/* eslint-disable */
import { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, updateDoc, collection, addDoc, getDocs, query, orderBy } from "firebase/firestore";


// ─── FIREBASE CONFIG ──────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyAU3Q2_2GWxi-xaoMhPyQVp4t86T1uHhRI",
  authDomain: "betguru-ba51c.firebaseapp.com",
  projectId: "betguru-ba51c",
  storageBucket: "betguru-ba51c.firebasestorage.app",
  messagingSenderId: "347163176127",
  appId: "1:347163176127:web:ff2295e923a6e4aefd2a0a"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db   = getFirestore(firebaseApp);
const VAPID_KEY = "BINp4ON8DvATiFAqRBWjjaH7CBVqWqbF29QZnE-ZSMvuPBm0CiwR9cODu-DNyA2kKTiQ6Jl_0OOveLzadbw4saQ";

// ─── PAYSTACK CONFIG ──────────────────────────────────────────────────────────
const PAYSTACK_PUBLIC_KEY = "pk_live_0eddaec4397c35d3b4a6f1f5cf6e1df91a57528a";

// ─── TELEGRAM CONFIG ──────────────────────────────────────────────────────────
const TELEGRAM_BOT_TOKEN = "8651476130:AAH0uEP2fd0qIuHOV-4PPn7ER4NnraN6lDM";
const TELEGRAM_CHANNEL   = "@betguru009";

async function sendTelegramMessage(message) {
  try {
    // Use URL params method to avoid CORS issues
    const params = new URLSearchParams({
      chat_id: TELEGRAM_CHANNEL,
      text: message,
      parse_mode: "HTML",
      disable_web_page_preview: "false",
    });
    const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage?${params.toString()}`;
    const res = await fetch(url, { method: "GET" });
    const data = await res.json();
    if (data.ok) {
      console.log("✅ Telegram message sent!");
    } else {
      console.log("❌ Telegram error:", data.description);
      alert("Telegram error: " + data.description);
    }
    return data;
  } catch(e) {
    console.log("Telegram send error:", e);
  }
}

// ─── GOOGLE ANALYTICS ────────────────────────────────────────────────────────
// ─── GOOGLE ANALYTICS ────────────────────────────────────────────────────────
if (typeof window !== "undefined") {
  const gaScript = document.createElement("script");
  gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-ZTMWDCN02D";
  gaScript.async = true;
  document.head.appendChild(gaScript);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){ window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", "G-ZTMWDCN02D", { page_title: "BetGuru", send_page_view: true });
}

// ─── FACEBOOK PIXEL ───────────────────────────────────────────────────────────
if (typeof window !== "undefined") {
  !function(f,b,e,v,n,t,s){
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  }(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", "793140073477448");
  window.fbq("track", "PageView");
}

// ─── GLOBAL STYLES ────────────────────────────────────────────────────────────
// ─── SEO META TAGS ───────────────────────────────────────────────────────────
if (typeof document !== "undefined") {
  document.title = "BetGuru — Premium Football Predictions | Nigeria, Ghana, Kenya";
  const setMeta = (name, content, prop=false) => {
    let el = document.querySelector(prop ? `meta[property="${name}"]` : `meta[name="${name}"]`);
    if (!el) { el = document.createElement("meta"); prop ? el.setAttribute("property",name) : el.setAttribute("name",name); document.head.appendChild(el); }
    el.setAttribute("content", content);
  };
  setMeta("description", "BetGuru gives you expert football predictions with 92%+ accuracy. Daily picks for EPL, UCL, NPFL, GPL and more. Subscribe for premium booking codes.");
  setMeta("keywords", "football predictions Nigeria, betting tips Ghana, soccer predictions Kenya, EPL predictions, NPFL tips, booking codes Bet9ja, SportyBet codes");
  setMeta("robots", "index, follow");
  setMeta("og:title", "BetGuru — Premium Football Predictions", true);
  setMeta("og:description", "Expert football tips with 92%+ accuracy. Daily picks for Nigeria, Ghana & Kenya.", true);
  setMeta("og:url", "https://betguru.com.ng", true);
  setMeta("og:type", "website", true);
  setMeta("twitter:card", "summary_large_image");
  setMeta("twitter:title", "BetGuru — Premium Football Predictions");
}

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800;900&family=DM+Sans:wght@400;500;600;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #f0f2f5;
    --surface: #ffffff;
    --card: #ffffff;
    --card2: #f8f9fc;
    --border: #e0e4ee;
    --border2: #d0d5e8;
    --lime: #2d8c00;
    --lime2: #237000;
    --green: #00a651;
    --gold: #e67e00;
    --red: #e53935;
    --blue: #1a73e8;
    --sporty: #ff6b00;
    --text: #111318;
    --muted: #8a94a8;
    --muted2: #555f7a;
    --dark-bg: #05060a;
    --dark-surface: #0c0e16;
    --dark-border: #1c2035;
    --dark-text: #eef0ff;
    --dark-muted: #4a5070;
    --head: 'Barlow Condensed', sans-serif;
    --body: 'DM Sans', sans-serif;
  }
  html, body { background: var(--bg); color: #111318; font-family: var(--body); min-height: 100vh; }
  button { font-family: var(--body); cursor: pointer; }
  input, textarea, select { font-family: var(--body); }
  ::-webkit-scrollbar { width: 3px; height: 3px; }
  ::-webkit-scrollbar-thumb { background: #2a2d45; border-radius: 4px; }

  @keyframes fadeUp  { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
  @keyframes fadeIn  { from { opacity:0; } to { opacity:1; } }
  @keyframes ticker  { 0% { transform:translateX(100vw); } 100% { transform:translateX(-100%); } }
  @keyframes pulse-btn { 0%,100% { box-shadow: 0 4px 14px rgba(245,160,0,0.4); } 50% { box-shadow: 0 4px 28px rgba(245,160,0,0.8); } }
  @keyframes glow    { 0%,100% { box-shadow:0 0 16px rgba(200,255,0,0.15); } 50% { box-shadow:0 0 36px rgba(200,255,0,0.4); } }
  @keyframes spin    { to { transform:rotate(360deg); } }
  @keyframes float   { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-8px); } }

  .fade-up  { animation: fadeUp  0.4s ease both; }
  .fade-in  { animation: fadeIn  0.3s ease both; }
  .glow-gold { animation: glow 3s ease-in-out infinite; }
  .float    { animation: float 4s ease-in-out infinite; }

  .btn-primary {
    background: #f5a000; color: #ffffff; border: none;
    padding: 12px 28px; border-radius: 10px; font-weight: 800;
    font-size: 14px; cursor: pointer; transition: all 0.2s;
    font-family: var(--body); letter-spacing: 0.3px;
    box-shadow: 0 4px 14px rgba(245,160,0,0.4);
  }
  .btn-primary:hover { background: #e09000; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(245,160,0,0.5); }
  .btn-primary:active { transform: translateY(0); }

  .card-base {
    background: #ffffff; border: 1px solid #e0e4ee;
    border-radius: 16px; transition: border-color 0.2s, transform 0.2s;
  }
  .card-base:hover { border-color: #d0d5e8; }

  .tag {
    display: inline-flex; align-items: center; gap: 4px;
    font-size: 10px; font-weight: 700; letter-spacing: 0.6px;
    padding: 3px 9px; border-radius: 20px; white-space: nowrap;
  }

  .blur-code { filter: blur(7px); user-select: none; pointer-events: none; }

  .code-box {
    background: #f8f9fc; border-radius: 12px;
    padding: 14px 20px; font-family: 'Courier New', monospace;
    font-size: 22px; font-weight: 900; letter-spacing: 3px; text-align: center;
  }

  .stripe-bg {
    background-image: repeating-linear-gradient(
      -45deg, transparent, transparent 10px,
      rgba(255,255,255,0.015) 10px, rgba(255,255,255,0.015) 20px
    );
  }

  .platform-bet9ja  { border-color: rgba(0,166,81,0.4)  !important; }
  .platform-sporty  { border-color: rgba(255,107,0,0.4) !important; }
  .platform-betway  { border-color: rgba(233,30,99,0.4) !important; }
  .platform-1xbet   { border-color: rgba(68,136,255,0.4)!important; }
  .platform-betking { border-color: rgba(124,58,237,0.4)!important; }
  .platform-melbet  { border-color: rgba(255,61,61,0.4) !important; }

  @media (max-width: 768px) {
    .hide-mobile { display: none !important; }
    .grid-2      { grid-template-columns: 1fr !important; }
    .grid-3      { grid-template-columns: 1fr !important; }
    .grid-4      { grid-template-columns: 1fr 1fr !important; }
    .hero-text   { font-size: 32px !important; }
    .px-page     { padding-left: 14px !important; padding-right: 14px !important; }
    .hero-stat   { display: none !important; }
    .tag         { font-size: 11px !important; padding: 4px 10px !important; }
    .card-base   { border-radius: 12px !important; }
    .code-box    { font-size: 16px !important; letter-spacing: 2px !important; }
  }

  @media (max-width: 480px) {
    .hero-text   { font-size: 28px !important; }
    .px-page     { padding-left: 12px !important; padding-right: 12px !important; }
  }
  .hide-scrollbar::-webkit-scrollbar { display: none; }
  .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

  /* Mobile responsive fixes */
  @media (max-width: 768px) {
    .grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
    .grid-3 { grid-template-columns: repeat(2, 1fr) !important; }
    .testimonials-grid { grid-template-columns: 1fr !important; }
  }
  @media (max-width: 480px) {
    .grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
    .grid-3 { grid-template-columns: 1fr 1fr !important; }
  }

  .social-float {
    display: none;
    position: fixed;
    top: 72px;
    right: 10px;
    z-index: 500;
    flex-direction: column;
    gap: 8px;
  }
  @media (max-width: 768px) {
    .social-float { display: flex; }
  }

  .mobile-nav {
    display: none;
    position: fixed;
    bottom: 0; left: 0; right: 0;
    background: #b00000;
    border-top: 2px solid #f5a000;
    padding: 0;
    z-index: 200;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.2);
  }
  .mobile-nav-inner {
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    height: 60px;
  }
  .mobile-nav-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px 2px;
    transition: background 0.2s;
    border-top: 3px solid transparent;
  }
  .mobile-nav-btn.active {
    background: rgba(255,255,255,0.15);
    border-top: 3px solid #f5a000;
  }
  .mobile-nav-icon { font-size: 18px; line-height: 1; }
  .mobile-nav-label { font-size: 10px; font-weight: 700; color: #ffffff; letter-spacing: 0.3px; }
  .mobile-nav-btn.active .mobile-nav-label { color: #f5a000; }

  .mobile-bottom-pad { display: none; }

  @media (max-width: 768px) {
    .mobile-nav { display: block; }
    .mobile-bottom-pad { display: block; height: 68px; }
    main { padding-bottom: 80px !important; }
    .social-bar { margin-bottom: 60px; }
  }
`;

// ─── EXCHANGE RATE (live: 1 GHS = ₦128.39 as of Mar 10 2026) ────────────────
const GHS_RATE = 128.39;
const KES_RATE = 10.23; // 1 KES = ₦10.23 (approx Mar 2026)
const toGHS = (ngn) => `GH₵${(ngn / GHS_RATE).toFixed(0)}`;
const toKES = (ngn) => `KSh${(ngn * KES_RATE).toFixed(0)}`;

// ─── DEFAULT SITE SETTINGS ───────────────────────────────────────────────────
const DEFAULT_SETTINGS = {
  siteName:      "BetGuru",
  tagline:       "🇳🇬 Nigeria · 🇬🇭 Ghana · 🇰🇪 Kenya",
  accuracy:      "92",
  wonThisMonth:  "110",
  lostThisMonth: "10",
  tickerText:    "✅ Arsenal WON · BJ-4X9TK2 &nbsp;&nbsp;·&nbsp;&nbsp; ✅ Enyimba WON · SB-7MN3QR &nbsp;&nbsp;·&nbsp;&nbsp; 🔥 92% Accuracy this month &nbsp;&nbsp;·&nbsp;&nbsp; 🇳🇬 NPFL codes live now &nbsp;&nbsp;·&nbsp;&nbsp; 🇬🇭 GPL Derby code available on SportyBet &nbsp;&nbsp;·&nbsp;&nbsp; 📋 8 predictions posted today",
  heroTitle:     "TODAY'S PICKS",
  heroSubtitle:  "Updated every morning by 10AM WAT",
  subscribeMsg:  "Subscribe from ₦1,500/week to unlock all booking codes and analysis",
  whatsapp:      "",
  telegram:      "",
  twitter:       "",
  weeklyNGN:     "1500",
  monthlyNGN:    "4999",
  quarterlyNGN:  "11999",
  weeklyLabel:   "7 days",
  monthlyLabel:  "30 days",
  quarterlyLabel:"90 days",
  referralActive: true,
  telegramActive: true,
  referralReward: 500,
  referralRewardGHS: 3.90,
  referralRewardKES: 5115,
};

// ─── PLANS  (prices in NGN, GHS auto-calculated) ──────────────────────────────
const getPlans = (s) => {
  const w = parseInt(s.weeklyNGN||"1500");
  const m = parseInt(s.monthlyNGN||"4999");
  const q = parseInt(s.quarterlyNGN||"11999");
  return [
    {
      id: "weekly", name: "Weekly", ngnVal: w,
      period: s.weeklyLabel||"7 days", perDay: `₦${Math.round(w/7).toLocaleString()}/day`,
      color: "#b00000",
      features: ["All daily predictions", "Booking codes on screen", "NPFL, GPL & European leagues", "Cancel anytime"],
      cta: "Start Weekly",
    },
    {
      id: "monthly", name: "Monthly", ngnVal: m,
      period: s.monthlyLabel||"30 days", perDay: `₦${Math.round(m/30).toLocaleString()}/day`,
      color: "#f5a000", badge: "BEST VALUE", popular: true,
      features: ["Everything in Weekly", "Priority picks (6hrs early)", "Full match analysis unlocked", "Referral rewards program", "WhatsApp community access"],
      cta: "Get Monthly",
    },
    {
      id: "quarterly", name: "3 Months", ngnVal: q,
      period: s.quarterlyLabel||"90 days", perDay: `₦${Math.round(q/90).toLocaleString()}/day`,
      color: "#f5a000", badge: "SAVE 20%",
      features: ["Everything in Monthly", "1-on-1 analyst support", "Exclusive VIP Telegram group", "Monthly accuracy report"],
      cta: "Get 3 Months",
    },
  ];
};
const PLANS = getPlans(DEFAULT_SETTINGS);

// ─── PREDICTIONS DATA ─────────────────────────────────────────────────────────
const INITIAL_PREDICTIONS = []; // Always empty — admin controls all games via Firebase

const DEFAULT_RESULTS = [
  { m:"Man Utd vs Liverpool",    p:"Away Win",  r:"WON",  o:"2.40", d:"Mar 9",  l:"EPL" },
  { m:"Enyimba vs Kano Pillars", p:"Home Win",  r:"WON",  o:"1.90", d:"Mar 8",  l:"NPFL" },
  { m:"Kotoko vs Medeama",       p:"Over 2.5",  r:"LOST", o:"2.10", d:"Mar 8",  l:"GPL" },
  { m:"Barcelona vs Sevilla",    p:"Home Win",  r:"WON",  o:"1.75", d:"Mar 7",  l:"La Liga" },
  { m:"PSG vs Lyon",             p:"BTTS",      r:"WON",  o:"1.85", d:"Mar 6",  l:"Ligue 1" },
  { m:"Inter Milan vs Napoli",   p:"Home Win",  r:"WON",  o:"2.10", d:"Mar 5",  l:"Serie A" },
  { m:"Hearts vs Aduana Stars",  p:"Draw",      r:"WON",  o:"2.70", d:"Mar 4",  l:"GPL" },
  { m:"Arsenal vs Wolves",       p:"Home Win",  r:"WON",  o:"1.60", d:"Mar 3",  l:"EPL" },
  { m:"Rangers vs Sunshine",     p:"BTTS",      r:"WON",  o:"2.00", d:"Mar 2",  l:"NPFL" },
  { m:"Bayern vs Leipzig",       p:"Home Win",  r:"WON",  o:"1.80", d:"Mar 1",  l:"Bundesliga" },
  { m:"Enyimba vs Akwa Utd",     p:"Home Win",  r:"WON",  o:"2.00", d:"Feb 28", l:"NPFL" },
  { m:"Hearts vs Legon Cities",  p:"Home Win",  r:"WON",  o:"1.95", d:"Feb 27", l:"GPL" },
];

// ─── SMALL COMPONENTS ─────────────────────────────────────────────────────────

function Tag({ children, color = "#b00000", bg }) {
  return (
    <span className="tag" style={{ color, background: bg || `${color}18`, border:`1px solid ${color}30` }}>
      {children}
    </span>
  );
}

function ConfBar({ value }) {
  const color = value >= 85 ? "#00a651" : value >= 75 ? "#f5a000" : "#b00000";
  return (
    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
      <div style={{ flex:1, height:5, background:"#e0e4ee", borderRadius:4, overflow:"hidden" }}>
        <div style={{ width:`${value}%`, height:"100%", background:`linear-gradient(90deg,${color}88,${color})`, borderRadius:4 }} />
      </div>
      <span style={{ fontSize:13, fontWeight:800, color, minWidth:36 }}>{value}%</span>
    </div>
  );
}

function Spinner() {
  return <div style={{ width:20, height:20, border:"2px solid #e0e4ee", borderTop:"2px solid #b00000", borderRadius:"50%", animation:"spin 0.7s linear infinite", display:"inline-block" }} />;
}

function PlatformDot({ platform }) {
  const colors = { "Bet9ja":"#00a651","SportyBet":"#ff6b00","BetWay GH":"#e91e63","1xBet":"#1976d2","Melbet":"#e53935","BetKing":"#7c3aed","NairaBet":"#ff9800" };
  return <span style={{ display:"inline-block", width:8, height:8, borderRadius:"50%", background:colors[platform]||"#888", marginRight:5 }} />;
}

// ─── BOOKING CODE DISPLAY ────────────────────────────────────────────────────

function BookingCodes({ codes, isSubscribed, onUpgrade }) {
  const [copied, setCopied] = useState(null);

  const copy = (code, idx) => {
    navigator.clipboard?.writeText(code).catch(()=>{});
    setCopied(idx);
    setTimeout(() => setCopied(null), 2000);
  };

  if (!isSubscribed) {
    return (
      <div style={{ position:"relative", marginTop:14 }}>
        <div style={{ fontSize:13, fontWeight:700, color:"#555f7a", letterSpacing:"0.6px", marginBottom:8 }}>📋 BOOKING CODES</div>
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {codes.map((c, i) => (
            <div key={i} style={{ position:"relative" }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:10, padding:"10px 14px" }}>
                <PlatformDot platform={c.platform} />
                <span style={{ fontSize:12, fontWeight:700, color:"#555f7a", minWidth:72 }}>{c.platform}</span>
                <span className="blur-code" style={{ fontFamily:"monospace", fontSize:16, fontWeight:900, letterSpacing:2, color:"#f5a000", flex:1, textAlign:"center" }}>{c.code}</span>
              </div>
            </div>
          ))}
        </div>
        <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:8, background:"rgba(5,6,10,0.7)", borderRadius:10, backdropFilter:"blur(2px)" }}>
          <span style={{ fontSize:22 }}>🔒</span>
          <button onClick={onUpgrade} style={{ background:"#f5a000", color:"#fff", border:"none", borderRadius:8, padding:"10px 22px", fontSize:13, fontWeight:800, cursor:"pointer", boxShadow:"0 3px 10px rgba(245,160,0,0.4)" }}>🔓 Subscribe to Unlock</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ marginTop:14 }}>
      <div style={{ fontSize:13, fontWeight:700, color:"#555f7a", letterSpacing:"0.6px", marginBottom:8 }}>📋 BOOKING CODES — Enter on your preferred platform</div>
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {codes.map((c, i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, background:"rgba(200,255,0,0.04)", border:`1px solid ${c.color}33`, borderRadius:10, padding:"10px 14px" }}>
            <PlatformDot platform={c.platform} />
            <span style={{ fontSize:12, fontWeight:700, color:c.color, minWidth:80 }}>{c.platform}</span>
            <span style={{ fontFamily:"monospace", fontSize:17, fontWeight:900, letterSpacing:2, color:"#f5a000", flex:1 }}>{c.code}</span>
            <button
              onClick={() => copy(c.code, i)}
              style={{ background: copied===i ? "rgba(0,166,81,0.1)" : "#f8f9fc", border:`1px solid ${copied===i ? "rgba(0,166,81,0.4)" : "#e0e4ee"}`, color: copied===i ? "#00a651" : "#555f7a", borderRadius:8, padding:"5px 14px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>
              {copied===i ? "✓ Copied!" : "Copy"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── PREDICTION CARD ─────────────────────────────────────────────────────────

function PredictionCard({ p, isSubscribed, onUpgrade }) {
  const [expanded, setExpanded] = useState(false);
  const locked = p.tier === "premium" && !isSubscribed;

  return (
    <div className="card-base fade-up" style={{ overflow:"hidden", borderColor: p.confidence >= 85 ? "#f5a000" : "#e0e4ee" }}>
      {/* League strip */}
      <div style={{ background:"linear-gradient(90deg,#b00000,#c00000)", borderBottom:"1px solid rgba(255,255,255,0.15)", padding:"10px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:15 }}>{p.flag}</span>
          <span style={{ fontSize:11, fontWeight:700, color:"#ffffff", letterSpacing:"0.5px" }}>{p.league}</span>
          {p.confidence >= 88 && <Tag color="#ffffff" bg="rgba(255,255,255,0.25)">🔥 TOP PICK</Tag>}
          <Tag color="#ffffff" bg={p.tier==="premium" ? "#f5a000" : "rgba(255,255,255,0.25)"}>{p.tier==="premium" ? "★ PREMIUM" : "✓ FREE"}</Tag>
        </div>
        <span style={{ fontSize:12, color:"#ffffff", fontWeight:600 }}>🕐 Today</span>
      </div>

      <div style={{ padding:"18px 18px 20px" }}>
        {/* Teams */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:17, fontWeight:800 }}>{p.home}</div>
            <div style={{ fontSize:13, color:"#888", marginTop:2 }}>Home</div>
          </div>
          <div style={{ textAlign:"center", padding:"6px 14px", background:"#f5f5f5", borderRadius:8, border:"1px solid #e0e4ee" }}>
            <div style={{ fontFamily:"var(--head)", fontSize:18, letterSpacing:1 }}>VS</div>
            <div style={{ fontSize:12, color:"#888", marginTop:1 }}>Odds {p.odds}</div>
          </div>
          <div style={{ flex:1, textAlign:"right" }}>
            <div style={{ fontSize:17, fontWeight:800 }}>{p.away}</div>
            <div style={{ fontSize:13, color:"#888", marginTop:2 }}>Away</div>
          </div>
        </div>

        {/* Prediction chip */}
        <div style={{ background: locked ? "#f5f5f5" : "#fff8ee", border:`1px solid ${locked ? "#e0e4ee" : "#f5a000"}`, borderRadius:12, padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
          <div>
            <div style={{ fontSize:12, fontWeight:700, color: locked ? "#aaa" : "#b00000", letterSpacing:"0.5px", marginBottom:5 }}>PREDICTION</div>
            <div style={{ fontSize:18, fontWeight:800, color: locked ? "#aaa" : "#111318" }}>
              {locked ? "••••••••••" : p.prediction}
            </div>
          </div>
          <div style={{ textAlign:"right" }}>
            <div style={{ fontSize:13, color:"#888", marginBottom:3 }}>Confidence</div>
            <div style={{ fontFamily:"var(--head)", fontSize:38, lineHeight:1, color: locked ? "#888888" : (p.confidence >= 85 ? "#00a651" : p.confidence >= 75 ? "#f5a000" : "#b00000") }}>
              {locked ? "??" : p.confidence}
            </div>
          </div>
        </div>

        {!locked && <ConfBar value={p.confidence} />}

        {/* Booking codes */}
        <BookingCodes codes={p.codes} isSubscribed={isSubscribed} onUpgrade={onUpgrade} />

        {/* Analysis toggle */}
        {!locked && (
          <div style={{ marginTop:12 }}>
            <button onClick={() => setExpanded(!expanded)} style={{ background:"transparent", border:"none", color:"#b00000", fontSize:13, fontWeight:700, padding:"4px 0", width:"100%", textAlign:"left", display:"flex", alignItems:"center", gap:6 }}>
              <span style={{ color:"#f5a000" }}>{expanded ? "▲" : "▼"}</span>
              {expanded ? "Hide" : "Show"} match analysis
            </button>
            {expanded && (
              <div className="fade-in" style={{ marginTop:8, background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:10, padding:"12px 14px", fontSize:13, color:"#aab", lineHeight:1.7 }}>
                {p.analysis}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── SPORTYBET SECTION ────────────────────────────────────────────────────────

function SportyBetSection({ predictions, isSubscribed, onUpgrade }) {
  const sportyPicks = predictions.filter(p => p.codes.some(c => c.platform === "SportyBet"));

  return (
    <div style={{ marginTop:48 }}>
      {/* Header */}
      <div style={{
        background:"linear-gradient(135deg,#fff3e0,#ffe8c0,#fff3e0)",
        border:"1px solid rgba(255,107,0,0.3)",
        borderRadius:20, padding:"28px 32px", marginBottom:24,
        display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:16,
      }}>
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
            <div style={{ width:38, height:38, background:"#ff6b00", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>⚽</div>
            <div style={{ fontFamily:"var(--head)", fontSize:36, letterSpacing:"2px", color:"#ff6b00" }}>SPORTYBET CODES</div>
          </div>
          <div style={{ fontSize:13, color:"#555f7a", maxWidth:520 }}>
            All predictions below have a dedicated SportyBet booking code — valid for Nigeria 🇳🇬, Ghana 🇬🇭 and Kenya 🇰🇪 platforms.
          </div>
        </div>
        <div style={{ display:"flex", gap:16 }}>
          <div style={{ textAlign:"center", background:"rgba(255,107,0,0.08)", border:"1px solid rgba(255,107,0,0.25)", borderRadius:14, padding:"14px 20px" }}>
            <div style={{ fontFamily:"var(--head)", fontSize:32, color:"#ff6b00" }}>{sportyPicks.length}</div>
            <div style={{ fontSize:11, color:"#555f7a" }}>Codes Today</div>
          </div>
          <div style={{ textAlign:"center", background:"rgba(200,255,0,0.06)", border:"1px solid rgba(200,255,0,0.2)", borderRadius:14, padding:"14px 20px" }}>
            <div style={{ fontFamily:"var(--head)", fontSize:32, color:"#f5a000" }}>92%</div>
            <div style={{ fontSize:11, color:"#555f7a" }}>Accuracy</div>
          </div>
        </div>
      </div>

      {/* SportyBet Cards */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(340px,1fr))", gap:14 }} className="grid-2">
        {sportyPicks.map(p => {
          const sportyCode = p.codes.find(c => c.platform === "SportyBet");
          const locked = p.tier === "premium" && !isSubscribed;
          return (
            <div key={p.id} style={{
              background:"#ffffff",
              border:`1px solid ${locked ? "rgba(255,107,0,0.15)" : "rgba(255,107,0,0.3)"}`,
              borderRadius:14, padding:"18px",
            }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                <div>
                  <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:6 }}>
                    <span style={{ fontSize:14 }}>{p.flag}</span>
                    <span style={{ fontSize:11, fontWeight:700, color:"#555f7a" }}>{p.league}</span>
                    <Tag color="#ff6b00">SportyBet</Tag>
                  </div>
                  <div style={{ fontSize:15, fontWeight:800 }}>{p.home} <span style={{ color:"#888888" }}>vs</span> {p.away}</div>
                </div>
                <div style={{ textAlign:"right", flexShrink:0 }}>
                  <div style={{ fontSize:12, color:"#888888" }}>Confidence</div>
                  <div style={{ fontFamily:"var(--head)", fontSize:30, color:"#ff6b00", lineHeight:1 }}>{locked ? "??" : p.confidence}%</div>
                </div>
              </div>

              {locked ? (
                <div style={{ textAlign:"center", padding:"14px", background:"rgba(0,0,0,0.3)", borderRadius:10, border:"1px dashed rgba(255,107,0,0.2)" }}>
                  <div style={{ fontSize:11, color:"#888888", marginBottom:8 }}>🔒 Subscribe to see SportyBet code</div>
                  <button onClick={onUpgrade} style={{ background:"#f5a000", color:"#fff", border:"none", borderRadius:8, padding:"9px 20px", fontSize:13, fontWeight:800, boxShadow:"0 3px 10px rgba(245,160,0,0.4)" }}>🔓 Unlock Now</button>
                </div>
              ) : (
                <div>
                  <div style={{ fontSize:12, fontWeight:700, color:"rgba(255,107,0,0.7)", letterSpacing:"0.6px", marginBottom:6 }}>
                    PREDICTION: <span style={{ color:"#111318" }}>{p.prediction}</span>
                  </div>
                  <SportyCodeBox code={sportyCode?.code} />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* How to use SportyBet */}
      <div style={{ marginTop:24, background:"#ffffff", border:"1px solid rgba(255,107,0,0.2)", borderRadius:16, padding:"22px 28px" }}>
        <div style={{ fontFamily:"var(--head)", fontSize:20, letterSpacing:"1px", color:"#ff6b00", marginBottom:14 }}>HOW TO USE A SPORTYBET BOOKING CODE</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:14 }}>
          {[
            { step:"1", icon:"📱", text:'Open SportyBet app or visit sportybet.com' },
            { step:"2", icon:"🔍", text:'Tap "My Bets" or "Booking" in the menu' },
            { step:"3", icon:"📋", text:'Enter the code and tap "Load Booking"' },
            { step:"4", icon:"💰", text:'Review the pre-loaded bet slip and stake your amount' },
          ].map((s,i) => (
            <div key={i} style={{ display:"flex", gap:12, alignItems:"flex-start" }}>
              <div style={{ width:28, height:28, borderRadius:"50%", background:"rgba(255,107,0,0.15)", border:"1px solid rgba(255,107,0,0.3)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:800, color:"#ff6b00", flexShrink:0 }}>{s.step}</div>
              <div style={{ fontSize:13, color:"#555f7a", lineHeight:1.55 }}><span style={{ fontSize:16, marginRight:4 }}>{s.icon}</span>{s.text}</div>
            </div>
          ))}
        </div>
        <div style={{ marginTop:14, fontSize:11, color:"#555f7a", padding:"10px 14px", background:"#0a0c14", borderRadius:8 }}>
          ⚠️ SportyBet booking codes are available on both <strong style={{color:"#111318"}}>SportyBet Nigeria</strong>, <strong style={{color:"#111318"}}>SportyBet Ghana</strong> and <strong style={{color:"#111318"}}>SportyBet Kenya</strong>. Make sure you're logged into the correct country platform.
        </div>
      </div>
    </div>
  );
}

function SportyCodeBox({ code }) {
  const [copied, setCopied] = useState(false);
  const doCopy = () => {
    navigator.clipboard?.writeText(code).catch(()=>{});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div style={{ display:"flex", alignItems:"center", gap:10, background:"rgba(255,107,0,0.06)", border:"1px solid rgba(255,107,0,0.3)", borderRadius:10, padding:"10px 14px" }}>
      <span style={{ fontFamily:"monospace", fontSize:20, fontWeight:900, letterSpacing:3, color:"#ff6b00", flex:1 }}>{code}</span>
      <button onClick={doCopy} style={{ background: copied ? "rgba(0,166,81,0.1)" : "#f8f9fc", border:`1px solid ${copied ? "rgba(0,166,81,0.4)" : "#e0e4ee"}`, color: copied ? "#00a651" : "#555f7a", borderRadius:8, padding:"5px 14px", fontSize:11, fontWeight:800 }}>
        {copied ? "✓ Copied!" : "Copy"}
      </button>
    </div>
  );
}

// ─── SUBSCRIBE MODAL ─────────────────────────────────────────────────────────

function SubscribeModal({ onClose, onSuccess, currency: initialCurrency, plans: plansProp }) {
  const PLANS = plansProp || getPlans(DEFAULT_SETTINGS);
  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ name:"", phone:"", email:"" });
  const [loading, setLoading] = useState(false);
  const [modalCurrency, setModalCurrency] = useState(initialCurrency || "NGN");
  const [country, setCountry] = useState(initialCurrency === "GHS" ? "GH" : initialCurrency === "KES" ? "KE" : "NG");

  const selectCountry = (c) => {
    setCountry(c);
    setModalCurrency(c === "NG" ? "NGN" : c === "GH" ? "GHS" : "KES");
  };

  const handlePay = async () => {
    if (!form.email || !form.phone) return;
    setLoading(true);

    const ref = "BG-" + Date.now();
    const subEnd = new Date();
    subEnd.setDate(subEnd.getDate() + (plan?.id === "weekly" ? 7 : plan?.id === "monthly" ? 30 : 90));

    try {
      // Step 1: Save user to Firebase BEFORE payment
      let userCred;
      try {
        userCred = await createUserWithEmailAndPassword(auth, form.email, form.phone + "@betguru.app");
      } catch(e) {
        userCred = await signInWithEmailAndPassword(auth, form.email, form.phone + "@betguru.app");
      }

      // Save to Firestore as pending (not active yet)
      await setDoc(doc(db, "users", userCred.user.uid), {
        name: form.email.split("@")[0], phone: form.phone, email: form.email,
        country, plan: plan?.id, planName: plan?.name,
        amount: plan?.ngnVal, currency: modalCurrency,
        paystackRef: ref,
        subscribedAt: new Date().toISOString(),
        expiresAt: subEnd.toISOString(),
        active: false,
        pending: true,
      });

      // Step 2: Save to localStorage as backup
      localStorage.setItem("bg_pending", JSON.stringify({
        email: form.email, phone: form.phone,
        country, plan: plan?.id, planName: plan?.name,
        ngnVal: plan?.ngnVal, currency: modalCurrency,
        uid: userCred.user.uid, ref,
      }));

      // Step 3: Redirect to Paystack
      const paystackUrl = new URL("https://paystack.shop/pay/n1q8db268-");
      paystackUrl.searchParams.set("email", form.email);
      paystackUrl.searchParams.set("amount", modalCurrency === "NGN" ? plan.ngnVal : Math.round(plan.ngnVal / 128.39));
      paystackUrl.searchParams.set("reference", ref);

      window.location.href = paystackUrl.toString();

    } catch(e) {
      setLoading(false);
      alert("Error: " + e.message);
    }
  };

  const plan = PLANS.find(p => p.id === selected);
  const price = plan ? (modalCurrency === "NGN" ? `₦${plan.ngnVal.toLocaleString()}` : modalCurrency === "GHS" ? toGHS(plan.ngnVal) : toKES(plan.ngnVal)) : "";
  const currency = modalCurrency;

  return (
    <div className="fade-in" style={{ position:"fixed", inset:0, background:"rgba(5,6,10,0.92)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16, backdropFilter:"blur(8px)" }}>
      <div style={{ background:"#ffffff", border:"1px solid #d0d5e8", borderRadius:20, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto", position:"relative" }}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:"50%", width:32, height:32, color:"#555f7a", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center" }}>✕</button>

        {step === 1 && (
          <div style={{ padding:28 }}>
            <div style={{ fontFamily:"var(--head)", fontSize:32, letterSpacing:"1px", marginBottom:6 }}>CHOOSE YOUR <span style={{ color:"#f5a000" }}>PLAN</span></div>
            <div style={{ fontSize:12, color:"#555f7a", marginBottom:16 }}>All plans unlock every prediction + booking code instantly.</div>

            {/* ── COUNTRY SELECTOR ── */}
            <div style={{ marginBottom:20 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#555f7a", letterSpacing:"0.6px", marginBottom:10 }}>SELECT YOUR COUNTRY</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
                <button onClick={() => selectCountry("NG")} style={{
                  padding:"14px 16px", borderRadius:14, cursor:"pointer", transition:"all 0.2s",
                  background: country==="NG" ? "rgba(176,0,0,0.05)" : "#f8f9fc",
                  border: `2px solid ${country==="NG" ? "#b00000" : "#e0e4ee"}`,
                  display:"flex", alignItems:"center", gap:12,
                }}>
                  <span style={{ fontSize:28 }}>🇳🇬</span>
                  <div style={{ textAlign:"left" }}>
                    <div style={{ fontSize:14, fontWeight:800, color: country==="NG" ? "#b00000" : "#111318" }}>Nigeria</div>
                    <div style={{ fontSize:11, color:"#555f7a" }}>Pay in Naira (₦)</div>
                  </div>
                  {country==="NG" && <span style={{ marginLeft:"auto", color:"#f5a000", fontSize:16 }}>✓</span>}
                </button>
                <button onClick={() => selectCountry("GH")} style={{
                  padding:"14px 16px", borderRadius:14, cursor:"pointer", transition:"all 0.2s",
                  background: country==="GH" ? "rgba(176,0,0,0.05)" : "#f8f9fc",
                  border: `2px solid ${country==="GH" ? "#b00000" : "#e0e4ee"}`,
                  display:"flex", alignItems:"center", gap:12,
                }}>
                  <span style={{ fontSize:28 }}>🇬🇭</span>
                  <div style={{ textAlign:"left" }}>
                    <div style={{ fontSize:14, fontWeight:800, color: country==="GH" ? "#b00000" : "#111318" }}>Ghana</div>
                    <div style={{ fontSize:11, color:"#555f7a" }}>Pay in Cedis (GH₵)</div>
                  </div>
                  {country==="GH" && <span style={{ marginLeft:"auto", color:"#f5a000", fontSize:16 }}>✓</span>}
                </button>
                <button onClick={() => selectCountry("KE")} style={{
                  padding:"14px 16px", borderRadius:14, cursor:"pointer", transition:"all 0.2s",
                  background: country==="KE" ? "rgba(176,0,0,0.05)" : "#f8f9fc",
                  border: `2px solid ${country==="KE" ? "#b00000" : "#e0e4ee"}`,
                  display:"flex", alignItems:"center", gap:12,
                }}>
                  <span style={{ fontSize:28 }}>🇰🇪</span>
                  <div style={{ textAlign:"left" }}>
                    <div style={{ fontSize:14, fontWeight:800, color: country==="KE" ? "#b00000" : "#111318" }}>Kenya</div>
                    <div style={{ fontSize:11, color:"#555f7a" }}>Pay in Shillings (KSh)</div>
                  </div>
                  {country==="KE" && <span style={{ marginLeft:"auto", color:"#f5a000", fontSize:16 }}>✓</span>}
                </button>
              </div>
              {(country==="GH" || country==="KE") && (
                <div style={{ fontSize:11, color:"#888", background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:8, padding:"6px 12px", marginTop:8 }}>
                  💱 {country==="GH" ? "Exchange rate: 1 GH₵ = ₦128.39" : "Exchange rate: 1 KSh = ₦0.098"} · Updated March 2026
                </div>
              )}
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {PLANS.map(plan => (
                <div key={plan.id} onClick={() => setSelected(plan.id)} style={{
                  border:`2px solid ${selected===plan.id ? plan.color : "#e0e4ee"}`,
                  borderRadius:14, padding:"16px 18px", cursor:"pointer",
                  background: selected===plan.id ? `${plan.color}08` : "#f5f5f5",
                  transition:"all 0.2s", position:"relative",
                }}>
                  {plan.badge && <div style={{ position:"absolute", top:-1, right:16, background:plan.color, color:"#000", fontSize:12, fontWeight:800, padding:"3px 10px", borderRadius:"0 0 8px 8px", letterSpacing:"0.6px" }}>{plan.badge}</div>}
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div>
                      <div style={{ fontSize:15, fontWeight:800 }}>{plan.name}</div>
                      <div style={{ fontSize:11, color:"#555f7a", marginTop:2 }}>{plan.period} · {plan.perDay}</div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontFamily:"var(--head)", fontSize:28, color:plan.color, lineHeight:1 }}>
                        {currency === "NGN" ? `₦${plan.ngnVal.toLocaleString()}` : currency === "GHS" ? toGHS(plan.ngnVal) : toKES(plan.ngnVal)}
                      </div>
                      {currency === "NGN" && <div style={{ fontSize:12, color:"#888888", marginTop:2 }}>{toGHS(plan.ngnVal)} · {toKES(plan.ngnVal)} equivalent</div>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={() => selected && setStep(2)} className="btn-primary" style={{ width:"100%", marginTop:20, opacity:selected?1:0.4, fontSize:15 }}>Continue →</button>
          </div>
        )}

        {step === 2 && (
          <div style={{ padding:28 }}>
            <button onClick={() => setStep(1)} style={{ background:"none", border:"none", color:"#555f7a", fontSize:13, marginBottom:16, padding:0, cursor:"pointer" }}>← Back</button>
            <div style={{ fontFamily:"var(--head)", fontSize:32, letterSpacing:"1px", marginBottom:16 }}>YOUR <span style={{ color:"#f5a000" }}>DETAILS</span></div>

            {/* Country & amount reminder */}
            <div style={{ display:"flex", alignItems:"center", gap:10, background: country==="NG"?"rgba(200,255,0,0.06)":"rgba(255,184,0,0.06)", border:`1px solid ${country==="NG"?"rgba(200,255,0,0.2)":"rgba(255,184,0,0.2)"}`, borderRadius:10, padding:"10px 14px", marginBottom:16 }}>
              <span style={{ fontSize:22 }}>{country==="NG"?"🇳🇬":country==="GH"?"🇬🇭":"🇰🇪"}</span>
              <div>
                <div style={{ fontSize:12, fontWeight:700, color: "#b00000" }}>
                  {country==="NG"?"Nigeria — Paying in Naira (₦)":country==="GH"?"Ghana — Paying in Cedis (GH₵)":"Kenya — Paying in Shillings (KSh)"}
                </div>
                <div style={{ fontSize:11, color:"#555f7a" }}>
                  Plan: <strong style={{color:"#111318"}}>{plan?.name}</strong> · Amount: <strong style={{color:"#111318"}}>{price}</strong>
                </div>
              </div>
              <button onClick={() => setStep(1)} style={{ marginLeft:"auto", background:"none", border:"1px solid #e0e4ee", borderRadius:8, color:"#555f7a", fontSize:11, padding:"4px 10px", cursor:"pointer" }}>Change</button>
            </div>

            <div style={{ background:"#fff8ee", border:"1px solid #f5a000", borderRadius:12, padding:"14px 16px", marginBottom:16 }}>
              <div style={{ fontSize:13, color:"#b00000", fontWeight:700, marginBottom:6 }}>🔑 Your Login Details</div>
              <div style={{ fontSize:12, color:"#666", marginBottom:14 }}>Use these to log back in anytime after subscribing</div>
              <div style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, fontWeight:700, color:"#555", display:"block", marginBottom:5 }}>EMAIL ADDRESS</label>
                <input type="email" placeholder="you@email.com" value={form.email} onChange={e => setForm({...form, email:e.target.value})}
                  style={{ width:"100%", background:"#ffffff", border:"1px solid #d0d5e8", borderRadius:10, padding:"12px 14px", color:"#111318", fontSize:14, outline:"none" }} />
              </div>
              <div>
                <label style={{ fontSize:11, fontWeight:700, color:"#555", display:"block", marginBottom:5 }}>PHONE NUMBER (used as password)</label>
                <input type="tel" placeholder={country==="NG"?"+234 80xxxxxxxx":country==="GH"?"+233 24xxxxxxx":"+254 7xxxxxxxx"} value={form.phone} onChange={e => setForm({...form, phone:e.target.value})}
                  style={{ width:"100%", background:"#ffffff", border:"1px solid #d0d5e8", borderRadius:10, padding:"12px 14px", color:"#111318", fontSize:14, outline:"none" }} />
                <div style={{ fontSize:11, color:"#888", marginTop:4 }}>💡 You'll use your email + phone to log in next time</div>
              </div>
            </div>
            <div style={{ background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:12, padding:"12px 16px", marginBottom:16 }}>
              <div style={{ fontSize:12, color:"#666" }}>✅ Your name and payment details will be collected securely by <strong>Paystack</strong> on the next page</div>
            </div>

            {/* Country-specific payment methods */}
            <div style={{ background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:12, padding:"16px 18px", marginBottom:20 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"#555f7a", marginBottom:12 }}>
                PAYMENT OPTIONS — {country==="NG"?"🇳🇬 Nigeria":country==="GH"?"🇬🇭 Ghana":"🇰🇪 Kenya"}
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                {(country==="NG" ? [
                  { icon:"💳", label:"Card / Bank Transfer", sub:"via Paystack" },
                  { icon:"💰", label:"Airtel Money", sub:"Nigeria" },
                  { icon:"📞", label:"USSD Banking", sub:"*737# *919# *770#" },
                  { icon:"🏦", label:"Direct Bank Transfer", sub:"GTB, Access, Zenith" },
                ] : [
                  { icon:"💳", label:"Card / Bank Transfer", sub:"via Paystack Ghana" },
                  { icon:"📱", label:"MTN Mobile Money", sub:"Ghana" },
                  { icon:"📲", label:"Vodafone Cash", sub:"Ghana" },
                  { icon:"📡", label:"AirtelTigo Money", sub:"Ghana" },
                ]).map((pm,i) => (
                  <div key={i} style={{ background:i===0?"#fff8ee":"#f5f5f5", border:`1px solid ${i===0?"#f5a000":"#e0e4ee"}`, borderRadius:10, padding:"10px 12px", display:"flex", gap:8, alignItems:"center" }}>
                    <span style={{ fontSize:18 }}>{pm.icon}</span>
                    <div>
                      <div style={{ fontSize:11, fontWeight:700 }}>{pm.label}</div>
                      <div style={{ fontSize:12, color:"#888888" }}>{pm.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button onClick={handlePay} className="btn-primary" style={{ width:"100%", fontSize:15, display:"flex", alignItems:"center", justifyContent:"center", gap:10 }} disabled={loading}>
              {loading ? <><Spinner /> Processing...</> : `💳 Pay ${price} with Paystack →`}
            </button>
            <div style={{ fontSize:11, color:"#888888", textAlign:"center", marginTop:10 }}>🔒 Secure payment · Instant access after confirmation</div>
          </div>
        )}

        {step === 3 && (
          <div style={{ padding:40, textAlign:"center" }} className="fade-up">
            <div className="float" style={{ fontSize:64, marginBottom:16 }}>🎉</div>
            <div style={{ fontFamily:"var(--head)", fontSize:36, color:"#f5a000", letterSpacing:"1px", marginBottom:8 }}>YOU'RE IN!</div>
            <div style={{ fontSize:14, color:"#555f7a", marginBottom:24, lineHeight:1.6 }}>Welcome to BetGuru. All predictions and booking codes are now unlocked.</div>
            <button onClick={() => { onSuccess(); onClose(); }} className="btn-primary" style={{ fontSize:15, padding:"13px 36px" }}>View Today's Codes →</button>
          </div>
        )}
      </div>
    </div>
  );
}


// ─── ADMIN PANEL ──────────────────────────────────────────────────────────────

const A_LEAGUES = ["EPL","UCL","NPFL","GPL","La Liga","Serie A","Bundesliga","Ligue 1"];
const A_FLAGS   = { EPL:"🏴󠁧󠁢󠁥󠁮󠁧󠁿", UCL:"⭐", NPFL:"🇳🇬", GPL:"🇬🇭", "La Liga":"🇪🇸", "Serie A":"🇮🇹", Bundesliga:"🇩🇪", "Ligue 1":"🇫🇷" };
const A_PLATS   = ["Bet9ja","SportyBet","BetWay GH","1xBet","Melbet","BetKing","NairaBet"];
const A_PCOLS   = { "Bet9ja":"#00a651","SportyBet":"#ff6b00","BetWay GH":"#e91e63","1xBet":"#1976d2","Melbet":"#e53935","BetKing":"#7c3aed","NairaBet":"#ff9800" };
const PKG_META  = [
  { key:"free",    label:"Free Odds",     emoji:"🎁", color:"#00a651", desc:"Visible to ALL visitors — no subscription needed", access:"FREE" },
  { key:"two",     label:"2 Odds",        emoji:"2️⃣", color:"#4488ff", desc:"2 carefully selected low-risk games",              access:"PAID" },
  { key:"five",    label:"5 Odds",        emoji:"5️⃣", color:"#ffb800", desc:"5 combined games for bigger returns",               access:"PAID" },
  { key:"ten",     label:"10 Odds",       emoji:"🔟", color:"#ff6b00", desc:"High-risk high-reward accumulator",                 access:"PAID" },
  { key:"bigband", label:"Big Bang Odds", emoji:"💥", color:"#ff4757", desc:"Massive accumulator — 20+ odds guaranteed",         access:"PAID" },
];
const BLANK_PRED = { league:"EPL", home:"", away:"", prediction:"", analysis:"", odds:"", confidence:78, tier:"premium", codes:[{ platform:"Bet9ja", code:"" },{ platform:"SportyBet", code:"" }] };
const BLANK_GAME = { home:"", away:"", tip:"", odds:"", league:"EPL 🏴🏴󠁧󠁢󠁥󠁮󠁧󠁿", date:"", time:"" };

// ─── SUBSCRIBERS PAGE ────────────────────────────────────────────────────────
function SubscribersPage({ db }) {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const loadSubscribers = async () => {
      try {
        const snap = await getDocs(collection(db, "users"));
        const users = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        // Only show users who completed payment (not pending)
        const paidUsers = users.filter(u => u.pending !== true || u.active === true);
        paidUsers.sort((a,b) => new Date(b.subscribedAt||0) - new Date(a.subscribedAt||0));
        setSubscribers(paidUsers);
      } catch(e) {
        console.log("Load subscribers error:", e);
      }
      setLoading(false);
    };
    loadSubscribers();
  }, []);

  const now = new Date();
  const active = subscribers.filter(s => (s.active || new Date(s.expiresAt) > now) && s.pending !== true);
  const expired = subscribers.filter(s => (!s.active && new Date(s.expiresAt) <= now) && s.pending !== true);
  const totalRevenue = subscribers.filter(s => s.active || new Date(s.expiresAt) > now).reduce((sum,s) => sum + (s.amount||0), 0);

  const filtered = subscribers.filter(s => {
    const matchFilter = filter === "all" ? true : filter === "active" ? (s.active && new Date(s.expiresAt) > now) : (!s.active || new Date(s.expiresAt) <= now);
    const matchSearch = !search || (s.email||"").toLowerCase().includes(search.toLowerCase()) || (s.phone||"").includes(search) || (s.name||"").toLowerCase().includes(search.toLowerCase());
    return matchFilter && matchSearch;
  });

  const getDaysLeft = (expiresAt) => {
    const days = Math.ceil((new Date(expiresAt) - now) / (1000*60*60*24));
    return days;
  };

  return (
    <div className="fade-up">
      <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>SUBSCRIBERS</div>
      <div style={{fontSize:13,color:"#667",marginBottom:24}}>All users who have subscribed to BetGuru.</div>

      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:24}}>
        {[
          {icon:"👥", label:"Total Subscribers", val:subscribers.length,      color:"#b00000", bg:"#fff0f0"},
          {icon:"✅", label:"Active",             val:active.length,           color:"#00a651", bg:"#edfff4"},
          {icon:"❌", label:"Expired",            val:expired.length,          color:"#e53935", bg:"#fff0f0"},
          {icon:"💰", label:"Total Revenue",      val:"₦"+totalRevenue.toLocaleString(), color:"#f5a000", bg:"#fff8ee"},
        ].map((s,i)=>(
          <div key={i} style={{background:s.bg,border:`1px solid ${s.color}33`,borderRadius:14,padding:"18px",textAlign:"center"}}>
            <div style={{fontSize:24,marginBottom:6}}>{s.icon}</div>
            <div style={{fontFamily:"var(--head)",fontSize:28,color:s.color,lineHeight:1}}>{s.val}</div>
            <div style={{fontSize:11,color:"#667",marginTop:4}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Search and filter */}
      <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by email, phone or name..."
          style={{flex:1,minWidth:200,background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 14px",fontSize:13,outline:"none"}} />
        {["all","active","expired"].map(f=>(
          <button key={f} onClick={()=>setFilter(f)}
            style={{padding:"10px 18px",borderRadius:10,border:"none",cursor:"pointer",fontWeight:700,fontSize:13,background:filter===f?"#b00000":"#f0f2f5",color:filter===f?"#fff":"#555"}}>
            {f.charAt(0).toUpperCase()+f.slice(1)}
          </button>
        ))}
      </div>

      {/* Subscribers list */}
      <div style={{background:"#fff",borderRadius:16,overflow:"hidden",border:"1px solid #e0e4ee",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
        <div style={{padding:"14px 24px",borderBottom:"1px solid #e0e4ee",background:"linear-gradient(135deg,#8b0000,#c00000)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontFamily:"var(--head)",fontSize:20,color:"#fff",letterSpacing:"1px"}}>👥 ALL SUBSCRIBERS ({filtered.length})</div>
        </div>

        {loading ? (
          <div style={{padding:32,textAlign:"center",color:"#667"}}>Loading subscribers...</div>
        ) : filtered.length === 0 ? (
          <div style={{padding:32,textAlign:"center",color:"#667"}}>
            <div style={{fontSize:40,marginBottom:12}}>👥</div>
            <div style={{fontSize:15,fontWeight:700}}>No subscribers yet</div>
            <div style={{fontSize:13,marginTop:4}}>Share your site to get your first subscriber!</div>
          </div>
        ) : filtered.map((s,i) => {
          const isActive = s.active && new Date(s.expiresAt) > now;
          const daysLeft = getDaysLeft(s.expiresAt);
          return (
            <div key={s.id} style={{padding:"16px 24px",borderBottom:i<filtered.length-1?"1px solid #f0f2f5":"none",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
              <div style={{flex:1,minWidth:200}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
                  <div style={{width:36,height:36,borderRadius:"50%",background:isActive?"#edfff4":"#fff0f0",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontWeight:800,color:isActive?"#00a651":"#e53935",flexShrink:0}}>
                    {(s.email||"U")[0].toUpperCase()}
                  </div>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{s.email}</div>
                    <div style={{fontSize:12,color:"#888"}}>{s.phone} · {s.country==="NG"?"🇳🇬 Nigeria":s.country==="GH"?"🇬🇭 Ghana":"🇰🇪 Kenya"}</div>
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:12,color:"#888"}}>Plan</div>
                  <div style={{fontSize:13,fontWeight:700,color:"#111",textTransform:"capitalize"}}>{s.planName||s.plan}</div>
                </div>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:12,color:"#888"}}>Amount</div>
                  <div style={{fontSize:13,fontWeight:700,color:"#00a651"}}>₦{(s.amount||0).toLocaleString()}</div>
                </div>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:12,color:"#888"}}>Subscribed</div>
                  <div style={{fontSize:12,color:"#555"}}>{s.subscribedAt ? new Date(s.subscribedAt).toLocaleDateString("en-NG",{day:"numeric",month:"short",year:"numeric"}) : "—"}</div>
                </div>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:12,color:"#888"}}>Expires</div>
                  <div style={{fontSize:12,color: daysLeft<=2?"#e53935":daysLeft<=7?"#f5a000":"#555"}}>
                    {s.expiresAt ? new Date(s.expiresAt).toLocaleDateString("en-NG",{day:"numeric",month:"short",year:"numeric"}) : "—"}
                  </div>
                </div>
                <span style={{
                  background:isActive?"#edfff4":"#fff0f0",
                  color:isActive?"#00a651":"#e53935",
                  border:`1px solid ${isActive?"#00a651":"#e53935"}`,
                  borderRadius:8,padding:"4px 12px",fontSize:12,fontWeight:800,whiteSpace:"nowrap"
                }}>
                  {isActive ? `✅ ACTIVE · ${daysLeft}d left` : "❌ EXPIRED"}
                </span>
                <button onClick={async () => {
                  if(!window.confirm(`Remove ${s.email} from subscribers?`)) return;
                  try {
                    const { deleteDoc } = await import("firebase/firestore");
                    await deleteDoc(doc(db, "users", s.id));
                    setSubscribers(prev => prev.filter(u => u.id !== s.id));
                  } catch(e) { alert("Error: " + e.message); }
                }} style={{background:"#fff0f0",border:"1px solid #ffcccc",color:"#e53935",borderRadius:8,padding:"5px 10px",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                  🗑 Remove
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── FORM INPUT COMPONENTS (defined outside to prevent re-render lag) ────────
function FI({label, value, onChange, placeholder, mono=false}) {
  return (
    <div>
      {label && <label style={{fontSize:11,fontWeight:700,color:"#667",letterSpacing:"0.5px",display:"block",marginBottom:5}}>{label}</label>}
      <input value={value} onChange={onChange} placeholder={placeholder}
        style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,fontFamily:mono?"monospace":undefined,outline:"none"}} />
    </div>
  );
}

function FS({label, value, onChange, options}) {
  return (
    <div>
      {label && <label style={{fontSize:11,fontWeight:700,color:"#667",letterSpacing:"0.5px",display:"block",marginBottom:5}}>{label}</label>}
      <select value={value} onChange={onChange} style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none"}}>
        {options.map(o=><option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

function AdminPanel({ predictions, setPredictions, oddsPackages, setOddsPackages, siteSettings, setSiteSettings, resultsData, setResultsData, referrals, setReferrals, withdrawals, setWithdrawals, onLogout }) {
  const [page, setPage]               = useState("overview");
  const [predForm, setPredForm]       = useState(BLANK_PRED);
  const [predSaved, setPredSaved]     = useState(false);
  const [editPredId, setEditPredId]   = useState(null);
  const [activePkg, setActivePkg]     = useState("free");
  const [gameForm, setGameForm]       = useState(BLANK_GAME);
  const [editGameId, setEditGameId]   = useState(null);
  const [editGameForm, setEditGameForm] = useState(BLANK_GAME);
  const [predTab, setPredTab]         = useState("free");

  const updateCode = (i,k,v) => { const c=[...predForm.codes]; c[i]={...c[i],[k]:v}; setPredForm({...predForm,codes:c}); };
  const addCode    = () => setPredForm({...predForm, codes:[...predForm.codes,{platform:"Bet9ja",code:""}]});
  const removeCode = (i) => setPredForm({...predForm, codes:predForm.codes.filter((_,idx)=>idx!==i)});

  const savePred = () => {
    if (!predForm.home||!predForm.away||!predForm.prediction) return;
    if (editPredId) {
      setPredictions(prev=>prev.map(p=>p.id===editPredId?{...predForm,id:editPredId,flag:A_FLAGS[predForm.league]||"⚽"}:p));
      setEditPredId(null);
    } else {
      const newPred = {...predForm,id:Date.now(),flag:A_FLAGS[predForm.league]||"⚽",date:new Date().toISOString().split("T")[0],result:null};
      setPredictions(prev=>[newPred,...prev]);
      // Save to Firebase for cross-device sync
      addDoc(collection(db, "predictions"), newPred).catch(e => console.log("Pred sync error:", e));
      // Send push notification to all users
      sendPushNotification(
        `🔥 New ${predForm.tier==="premium"?"Premium":"Free"} Pick Posted!`,
        `${A_FLAGS[predForm.league]||"⚽"} ${predForm.home} vs ${predForm.away} — ${predForm.prediction}`
      );

      // Auto-post to Telegram channel
      const tier = predForm.tier === "premium" ? "⭐ PREMIUM" : "🎁 FREE";
      const flag = A_FLAGS[predForm.league] || "⚽";
      const telegramMsg = [
        `🔥 <b>NEW BETGURU PICK!</b>`,
        ``,
        `${flag} <b>${predForm.home} vs ${predForm.away}</b>`,
        `🏆 League: ${predForm.league}`,
        `🎯 Prediction: <b>${predForm.prediction}</b>`,
        `📊 Odds: ${predForm.odds}`,
        `💯 Confidence: ${predForm.confidence}%`,
        `🏷 Type: ${tier}`,
        ``,
        predForm.tier === "free"
          ? `✅ <b>FREE PICK</b> — View on BetGuru now!`
          : `🔒 <b>PREMIUM PICK</b> — Subscribe to see booking codes!`,
        ``,
        `🌐 <a href="https://betguru-ashy.vercel.app">betguru-ashy.vercel.app</a>`,
        ``,
        `🇳🇬 Nigeria | 🇬🇭 Ghana | 🇰🇪 Kenya`,
      ].join("\n");

      if (siteSettings?.telegramActive !== false) {
        sendTelegramMessage(telegramMsg);
      }
    }
    setPredSaved(true); setTimeout(()=>setPredSaved(false),3000);
    setPredForm({...BLANK_PRED,codes:[{platform:"Bet9ja",code:""},{platform:"SportyBet",code:""}]});
  };
  const startEditPred = (p) => { setEditPredId(p.id); setPredForm({...p}); setPage("predictions"); };
  const deletePred    = (id) => { if(window.confirm("Delete this prediction?")) setPredictions(prev=>prev.filter(p=>p.id!==id)); };

  const addGame = () => {
    if (!gameForm.home||!gameForm.away||!gameForm.tip||!gameForm.odds) return;
    setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],games:[...prev[activePkg].games,{...gameForm,id:Date.now()}]}}));
    setGameForm(BLANK_GAME);
  };
  const removeGame     = (pk,gid) => { if(window.confirm("Remove this game?")) setOddsPackages(prev=>({...prev,[pk]:{...prev[pk],games:prev[pk].games.filter(g=>g.id!==gid)}})); };
  const startEditGame  = (g) => { setEditGameId(g.id); setEditGameForm({...g}); };
  const saveEditGame   = () => {
    setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],games:prev[activePkg].games.map(g=>g.id===editGameId?{...editGameForm,id:editGameId}:g)}}));
    setEditGameId(null);
  };

  const won      = predictions.filter(p=>p.result==="won").length;
  const lost     = predictions.filter(p=>p.result==="lost").length;
  const accuracy = won+lost>0?Math.round((won/(won+lost))*100):92;
  const freePreds    = predictions.filter(p=>p.tier==="free");
  const premiumPreds = predictions.filter(p=>p.tier==="premium");


  // eslint-disable-next-line no-unused-vars
  const Card = ({children,s={}}) => <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20,...s}}>{children}</div>;

  return (
    <div style={{minHeight:"100vh",background:"#f0f2f5",display:"flex",fontFamily:"var(--body)"}}>

      {/* SIDEBAR */}
      <div style={{width:250,background:"#1a1f2e",borderRight:"1px solid #2a3045",padding:"24px 0",display:"flex",flexDirection:"column",flexShrink:0,position:"sticky",top:0,height:"100vh",overflowY:"auto"}}>
        <div style={{padding:"0 20px 20px",borderBottom:"1px solid #2a3045"}}>
          <div style={{fontFamily:"var(--head)",fontSize:26,letterSpacing:"1px",color:"#fff"}}>BET<span style={{color:"#c8ff00"}}>GURU</span></div>
          <div style={{fontSize:11,color:"#8899bb",marginTop:2}}>Admin Dashboard</div>
        </div>
        <nav style={{flex:1,padding:"8px 0"}}>
          {[
            {id:"overview",    icon:"📊", label:"Overview"},
            {id:"predictions", icon:"✏️", label:"Post Prediction"},
            {id:"manage",      icon:"📋", label:"Manage Picks"},
            {id:"leaderboard",  icon:"🏆", label:"Leaderboard"},
            {id:"referrals",   icon:"🔗", label:"Referrals"},
            {id:"subscribers", icon:"👥", label:"Subscribers"},
          ].map(n=>(
            <button key={n.id} onClick={()=>setPage(n.id)} style={{width:"100%",padding:"13px 20px",background:page===n.id?"rgba(200,255,0,0.1)":"transparent",border:"none",borderLeft:page===n.id?"3px solid #c8ff00":"3px solid transparent",color:page===n.id?"#c8ff00":"#aabbd0",textAlign:"left",fontSize:14,fontWeight:600,display:"flex",alignItems:"center",gap:10,cursor:"pointer"}}>
              {n.icon} {n.label}
            </button>
          ))}

          <div style={{padding:"14px 20px 6px",fontSize:10,fontWeight:700,color:"#4a5570",letterSpacing:"1px",borderTop:"1px solid #2a3045",marginTop:8}}>
            💰 ODDS PACKAGES
          </div>
          {PKG_META.map(p=>{
            const active = page==="oddsmanager" && activePkg===p.key;
            return (
              <button key={p.key} onClick={()=>{setPage("oddsmanager");setActivePkg(p.key);setEditGameId(null);}} style={{width:"100%",padding:"10px 20px",background:active?"rgba(200,255,0,0.08)":"transparent",border:"none",borderLeft:active?"3px solid #c8ff00":"3px solid transparent",color:active?p.color:"#8899bb",textAlign:"left",fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
                {p.emoji} {p.label}
                <span style={{marginLeft:"auto",fontSize:10,background:p.access==="FREE"?"rgba(0,166,81,0.2)":"rgba(68,136,255,0.2)",color:p.access==="FREE"?"#00a651":"#4488ff",borderRadius:8,padding:"2px 7px",fontWeight:700}}>{p.access}</span>
              </button>
            );
          })}
        </nav>
        <div style={{padding:"16px 20px",borderTop:"1px solid #2a3045"}}>
          <button onClick={onLogout} style={{background:"none",border:"1px solid #3a4060",color:"#aabbd0",borderRadius:8,padding:"9px 14px",fontSize:12,fontWeight:600,width:"100%",cursor:"pointer"}}>← Exit Admin</button>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={{flex:1,padding:"32px 36px",overflowY:"auto",minHeight:"100vh"}}>

        {/* SUBSCRIBERS */}
        {page==="subscribers" && (
          <SubscribersPage db={db} />
        )}

        {/* REFERRALS ADMIN */}
        {page==="referrals" && (
          <div className="fade-up">
            <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>REFERRALS</div>
            <div style={{fontSize:13,color:"#667",marginBottom:24}}>Manage referral rewards and withdrawal requests.</div>

            {/* Stats */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:20}}>
              {[
                {icon:"👥", label:"Total Referrals",  val:referrals.length,                                          color:"#b00000"},
                {icon:"💰", label:"Total Rewards",    val:"₦"+(referrals.reduce((s,r)=>s+r.reward,0)).toLocaleString(), color:"#00a651"},
                {icon:"⏳", label:"Pending Withdrawals", val:withdrawals.filter(w=>w.status==="pending").length,       color:"#f5a000"},
              ].map((s,i)=>(
                <div key={i} style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:14,padding:"20px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
                  <div style={{fontSize:28,marginBottom:8}}>{s.icon}</div>
                  <div style={{fontFamily:"var(--head)",fontSize:36,color:s.color,lineHeight:1}}>{s.val}</div>
                  <div style={{fontSize:12,color:"#667",marginTop:4}}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Withdrawal requests */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{padding:"16px 24px",borderBottom:"1px solid #e0e4ee",background:"linear-gradient(135deg,#8b0000,#c00000)"}}>
                <div style={{fontFamily:"var(--head)",fontSize:20,color:"#fff",letterSpacing:"1px"}}>💳 WITHDRAWAL REQUESTS</div>
              </div>
              {withdrawals.length===0 ? (
                <div style={{padding:32,textAlign:"center",color:"#667",fontSize:14}}>No withdrawal requests yet.</div>
              ) : withdrawals.map((w,i)=>(
                <div key={i} style={{padding:"16px 24px",borderBottom:i<withdrawals.length-1?"1px solid #f0f2f5":"none",flexWrap:"wrap",gap:8}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                    <div>
                      <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{w.name}</div>
                      <div style={{fontSize:12,color:"#667",marginTop:2}}>{w.bank} · {w.account}</div>
                      <div style={{fontSize:12,color:"#667"}}>Amount: <strong style={{color:"#00a651"}}>₦{(w.amount||0).toLocaleString()}</strong> · {w.date}</div>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      {w.status==="pending" ? (
                        <>
                          <button onClick={()=>setWithdrawals(prev=>prev.map((x,j)=>j===i?{...x,status:"paid"}:x))}
                            style={{background:"#edfff4",border:"1px solid #00a651",color:"#00a651",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>✅ Mark Paid</button>
                          <button onClick={()=>setWithdrawals(prev=>prev.map((x,j)=>j===i?{...x,status:"rejected"}:x))}
                            style={{background:"#fff0f0",border:"1px solid #e53935",color:"#e53935",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>❌ Reject</button>
                        </>
                      ) : (
                        <span style={{background:w.status==="paid"?"#edfff4":"#fff0f0",color:w.status==="paid"?"#00a651":"#e53935",border:`1px solid ${w.status==="paid"?"#00a651":"#e53935"}`,borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700}}>
                          {w.status==="paid"?"✅ PAID":"❌ REJECTED"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* All referrals list */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{padding:"16px 24px",borderBottom:"1px solid #e0e4ee",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontWeight:800,fontSize:15,color:"#111"}}>👥 All Referrals ({referrals.length})</div>
              </div>
              {referrals.length===0 ? (
                <div style={{padding:32,textAlign:"center",color:"#667",fontSize:14}}>No referrals yet.</div>
              ) : referrals.map((r,i)=>(
                <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 24px",borderBottom:i<referrals.length-1?"1px solid #f0f2f5":"none",flexWrap:"wrap",gap:8}}>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{r.email}</div>
                    <div style={{fontSize:12,color:"#667",marginTop:2}}>Referred by: {r.code} · {r.plan} plan · {r.date}</div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{fontFamily:"var(--head)",fontSize:18,color:"#00a651"}}>+₦{r.reward}</div>
                    <button onClick={()=>setReferrals(prev=>prev.map((x,j)=>j===i?{...x,paid:!x.paid}:x))}
                      style={{background:r.paid?"#edfff4":"#fff8ee",border:`1px solid ${r.paid?"#00a651":"#f5a000"}`,color:r.paid?"#00a651":"#f5a000",borderRadius:8,padding:"5px 12px",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                      {r.paid?"✅ PAID":"⏳ PENDING"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* LEADERBOARD MANAGER */}
        {page==="leaderboard" && (
          <div className="fade-up">
            <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>LEADERBOARD</div>
            <div style={{fontSize:13,color:"#667",marginBottom:24}}>Add and manage results shown on the public leaderboard. Changes save instantly.</div>

            {/* Add new result */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{fontWeight:800,fontSize:15,color:"#111",marginBottom:16}}>➕ Add New Result</div>
              <ResultForm onSave={(r) => setResultsData(prev => [r, ...prev])} />
            </div>

            {/* Results list */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{padding:"16px 24px",borderBottom:"1px solid #e0e4ee",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontWeight:800,fontSize:15,color:"#111"}}>📋 All Results ({resultsData.length})</div>
                <button onClick={()=>{if(window.confirm("Clear all results?")) setResultsData([]);}} style={{background:"#fff0f0",border:"1px solid #ffcccc",color:"#e53935",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🗑 Clear All</button>
              </div>
              {resultsData.map((r,i) => (
                <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 24px",borderBottom:i<resultsData.length-1?"1px solid #f0f2f5":"none",flexWrap:"wrap",gap:8}}>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:"#111"}}>{r.m}</div>
                    <div style={{fontSize:12,color:"#667",marginTop:2}}>{r.l} · {r.p} · Odds {r.o} · {r.d}</div>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{background:r.r==="WON"?"#edfff4":"#fff0f0",color:r.r==="WON"?"#00a651":"#e53935",border:`1px solid ${r.r==="WON"?"#00a651":"#e53935"}`,borderRadius:8,padding:"4px 12px",fontSize:12,fontWeight:800}}>{r.r==="WON"?"✅ WON":"❌ LOST"}</span>
                    <button onClick={()=>setResultsData(prev=>prev.filter((_,j)=>j!==i))} style={{background:"#fff0f0",border:"1px solid #ffcccc",color:"#e53935",borderRadius:7,padding:"5px 10px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🗑</button>
                  </div>
                </div>
              ))}
              {resultsData.length===0 && <div style={{padding:32,textAlign:"center",color:"#667",fontSize:14}}>No results yet. Add your first result above!</div>}
            </div>
          </div>
        )}

        {/* OVERVIEW + SITE SETTINGS */}
        {page==="overview" && (
          <div className="fade-up">
            <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>OVERVIEW</div>
            <div style={{fontSize:13,color:"#667",marginBottom:24}}>Welcome back! Edit your site settings below — all changes save instantly.</div>

            {/* Live stats */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:20}}>
              {[
                {icon:"⚽",label:"Total Picks",val:predictions.length,color:"#4488ff",bg:"#eef2ff"},
                {icon:"✅",label:"Won",         val:won,               color:"#00a651",bg:"#edfff4"},
                {icon:"❌",label:"Lost",        val:lost,              color:"#e53935",bg:"#fff0f0"},
                {icon:"🎯",label:"Accuracy",    val:accuracy+"%",      color:"#e67e00",bg:"#fff8ee"},
              ].map((s,i)=>(
                <div key={i} style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:14,padding:"20px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
                  <div style={{width:40,height:40,borderRadius:10,background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,marginBottom:12}}>{s.icon}</div>
                  <div style={{fontFamily:"var(--head)",fontSize:40,color:s.color,lineHeight:1}}>{s.val}</div>
                  <div style={{fontSize:12,color:"#667",marginTop:4,fontWeight:600}}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* ── SITE SETTINGS ── */}
            {[
              {
                title:"📊 Stats & Numbers",
                subtitle:"These numbers show on the Results page and hero section",
                color:"#4488ff",
                fields:[
                  {key:"accuracy",      label:"🎯 Accuracy %",           ph:"e.g. 92",  hint:"Shown as '92%' on results page and header"},
                  {key:"wonThisMonth",  label:"✅ Won This Month",        ph:"e.g. 110", hint:"Shown on Results tab"},
                  {key:"lostThisMonth", label:"❌ Lost This Month",       ph:"e.g. 10",  hint:"Shown on Results tab"},
                ]
              },
              {
                title:"📣 Ticker / Breaking News Bar",
                subtitle:"The scrolling green text at the very top of your site",
                color:"#00a651",
                fields:[
                  {key:"tickerText", label:"Ticker Text", ph:"✅ Arsenal WON · BJ-4X9TK2 · 🔥 92% accuracy...", hint:"Separate items with  &nbsp;·&nbsp;  for the dot separator", wide:true},
                ]
              },
              {
                title:"🏠 Hero Section (Today's Picks Page)",
                subtitle:"The big banner at the top of the Today tab",
                color:"#e67e00",
                fields:[
                  {key:"heroTitle",    label:"Big Title Text",  ph:"TODAY'S PICKS",                hint:"Shown in huge letters"},
                  {key:"heroSubtitle", label:"Subtitle Text",   ph:"Updated every morning by 10AM WAT", hint:"Small text under the title"},
                  {key:"subscribeMsg", label:"Subscribe Banner Message", ph:"Subscribe from ₦1,500/week...", hint:"Text in the yellow subscribe prompt bar"},
                ]
              },
              {
                title:"🔗 Referral Program",
                subtitle:"Turn the referral program on or off for all users instantly",
                color:"#00a651",
                isReferral: true,
                fields:[
                  {key:"referralReward",    label:"🇳🇬 REWARD PER REFERRAL (NGN)", ph:"e.g. 500",   hint:"Nigeria — amount per successful referral"},
                  {key:"referralRewardGHS", label:"🇬🇭 REWARD PER REFERRAL (GHS)", ph:"e.g. 3.90",  hint:"Ghana — amount per successful referral"},
                  {key:"referralRewardKES", label:"🇰🇪 REWARD PER REFERRAL (KES)", ph:"e.g. 5115",  hint:"Kenya — amount per successful referral"},
                ],
              },
              {
                title:"✈️ Telegram Auto-Post",
                subtitle:"Automatically post new picks to @betguru009 Telegram channel",
                color:"#0088cc",
                fields:[],
                isTelegram: true,
              },
              {
                title:"💳 Subscription Pricing (NGN)",
                subtitle:"Change what users pay — updates instantly on the site",
                color:"#b00000",
                fields:[
                  {key:"weeklyNGN",     label:"Weekly Price (₦)",    ph:"1500",  hint:"e.g. 1500 — per day cost auto-calculated"},
                  {key:"monthlyNGN",    label:"Monthly Price (₦)",   ph:"4999",  hint:"e.g. 4999 — shown as BEST VALUE plan"},
                  {key:"quarterlyNGN",  label:"3-Month Price (₦)",   ph:"11999", hint:"e.g. 11999 — shown as SAVE 20% plan"},
                  {key:"weeklyLabel",   label:"Weekly Duration",      ph:"7 days",  hint:"Label shown under weekly plan"},
                  {key:"monthlyLabel",  label:"Monthly Duration",     ph:"30 days", hint:"Label shown under monthly plan"},
                  {key:"quarterlyLabel",label:"3-Month Duration",     ph:"90 days", hint:"Label shown under quarterly plan"},
                ]
              },
              {
                title:"🔗 Social Media Links",
                subtitle:"These appear in the footer. Leave blank to hide.",
                color:"#7c3aed",
                fields:[
                  {key:"whatsapp", label:"WhatsApp Link", ph:"https://wa.me/2348012345678", hint:"Full WhatsApp link"},
                  {key:"telegram", label:"Telegram Link", ph:"https://t.me/betguru",        hint:"Full Telegram link"},
                  {key:"twitter",  label:"Twitter / X",   ph:"https://x.com/betguru",       hint:"Full Twitter/X profile link"},
                ]
              },
            ].map((section,si)=>(
              <div key={si} style={{background:"#fff",border:`1px solid ${section.color}33`,borderRadius:16,padding:"22px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.04)",marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:section.fields.length>0?16:0,paddingBottom:section.fields.length>0?12:0,borderBottom:section.fields.length>0?"1px solid #f0f2f5":"none"}}>
                  <div style={{width:10,height:10,borderRadius:"50%",background:section.color,flexShrink:0}} />
                  <div style={{flex:1}}>
                    <div style={{fontWeight:800,fontSize:15,color:"#111"}}>{section.title}</div>
                    <div style={{fontSize:12,color:"#667",marginTop:1}}>{section.subtitle}</div>
                  </div>
                  {(section.isReferral || section.isTelegram) && (
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      {(() => {
                        const key = section.isReferral ? "referralActive" : "telegramActive";
                        const isOn = siteSettings[key] !== false;
                        return (
                          <>
                            <span style={{fontSize:13,fontWeight:700,color:isOn?"#00a651":"#e53935"}}>
                              {isOn ? "ON" : "OFF"}
                            </span>
                            <div onClick={()=>setSiteSettings(prev=>({...prev,[key]:!prev[key]}))}
                              style={{width:52,height:28,borderRadius:14,background:isOn?"#00a651":"#ccc",cursor:"pointer",position:"relative",transition:"background 0.3s",flexShrink:0}}>
                              <div style={{position:"absolute",top:3,left:isOn?26:3,width:22,height:22,borderRadius:"50%",background:"#fff",transition:"left 0.3s",boxShadow:"0 2px 4px rgba(0,0,0,0.2)"}} />
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  )}
                </div>
                {section.fields.length > 0 && (
                  <div style={{display:"grid",gridTemplateColumns:section.fields.some(f=>f.wide)?"1fr":"1fr 1fr 1fr",gap:14}}>
                    {section.fields.map(f=>(
                      <div key={f.key} style={{gridColumn:f.wide?"1/-1":"auto"}}>
                        <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>{f.label}</label>
                        {f.wide ? (
                          <textarea value={siteSettings[f.key]||""} onChange={e=>setSiteSettings(prev=>({...prev,[f.key]:e.target.value}))} placeholder={f.ph} rows={3}
                            style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none",resize:"vertical"}} />
                        ) : (
                          <input value={siteSettings[f.key]||""} onChange={e=>setSiteSettings(prev=>({...prev,[f.key]:e.target.value}))} placeholder={f.ph}
                            style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none"}} />
                        )}
                        <div style={{fontSize:10,color:"#aaa",marginTop:3}}>{f.hint}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {/* Reset to defaults */}
            <div style={{textAlign:"right",marginBottom:24}}>
              <button onClick={()=>{if(window.confirm("Reset ALL settings to default?")) setSiteSettings(DEFAULT_SETTINGS);}} style={{background:"none",border:"1px solid #d0d5e8",color:"#aaa",borderRadius:8,padding:"7px 16px",fontSize:12,cursor:"pointer"}}>↩ Reset to defaults</button>
            </div>

            {/* Odds packages quick view */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{fontWeight:800,fontSize:15,color:"#111",marginBottom:16}}>💰 Odds Packages — Quick View</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10}}>
                {PKG_META.map(p=>(
                  <button key={p.key} onClick={()=>{setPage("oddsmanager");setActivePkg(p.key);}} style={{background:`${p.color}0d`,border:`1px solid ${p.color}33`,borderRadius:12,padding:"14px 10px",textAlign:"center",cursor:"pointer"}}>
                    <div style={{fontSize:24,marginBottom:4}}>{p.emoji}</div>
                    <div style={{fontSize:12,fontWeight:700,color:"#111"}}>{p.label}</div>
                    <div style={{fontFamily:"var(--head)",fontSize:24,color:p.color}}>{oddsPackages[p.key].games.length}</div>
                    <div style={{fontSize:10,color:"#667"}}>games</div>
                    <div style={{fontSize:10,marginTop:6,background:p.access==="FREE"?"#edfff4":"#eef2ff",color:p.access==="FREE"?"#00a651":"#4488ff",borderRadius:8,padding:"2px 6px",fontWeight:700}}>{p.access}</div>
                  </button>
                ))}
              </div>
            </div>

            {/* Recent predictions */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{fontWeight:800,fontSize:15,color:"#111",marginBottom:12}}>Recent Predictions</div>
              {predictions.slice(0,5).map((p,i)=>(
                <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:i<4?"1px solid #f0f2f5":"none",flexWrap:"wrap",gap:8}}>
                  <div>
                    <span style={{fontSize:13,fontWeight:700,color:"#111"}}>{p.flag} {p.home} vs {p.away}</span>
                    <span style={{fontSize:11,color:"#667",marginLeft:8}}>{p.prediction}</span>
                    <span style={{fontSize:10,background:p.tier==="free"?"#edfff4":"#f0eeff",color:p.tier==="free"?"#00a651":"#7c3aed",borderRadius:8,padding:"2px 8px",marginLeft:8,fontWeight:700}}>{p.tier.toUpperCase()}</span>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <button onClick={()=>startEditPred(p)} style={{background:"#f0f4ff",border:"1px solid #c0cff8",color:"#4488ff",borderRadius:7,padding:"4px 10px",fontSize:11,fontWeight:700,cursor:"pointer"}}>✏️ Edit</button>
                    <button onClick={()=>deletePred(p.id)} style={{background:"#fff0f0",border:"1px solid #ffffff",color:"#e53935",borderRadius:7,padding:"4px 10px",fontSize:11,fontWeight:700,cursor:"pointer"}}>🗑</button>
                  </div>
                </div>
              ))}
              <button onClick={()=>setPage("manage")} style={{marginTop:12,background:"none",border:"none",color:"#4488ff",fontSize:13,fontWeight:700,cursor:"pointer"}}>View all →</button>
            </div>
          </div>
        )}

        {/* POST / EDIT PREDICTION */}
        {page==="predictions" && (
          <div className="fade-up" style={{maxWidth:780}}>
            <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>
              {editPredId?"✏️ EDIT PREDICTION":"✏️ POST PREDICTION"}
            </div>
            <div style={{fontSize:13,color:"#667",marginBottom:20}}>{editPredId?"Update details and click Save.":"Fill every field, set Free or Premium, then click Publish."}</div>
            {predSaved && <div className="fade-in" style={{background:"#edfff4",border:"1px solid #00a651",borderRadius:10,padding:"12px 18px",marginBottom:20,fontSize:14,color:"#00a651",fontWeight:700}}>✅ {editPredId?"Updated":"Published"} successfully!</div>}

            {/* Tier selector */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{fontWeight:800,fontSize:14,color:"#111",marginBottom:12}}>👁 WHO CAN SEE THIS?</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                {[
                  {tier:"free",    icon:"🎁", title:"Free",    desc:"Visible to ALL visitors — no subscription needed.", color:"#00a651"},
                  {tier:"premium", icon:"⭐", title:"Premium", desc:"Subscribers only — booking codes blurred for free users.", color:"#7c3aed"},
                ].map(t=>(
                  <button key={t.tier} onClick={()=>setPredForm({...predForm,tier:t.tier})} style={{padding:"16px",borderRadius:14,cursor:"pointer",border:`2px solid ${predForm.tier===t.tier?t.color:"#d0d5e8"}`,background:predForm.tier===t.tier?`${t.color}10`:"#f8f9fc",textAlign:"left"}}>
                    <div style={{fontSize:22,marginBottom:6}}>{t.icon}</div>
                    <div style={{fontWeight:800,fontSize:15,color:predForm.tier===t.tier?t.color:"#111"}}>{t.title}</div>
                    <div style={{fontSize:12,color:"#667",marginTop:2}}>{t.desc}</div>
                    {predForm.tier===t.tier&&<div style={{marginTop:8,fontSize:11,fontWeight:700,color:t.color}}>✓ SELECTED</div>}
                  </button>
                ))}
              </div>
            </div>

            {/* Match details */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{fontWeight:800,fontSize:14,color:"#111",marginBottom:14}}>⚽ MATCH DETAILS</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
                <FS label="LEAGUE" value={predForm.league} onChange={e=>setPredForm({...predForm,league:e.target.value})} options={A_LEAGUES} />
                <FI label="ODDS"      value={predForm.odds}       onChange={e=>setPredForm({...predForm,odds:e.target.value})}       placeholder="e.g. 2.10" />
                <FI label="HOME TEAM" value={predForm.home}       onChange={e=>setPredForm({...predForm,home:e.target.value})}       placeholder="e.g. Arsenal" />
                <FI label="AWAY TEAM" value={predForm.away}       onChange={e=>setPredForm({...predForm,away:e.target.value})}       placeholder="e.g. Chelsea" />
              </div>
              <FI label="PREDICTION TIP" value={predForm.prediction} onChange={e=>setPredForm({...predForm,prediction:e.target.value})} placeholder="e.g. Home Win · Over 2.5 · BTTS" />
              <div style={{marginTop:14}}>
                <label style={{fontSize:11,fontWeight:700,color:"#667",display:"block",marginBottom:5}}>CONFIDENCE: {predForm.confidence}%</label>
                <input type="range" min={55} max={98} value={predForm.confidence} onChange={e=>setPredForm({...predForm,confidence:Number(e.target.value)})} style={{width:"100%",accentColor:"#00a651"}} />
              </div>
            </div>

            {/* Booking codes — unlimited */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                <div>
                  <div style={{fontWeight:800,fontSize:14,color:"#111"}}>📋 BOOKING CODES</div>
                  <div style={{fontSize:12,color:"#667",marginTop:2}}>Add as many platforms as you want — no limit.</div>
                </div>
                <button onClick={addCode} style={{background:"#edfff4",border:"1px solid #00a651",color:"#00a651",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:800,cursor:"pointer"}}>+ Add Platform</button>
              </div>
              {predForm.codes.length===0&&(
                <div style={{textAlign:"center",padding:"20px",color:"#aaa",fontSize:13,background:"#f8f9fc",borderRadius:10,border:"1px dashed #d0d5e8"}}>No booking codes yet. Click "Add Platform" above.</div>
              )}
              {predForm.codes.map((c,i)=>(
                <div key={i} style={{display:"grid",gridTemplateColumns:"160px 1fr auto",gap:10,marginBottom:10,alignItems:"center"}}>
                  <select value={c.platform} onChange={e=>updateCode(i,"platform",e.target.value)} style={{background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px",color:A_PCOLS[c.platform]||"#111",fontSize:13,fontWeight:700,outline:"none"}}>
                    {A_PLATS.map(pl=><option key={pl} value={pl}>{pl}</option>)}
                  </select>
                  <input value={c.code} onChange={e=>updateCode(i,"code",e.target.value.toUpperCase())} placeholder="e.g. BJ-4X9TK2" style={{background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#00a651",fontSize:14,fontFamily:"monospace",letterSpacing:1,outline:"none"}} />
                  <button onClick={()=>removeCode(i)} style={{background:"#fff0f0",border:"1px solid #ffffff",color:"#e53935",borderRadius:10,padding:"10px 12px",fontSize:13,fontWeight:800,cursor:"pointer"}}>✕</button>
                </div>
              ))}
            </div>

            {/* Analysis */}
            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
              <div style={{fontWeight:800,fontSize:14,color:"#111",marginBottom:10}}>📝 MATCH ANALYSIS</div>
              <textarea value={predForm.analysis} onChange={e=>setPredForm({...predForm,analysis:e.target.value})} placeholder="Form guide, head-to-head stats, key trends, injuries..." rows={5} style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"11px 14px",color:"#111",fontSize:13,resize:"vertical",lineHeight:1.7,outline:"none"}} />
            </div>

            <div style={{display:"flex",gap:12}}>
              <button onClick={savePred} style={{background:"#b00000",color:"#fff",border:"none",borderRadius:10,padding:"13px 40px",fontSize:15,fontWeight:800,cursor:"pointer"}}>
                {editPredId?"💾 Save Changes":"🚀 Publish Prediction"}
              </button>
              {editPredId&&<button onClick={()=>{setEditPredId(null);setPredForm(BLANK_PRED);}} style={{background:"#f0f2f5",border:"1px solid #d0d5e8",color:"#667",borderRadius:10,padding:"13px 24px",fontSize:14,fontWeight:700,cursor:"pointer"}}>Cancel</button>}
            </div>
          </div>
        )}

        {/* MANAGE PICKS */}
        {page==="manage" && (
          <div className="fade-up">
            <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>MANAGE PICKS</div>
            <div style={{fontSize:13,color:"#667",marginBottom:20}}>Edit, delete, or mark predictions Won / Lost after each match.</div>

            <div style={{display:"flex",gap:8,marginBottom:20}}>
              {[{id:"free",label:"🎁 Free ("+freePreds.length+")"},{id:"premium",label:"⭐ Premium ("+premiumPreds.length+")"}].map(t=>(
                <button key={t.id} onClick={()=>setPredTab(t.id)} style={{padding:"9px 20px",borderRadius:10,fontSize:13,fontWeight:700,border:"2px solid",borderColor:predTab===t.id?"#4488ff":"#d0d5e8",background:predTab===t.id?"#eef2ff":"#fff",color:predTab===t.id?"#4488ff":"#667",cursor:"pointer"}}>{t.label}</button>
              ))}
            </div>

            <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              {(predTab==="free"?freePreds:premiumPreds).length===0?(
                <div style={{textAlign:"center",padding:"32px",color:"#667",fontSize:14}}>No {predTab} predictions yet.{" "}
                  <button onClick={()=>setPage("predictions")} style={{background:"none",border:"none",color:"#4488ff",cursor:"pointer",fontWeight:700}}>Post one →</button>
                </div>
              ):(predTab==="free"?freePreds:premiumPreds).map((p,i,arr)=>(
                <div key={p.id} style={{padding:"16px 20px",borderBottom:i<arr.length-1?"1px solid #f0f2f5":"none",background:i%2===0?"#fff":"#fafbfc"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:15,fontWeight:800,color:"#111"}}>{p.flag} {p.home} <span style={{color:"#aaa",fontWeight:400}}>vs</span> {p.away}</div>
                      <div style={{fontSize:12,color:"#667",marginTop:3}}>{p.league} · <strong style={{color:"#111"}}>{p.prediction}</strong> · Odds: {p.odds}</div>
                      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:6}}>
                        {(p.codes||[]).map((c,ci)=>(
                          <span key={ci} style={{fontSize:11,fontFamily:"monospace",background:(A_PCOLS[c.platform]||"#888")+"18",border:"1px solid "+(A_PCOLS[c.platform]||"#888")+"44",color:A_PCOLS[c.platform]||"#888",borderRadius:6,padding:"2px 8px",fontWeight:700}}>{c.platform}: {c.code}</span>
                        ))}
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                      {p.result&&<span style={{fontSize:11,fontWeight:800,color:p.result==="won"?"#00a651":"#e53935",background:p.result==="won"?"#edfff4":"#fff0f0",padding:"3px 10px",borderRadius:20,border:"1px solid "+(p.result==="won"?"#00a651":"#e53935")}}>{p.result.toUpperCase()}</span>}
                      <button onClick={()=>setPredictions(prev=>prev.map(x=>x.id===p.id?{...x,result:"won"}:x))} style={{background:"#edfff4",border:"1px solid #00a651",color:"#00a651",borderRadius:7,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>✅ WON</button>
                      <button onClick={()=>setPredictions(prev=>prev.map(x=>x.id===p.id?{...x,result:"lost"}:x))} style={{background:"#fff0f0",border:"1px solid #e53935",color:"#e53935",borderRadius:7,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>❌ LOST</button>
                      <button onClick={()=>startEditPred(p)} style={{background:"#f0f4ff",border:"1px solid #c0cff8",color:"#4488ff",borderRadius:7,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>✏️ Edit</button>
                      <button onClick={()=>deletePred(p.id)} style={{background:"#fff0f0",border:"1px solid #ffffff",color:"#e53935",borderRadius:7,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🗑</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ODDS PACKAGES MANAGER */}
        {page==="oddsmanager" && (
          <div className="fade-up">
            <div style={{fontFamily:"var(--head)",fontSize:38,color:"#111",marginBottom:4}}>ODDS PACKAGES</div>
            <div style={{fontSize:13,color:"#667",marginBottom:20}}>Select a package in the sidebar, then add or remove games below.</div>

            {PKG_META.filter(p=>p.key===activePkg).map(meta=>{
              const pkg = oddsPackages[activePkg];
              const totalOdds = pkg.games.reduce((a,g)=>a*parseFloat(g.odds||1),1).toFixed(2);
              return (
                <div key={meta.key}>
                  {/* Info bar + Package Date Setter */}
                  <div style={{background:meta.color+"12",border:"1px solid "+meta.color+"33",borderRadius:14,padding:"16px 22px",marginBottom:16,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
                    <div style={{fontSize:36}}>{meta.emoji}</div>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:800,fontSize:18,color:"#111"}}>{meta.label}</div>
                      <div style={{fontSize:12,color:"#667",marginTop:2}}>{meta.desc}</div>
                    </div>
                    <div style={{display:"flex",gap:24}}>
                      {[{l:"GAMES",v:pkg.games.length},{l:"TOTAL ODDS",v:totalOdds+"x"},{l:"ACCESS",v:meta.access}].map((s,i)=>(
                        <div key={i} style={{textAlign:"center"}}>
                          <div style={{fontSize:10,color:"#667",fontWeight:700}}>{s.l}</div>
                          <div style={{fontFamily:"var(--head)",fontSize:26,color:meta.color}}>{s.v}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Package date + clear controls */}
                  <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:12,padding:"14px 20px",marginBottom:20,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,flex:1}}>
                      <span style={{fontSize:20}}>📅</span>
                      <div>
                        <div style={{fontSize:11,fontWeight:800,color:"#333",marginBottom:4}}>PACKAGE DATE — shown to users on the Odds tab</div>
                        <input type="date" value={pkg.packageDate||""} onChange={e=>setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],packageDate:e.target.value}}))}
                          style={{background:"#f0f2f5",border:"2px solid "+meta.color,borderRadius:8,padding:"7px 12px",color:"#111",fontSize:14,fontWeight:700,outline:"none"}} />
                    <div style={{marginTop:12}}>
                      <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>📋 BOOKING CODE (Bet9ja)</label>
                      <input value={pkg.bookingCodeBet9ja||""} onChange={e=>setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],bookingCodeBet9ja:e.target.value}}))}
                        placeholder="e.g. BJ-4X9TK2" style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none",marginBottom:8}} />
                      <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>📋 BOOKING CODE (SportyBet)</label>
                      <input value={pkg.bookingCodeSporty||""} onChange={e=>setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],bookingCodeSporty:e.target.value}}))}
                        placeholder="e.g. SB-8RT3NQ" style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none",marginBottom:8}} />
                      <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>📋 BOOKING CODE (BetKing)</label>
                      <input value={pkg.bookingCodeBetKing||""} onChange={e=>setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],bookingCodeBetKing:e.target.value}}))}
                        placeholder="e.g. BK-3RV6NJ" style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none"}} />
                    </div>
                      </div>
                    </div>
                    <button onClick={()=>{if(window.confirm("Clear ALL games from "+meta.label+"? This cannot be undone.")) setOddsPackages(prev=>({...prev,[activePkg]:{...prev[activePkg],games:[]}}));}}
                      style={{background:"#fff0f0",border:"1px solid #ffffff",color:"#e53935",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:800,cursor:"pointer"}}>
                      🗑 Clear All Games
                    </button>
                  </div>

                  {/* Current games */}
                  <div style={{background:"#fff",border:"1px solid #e0e4ee",borderRadius:16,padding:"20px 24px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",marginBottom:20}}>
                    <div style={{fontWeight:800,fontSize:14,color:"#111",marginBottom:14}}>Current Games in {meta.label} ({pkg.games.length})</div>
                    {pkg.games.length===0?(
                      <div style={{textAlign:"center",padding:"24px",color:"#aaa",fontSize:13,background:"#f8f9fc",borderRadius:10,border:"1px dashed #d0d5e8"}}>No games yet — add one below</div>
                    ):pkg.games.map((g,i)=>(
                      editGameId===g.id?(
                        <div key={g.id} style={{background:meta.color+"0a",border:"1px solid "+meta.color+"33",borderRadius:12,padding:"14px",marginBottom:10}}>
                          <div style={{fontSize:12,fontWeight:700,color:meta.color,marginBottom:10}}>✏️ Editing game #{i+1}</div>
                          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 1fr 1fr",gap:10,marginBottom:10}}>
                            <FI label="HOME"   value={editGameForm.home}   onChange={e=>setEditGameForm({...editGameForm,home:e.target.value})}   placeholder="Arsenal" />
                            <FI label="AWAY"   value={editGameForm.away}   onChange={e=>setEditGameForm({...editGameForm,away:e.target.value})}   placeholder="Chelsea" />
                            <FI label="TIP"    value={editGameForm.tip}    onChange={e=>setEditGameForm({...editGameForm,tip:e.target.value})}    placeholder="Home Win" />
                            <FI label="ODDS"   value={editGameForm.odds}   onChange={e=>setEditGameForm({...editGameForm,odds:e.target.value})}   placeholder="1.85" />
                            <FI label="LEAGUE" value={editGameForm.league} onChange={e=>setEditGameForm({...editGameForm,league:e.target.value})} placeholder="EPL 🏴󠁧󠁢󠁥󠁮󠁧󠁿" />
                            <div>
                              <label style={{fontSize:11,fontWeight:700,color:"#667",display:"block",marginBottom:5}}>📅 DATE</label>
                              <input type="date" value={editGameForm.date||""} onChange={e=>setEditGameForm({...editGameForm,date:e.target.value})}
                                style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 8px",color:"#111",fontSize:12,outline:"none"}} />
                            </div>
                            <div>
                              <label style={{fontSize:11,fontWeight:700,color:"#667",display:"block",marginBottom:5}}>⏰ TIME</label>
                              <input type="time" value={editGameForm.time||""} onChange={e=>setEditGameForm({...editGameForm,time:e.target.value})}
                                style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 8px",color:"#111",fontSize:12,outline:"none"}} />
                            </div>
                          </div>
                          <div style={{display:"flex",gap:8}}>
                            <button onClick={saveEditGame} style={{background:"#edfff4",border:"1px solid #00a651",color:"#00a651",borderRadius:8,padding:"8px 18px",fontWeight:800,cursor:"pointer",fontSize:13}}>💾 Save Game</button>
                            <button onClick={()=>setEditGameId(null)} style={{background:"#f0f2f5",border:"1px solid #d0d5e8",color:"#667",borderRadius:8,padding:"8px 14px",fontWeight:700,cursor:"pointer",fontSize:13}}>✕ Cancel</button>
                          </div>
                        </div>
                      ):(
                        <div key={g.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 16px",borderRadius:12,background:i%2===0?"#f8f9fc":"#fff",border:"1px solid #e8ecf4",marginBottom:8,flexWrap:"wrap",gap:8}}>
                          <div style={{display:"flex",alignItems:"center",gap:12,flex:1}}>
                            <div style={{width:32,height:32,borderRadius:"50%",background:meta.color+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,color:meta.color,flexShrink:0}}>{i+1}</div>
                            <div style={{flex:1}}>
                              <div style={{fontSize:14,fontWeight:800,color:"#111"}}>{g.home} <span style={{color:"#aaa",fontWeight:400}}>vs</span> {g.away}</div>
                              <div style={{fontSize:11,color:"#667",marginTop:2}}>
                                {g.league} · <strong style={{color:"#333"}}>{g.tip}</strong>
                                {(g.date||g.time) && <span style={{marginLeft:8,background:"#eef2ff",color:"#4488ff",borderRadius:6,padding:"1px 7px",fontSize:10,fontWeight:700}}>
                                  📅 {g.date||""} {g.time?"⏰ "+g.time:""}
                                </span>}
                              </div>
                            </div>
                          </div>
                          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                            <div style={{background:meta.color+"18",border:"1px solid "+meta.color+"44",borderRadius:8,padding:"5px 14px",fontFamily:"monospace",fontSize:17,fontWeight:900,color:meta.color,minWidth:52,textAlign:"center"}}>{g.odds}</div>
                            <button onClick={()=>startEditGame(g)} style={{background:"#f0f4ff",border:"1px solid #c0cff8",color:"#4488ff",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>✏️ Edit</button>
                            <button onClick={()=>removeGame(activePkg,g.id)} style={{background:"#fff0f0",border:"1px solid #ffffff",color:"#e53935",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🗑 Remove</button>
                          </div>
                        </div>
                      )
                    ))}
                  </div>

                  {/* ═══ ADD NEW GAME ═══ */}
                  <div style={{background:"#fff",border:"3px solid "+meta.color,borderRadius:16,padding:"24px 28px",boxShadow:"0 4px 20px "+meta.color+"33"}}>
                    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                      <div style={{width:40,height:40,borderRadius:10,background:meta.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>➕</div>
                      <div>
                        <div style={{fontWeight:900,fontSize:18,color:"#111"}}>ADD NEW GAME TO {meta.label.toUpperCase()}</div>
                        <div style={{fontSize:12,color:"#667",marginTop:2}}>Fill all fields below then click the green button to save. You can add unlimited games.</div>
                      </div>
                    </div>

                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
                      <div>
                        <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>🏠 HOME TEAM *</label>
                        <input value={gameForm.home} onChange={e=>setGameForm({...gameForm,home:e.target.value})}
                          placeholder="e.g. Arsenal" style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}} />
                      </div>
                      <div>
                        <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>✈️ AWAY TEAM *</label>
                        <input value={gameForm.away} onChange={e=>setGameForm({...gameForm,away:e.target.value})}
                          placeholder="e.g. Chelsea" style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}} />
                      </div>
                      <div>
                        <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>🎯 PREDICTION TIP *</label>
                        <input value={gameForm.tip} onChange={e=>setGameForm({...gameForm,tip:e.target.value})}
                          placeholder="e.g. Home Win / Over 2.5 / BTTS" style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}} />
                      </div>
                      <div>
                        <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>💰 ODDS *</label>
                        <input value={gameForm.odds} onChange={e=>setGameForm({...gameForm,odds:e.target.value})}
                          placeholder="e.g. 1.85" style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}} />
                      </div>
                      <div>
                        <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>📅 MATCH DATE</label>
                        <input type="date" value={gameForm.date} onChange={e=>setGameForm({...gameForm,date:e.target.value})}
                          style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}} />
                      </div>
                      <div>
                        <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>⏰ KICK-OFF TIME</label>
                        <input type="time" value={gameForm.time} onChange={e=>setGameForm({...gameForm,time:e.target.value})}
                          style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}} />
                      </div>
                    </div>
                    <div style={{marginBottom:20}}>
                      <label style={{fontSize:12,fontWeight:800,color:"#333",display:"block",marginBottom:6}}>🏆 LEAGUE</label>
                      <select value={gameForm.league} onChange={e=>setGameForm({...gameForm,league:e.target.value})}
                        style={{width:"100%",background:"#f0f2f5",border:"2px solid #d0d5e8",borderRadius:10,padding:"12px 14px",color:"#111",fontSize:14,outline:"none",fontWeight:600}}>
                        {["EPL 🏴󠁧󠁢󠁥󠁮󠁧󠁿","UCL ⭐","NPFL 🇳🇬","GPL 🇬🇭","La Liga 🇪🇸","Serie A 🇮🇹","Bundesliga 🇩🇪","Ligue 1 🇫🇷"].map(l=><option key={l} value={l}>{l}</option>)}
                      </select>
                    </div>

                    {/* Validation hint */}
                    {(!gameForm.home||!gameForm.away||!gameForm.tip||!gameForm.odds) && (
                      <div style={{background:"#fff8ee",border:"1px solid #ffb800",borderRadius:8,padding:"8px 14px",fontSize:12,color:"#c07000",marginBottom:14,fontWeight:600}}>
                        ⚠️ Fill in Home Team, Away Team, Tip and Odds to enable the save button
                      </div>
                    )}

                    <button
                      onClick={addGame}
                      disabled={!gameForm.home||!gameForm.away||!gameForm.tip||!gameForm.odds}
                      style={{
                        width:"100%",background:(!gameForm.home||!gameForm.away||!gameForm.tip||!gameForm.odds)?"#ccc":meta.color,
                        color:"#000",border:"none",borderRadius:12,padding:"15px",fontSize:16,fontWeight:900,
                        cursor:(!gameForm.home||!gameForm.away||!gameForm.tip||!gameForm.odds)?"not-allowed":"pointer",
                        letterSpacing:"0.5px",transition:"all 0.2s"
                      }}>
                      ✅ SAVE GAME TO {meta.label.toUpperCase()}
                    </button>
                    <div style={{textAlign:"center",fontSize:11,color:"#667",marginTop:8}}>Game saves instantly and appears above. You can add unlimited games.</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      </div>
    </div>
  );
}

// ─── FAQ ITEM ─────────────────────────────────────────────────────────────────

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom:"1px solid rgba(255,255,255,0.15)", padding:"16px 0" }}>
      <button onClick={() => setOpen(!open)} style={{ background:"none", border:"none", color:"#111318", fontSize:14, fontWeight:700, textAlign:"left", width:"100%", display:"flex", justifyContent:"space-between", gap:16, cursor:"pointer" }}>
        {q} <span style={{ color:"#f5a000", flexShrink:0 }}>{open?"−":"+"}</span>
      </button>
      {open && <div className="fade-in" style={{ fontSize:13, color:"#555f7a", lineHeight:1.7, marginTop:10 }}>{a}</div>}
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────

// ─── localStorage helpers ─────────────────────────────────────────────────────
function loadLS(key, fallback) {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch { return fallback; }
}
function saveLS(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}

const TODAY = new Date().toISOString().split("T")[0];


const EMPTY_ODDS_PACKAGES = {
  free:    { label:"Free Odds",    emoji:"🎁", color:"#00a651", desc:"Free daily pick — no subscription needed",         games:[], packageDate:TODAY },
  two:     { label:"2 Odds",       emoji:"2️⃣", color:"#4488ff", desc:"2 carefully selected games. Low risk, steady wins", games:[], packageDate:TODAY },
  five:    { label:"5 Odds",       emoji:"5️⃣", color:"#ffb800", desc:"5 games combined for bigger returns",               games:[], packageDate:TODAY },
  ten:     { label:"10 Odds",      emoji:"🔟", color:"#ff6b00", desc:"10 games. High risk, high reward combo",             games:[], packageDate:TODAY },
  bigband: { label:"Big Bang Odds",emoji:"💥", color:"#ff4757", desc:"Massive accumulator — 20+ odds guaranteed",         games:[], packageDate:TODAY },
};

// ─── PUSH NOTIFICATION HELPER ────────────────────────────────────────────────
async function sendPushNotification(title, body) {
  try {
    await addDoc(collection(db, "notifications"), {
      title,
      body,
      sentAt: new Date().toISOString(),
      sent: false,
    });
    // Also show local notification if permission granted
    if (Notification.permission === "granted") {
      new Notification(title, { body, icon: "/favicon.ico" });
    }
  } catch(e) {
    console.log("Push notification error:", e);
  }
}

// ─── REFERRAL PAGE COMPONENT ─────────────────────────────────────────────────
function ReferralPage({ currency, siteSettings, firebaseUser, referrals, withdrawals, onWithdraw }) {
  const [showWithdrawForm, setShowWithdrawForm] = useState(false);
  const [wForm, setWForm] = useState({ name:"", bank:"", account:"", amount:"" });
  const [refCode, setRefCode] = useState(localStorage.getItem("bg_refcode") || "");

  // Generate referral code if not present
  useEffect(() => {
    if (!refCode && firebaseUser) {
      const newCode = "BG" + firebaseUser.uid.substring(0,6).toUpperCase();
      localStorage.setItem("bg_refcode", newCode);
      setRefCode(newCode);
      // Save to Firebase
      updateDoc(doc(db, "users", firebaseUser.uid), { referralCode: newCode }).catch(()=>{});
    }
  }, [firebaseUser, refCode]);
  const refLink = `${window.location.origin}?ref=${refCode}`;
  const [copied, setCopied] = useState(false);

  const totalEarned = referrals.filter(r=>!r.paid).reduce((sum,r) => sum + r.reward, 0);
  const totalPaid   = referrals.filter(r=>r.paid).reduce((sum,r) => sum + r.reward, 0);
  const pendingWithdrawal = withdrawals.some(w => w.status === "pending");

  const copyLink = () => {
    navigator.clipboard?.writeText(refLink).then(() => { setCopied(true); setTimeout(()=>setCopied(false), 2000); });
  };

  const handleWithdraw = () => {
    if (!wForm.name || !wForm.bank || !wForm.account) return alert("Please fill all fields!");
    const minWithdraw = 5000;
    if (totalEarned < minWithdraw) return alert(`Minimum withdrawal is ₦${minWithdraw.toLocaleString()}. Keep referring!`);
    onWithdraw({ ...wForm, amount: totalEarned });
    setShowWithdrawForm(false);
    setWForm({ name:"", bank:"", account:"", amount:"" });
    alert("Withdrawal request submitted! Admin will process within 24 hours.");
  };

  // Currency display
  const displayAmount = (ngn) => {
    if (currency === "GHS") return `GH₵${(ngn / 128.39).toFixed(2)}`;
    if (currency === "KES") return `KSh${(ngn * 10.23).toFixed(0)}`;
    return `₦${ngn.toLocaleString()}`;
  };

  return (
    <div>
      {/* Earnings summary */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:16, marginBottom:24 }} className="grid-3">
        {[
          { icon:"💰", label:"Available Balance", val:displayAmount(totalEarned), color:"#00a651", bg:"#edfff4" },
          { icon:"👥", label:"Total Referrals",   val:referrals.length,           color:"#b00000", bg:"#fff0f0" },
          { icon:"✅", label:"Total Paid Out",    val:displayAmount(totalPaid),   color:"#f5a000", bg:"#fff8ee" },
        ].map((s,i) => (
          <div key={i} style={{ background:s.bg, borderRadius:16, padding:"20px", textAlign:"center", border:`1px solid ${s.color}33` }}>
            <div style={{ fontSize:28, marginBottom:8 }}>{s.icon}</div>
            <div style={{ fontFamily:"var(--head)", fontSize:32, color:s.color, lineHeight:1 }}>{s.val}</div>
            <div style={{ fontSize:12, color:"#666", marginTop:6 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Referral link */}
      <div style={{ background:"#fff", borderRadius:16, padding:"24px", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:24 }}>
        <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:6 }}>🔗 Your Referral Link</div>
        <div style={{ fontSize:13, color:"#666", marginBottom:16 }}>Share this link. When a friend subscribes to Monthly or Quarterly plan, you earn <strong style={{color:"#b00000"}}>
          {currency==="NGN" ? `₦${(siteSettings?.referralReward||500).toLocaleString()}` : currency==="GHS" ? `GH₵${(siteSettings?.referralRewardGHS||3.90).toFixed(2)}` : `KSh${(siteSettings?.referralRewardKES||5115).toLocaleString()}`}
        </strong> instantly!</div>
        <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap" }}>
          <div style={{ flex:1, background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:10, padding:"12px 16px", fontSize:13, color:"#555", fontFamily:"monospace", wordBreak:"break-all" }}>
            {refLink}
          </div>
          <button onClick={copyLink} style={{ background: copied ? "#00a651" : "#b00000", color:"#fff", border:"none", borderRadius:10, padding:"12px 20px", fontSize:13, fontWeight:800, cursor:"pointer", whiteSpace:"nowrap" }}>
            {copied ? "✅ Copied!" : "📋 Copy Link"}
          </button>
        </div>

        {/* Share buttons */}
        <div style={{ display:"flex", gap:10, marginTop:14, flexWrap:"wrap" }}>
          <a href={`https://wa.me/?text=${encodeURIComponent("🔥 I've been winning with BetGuru football predictions! Subscribe to the Monthly Premium plan using my link and get expert picks daily: " + refLink + " (Use my referral link for ₦4,999/month premium access)")}`} target="_blank" rel="noreferrer"
            style={{ background:"#25D366", color:"#fff", borderRadius:10, padding:"10px 18px", fontSize:13, fontWeight:700, textDecoration:"none" }}>
            📱 Share on WhatsApp
          </a>
          <a href={`https://t.me/share/url?url=${encodeURIComponent(refLink)}&text=${encodeURIComponent("🔥 Get premium football predictions on BetGuru!")}`} target="_blank" rel="noreferrer"
            style={{ background:"#0088cc", color:"#fff", borderRadius:10, padding:"10px 18px", fontSize:13, fontWeight:700, textDecoration:"none" }}>
            ✈️ Share on Telegram
          </a>
          <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent("🔥 Making money with BetGuru football predictions! Join me: " + refLink)}`} target="_blank" rel="noreferrer"
            style={{ background:"#000", color:"#fff", borderRadius:10, padding:"10px 18px", fontSize:13, fontWeight:700, textDecoration:"none" }}>
            🐦 Share on X
          </a>
        </div>
      </div>

      {/* Reward rates */}
      <div style={{ background:"#fff8ee", border:"1px solid #f5a000", borderRadius:16, padding:"20px 24px", marginBottom:24 }}>
        <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:12 }}>💡 How It Works</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, marginBottom:12 }} className="grid-3">
          {[
            { flag:"🇳🇬", country:"Nigeria", reward:`₦${(siteSettings?.referralReward||500).toLocaleString()} per referral`,    min:`Min withdrawal: ₦5,000` },
            { flag:"🇬🇭", country:"Ghana",   reward:`GH₵${(siteSettings?.referralRewardGHS||3.90).toFixed(2)} per referral`,    min:`Min withdrawal: GH₵39` },
            { flag:"🇰🇪", country:"Kenya",   reward:`KSh${(siteSettings?.referralRewardKES||5115).toLocaleString()} per referral`, min:`Min withdrawal: KSh51,150` },
          ].map((c,i) => (
            <div key={i} style={{ background:"#fff", borderRadius:12, padding:"14px", textAlign:"center", border:"1px solid #ffe4a0" }}>
              <div style={{ fontSize:28, marginBottom:6 }}>{c.flag}</div>
              <div style={{ fontSize:13, fontWeight:800, color:"#111", marginBottom:4 }}>{c.country}</div>
              <div style={{ fontSize:13, color:"#b00000", fontWeight:700, marginBottom:4 }}>{c.reward}</div>
              <div style={{ fontSize:11, color:"#888" }}>{c.min}</div>
            </div>
          ))}
        </div>
        <div style={{ fontSize:12, color:"#666" }}>⚡ Rewards are credited instantly when your referral subscribes to the <strong style={{color:"#b00000"}}>Monthly (₦4,999) or Quarterly (₦11,999)</strong> plan. Weekly plan does not qualify. Withdrawals processed within 24 hours.</div>
      </div>

      {/* Withdrawal button */}
      <div style={{ background:"#fff", borderRadius:16, padding:"20px 24px", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:24 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:12 }}>
          <div>
            <div style={{ fontWeight:800, fontSize:15, color:"#111" }}>💳 Request Withdrawal</div>
            <div style={{ fontSize:12, color:"#888", marginTop:2 }}>Minimum: ₦5,000 · Processed within 24 hours</div>
          </div>
          {!showWithdrawForm && (
            <button onClick={() => setShowWithdrawForm(true)} disabled={totalEarned < 5000 || pendingWithdrawal}
              style={{ background: totalEarned >= 5000 && !pendingWithdrawal ? "#f5a000" : "#ccc", color:"#fff", border:"none", borderRadius:10, padding:"12px 24px", fontSize:14, fontWeight:800, cursor: totalEarned >= 5000 && !pendingWithdrawal ? "pointer" : "not-allowed" }}>
              {pendingWithdrawal ? "⏳ Request Pending" : totalEarned < 5000 ? `Need ₦${(5000-totalEarned).toLocaleString()} more` : "💳 Withdraw Now"}
            </button>
          )}
        </div>

        {showWithdrawForm && (
          <div style={{ borderTop:"1px solid #e0e4ee", paddingTop:16 }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
              {[
                { key:"name",    label:"ACCOUNT NAME",   ph:"Your full name" },
                { key:"bank",    label:"BANK NAME",       ph:"e.g. GTBank, Access, Zenith" },
                { key:"account", label:"ACCOUNT NUMBER",  ph:"10-digit account number" },
              ].map(f => (
                <div key={f.key} style={{ gridColumn: f.key==="account" ? "1/-1" : "auto" }}>
                  <label style={{ fontSize:11, fontWeight:800, color:"#444", display:"block", marginBottom:5 }}>{f.label}</label>
                  <input value={wForm[f.key]} onChange={e=>setWForm({...wForm,[f.key]:e.target.value})} placeholder={f.ph}
                    style={{ width:"100%", background:"#f8f9fc", border:"1px solid #d0d5e8", borderRadius:10, padding:"11px 14px", color:"#111", fontSize:14, outline:"none" }} />
                </div>
              ))}
            </div>
            <div style={{ background:"#fff8ee", border:"1px solid #f5a000", borderRadius:10, padding:"12px 16px", marginBottom:12, fontSize:13, color:"#b00000", fontWeight:700 }}>
              Withdrawal Amount: {displayAmount(totalEarned)}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={handleWithdraw} style={{ background:"#f5a000", color:"#fff", border:"none", borderRadius:10, padding:"12px 24px", fontSize:14, fontWeight:800, cursor:"pointer" }}>
                ✅ Submit Request
              </button>
              <button onClick={() => setShowWithdrawForm(false)} style={{ background:"none", border:"1px solid #e0e4ee", borderRadius:10, padding:"12px 24px", fontSize:14, fontWeight:600, cursor:"pointer", color:"#666" }}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Referral history */}
      <div style={{ background:"#fff", borderRadius:16, overflow:"hidden", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
        <div style={{ padding:"16px 24px", borderBottom:"1px solid #e0e4ee", background:"linear-gradient(135deg,#8b0000,#c00000)" }}>
          <div style={{ fontFamily:"var(--head)", fontSize:20, color:"#fff", letterSpacing:"1px" }}>👥 YOUR REFERRALS</div>
        </div>
        {referrals.length === 0 ? (
          <div style={{ padding:"32px", textAlign:"center", color:"#888" }}>
            <div style={{ fontSize:40, marginBottom:12 }}>👥</div>
            <div style={{ fontSize:15, fontWeight:700, marginBottom:8 }}>No referrals yet</div>
            <div style={{ fontSize:13 }}>Share your link above to start earning!</div>
          </div>
        ) : referrals.map((r,i) => (
          <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"14px 24px", borderBottom:i<referrals.length-1?"1px solid #f0f0f0":"none", flexWrap:"wrap", gap:8 }}>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:"#111" }}>👤 {r.email}</div>
              <div style={{ fontSize:12, color:"#888", marginTop:2 }}>{r.plan} plan · {r.date}</div>
            </div>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <div style={{ fontFamily:"var(--head)", fontSize:20, color:"#00a651" }}>+{displayAmount(r.reward)}</div>
              <span style={{ background: r.paid?"#edfff4":"#fff8ee", color: r.paid?"#00a651":"#f5a000", border:`1px solid ${r.paid?"#00a651":"#f5a000"}`, borderRadius:8, padding:"3px 10px", fontSize:11, fontWeight:800 }}>
                {r.paid ? "PAID" : "PENDING"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── RESULT FORM COMPONENT ────────────────────────────────────────────────────
function ResultForm({ onSave }) {
  const [form, setForm] = useState({ m:"", p:"", r:"WON", o:"", d:"", l:"EPL" });
  const leagues = ["EPL","NPFL","UCL","GPL","La Liga","Bundesliga","Serie A","Ligue 1","AFCON","Other"];
  const handleSave = () => {
    if (!form.m || !form.p || !form.o) return alert("Fill in match, prediction and odds!");
    onSave({ ...form, d: form.d || new Date().toLocaleDateString("en-NG",{day:"numeric",month:"short"}) });
    setForm({ m:"", p:"", r:"WON", o:"", d:"", l:"EPL" });
  };
  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
        {[
          {key:"m", label:"MATCH",      ph:"e.g. Arsenal vs Chelsea"},
          {key:"p", label:"PREDICTION", ph:"e.g. Home Win / Over 2.5"},
          {key:"o", label:"ODDS",       ph:"e.g. 2.10"},
          {key:"d", label:"DATE",       ph:"e.g. Mar 20"},
        ].map(f=>(
          <div key={f.key}>
            <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>{f.label}</label>
            <input value={form[f.key]} onChange={e=>setForm({...form,[f.key]:e.target.value})} placeholder={f.ph}
              style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none"}} />
          </div>
        ))}
        <div>
          <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>LEAGUE</label>
          <select value={form.l} onChange={e=>setForm({...form,l:e.target.value})}
            style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none"}}>
            {leagues.map(l=><option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:800,color:"#444",display:"block",marginBottom:5}}>RESULT</label>
          <select value={form.r} onChange={e=>setForm({...form,r:e.target.value})}
            style={{width:"100%",background:"#f8f9fc",border:"1px solid #d0d5e8",borderRadius:10,padding:"10px 12px",color:"#111",fontSize:13,outline:"none"}}>
            <option value="WON">✅ WON</option>
            <option value="LOST">❌ LOST</option>
          </select>
        </div>
      </div>
      <button onClick={handleSave} style={{background:"#b00000",color:"#fff",border:"none",borderRadius:10,padding:"12px 32px",fontSize:14,fontWeight:800,cursor:"pointer"}}>
        ➕ Add Result
      </button>
    </div>
  );
}

// ─── LOGIN MODAL ─────────────────────────────────────────────────────────────
function LoginModal({ onClose, onSuccess }) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    if (!email || !phone) return;
    setLoading(true);
    setError("");
    try {
      const userCred = await signInWithEmailAndPassword(auth, email, phone + "@betguru.app");
      const snap = await getDoc(doc(db, "users", userCred.user.uid));
      if (snap.exists()) {
        const data = snap.data();
        const expiry = new Date(data.expiresAt);
        if (data.active && expiry > new Date()) {
          onSuccess();
          onClose();
        } else {
          setError("Your subscription has expired. Please subscribe again.");
          await signOut(auth);
        }
      }
    } catch(e) {
      setError("Invalid email or phone number. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:"#ffffff", borderRadius:20, width:"100%", maxWidth:400, padding:32, position:"relative" }}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"#f5f5f5", border:"none", borderRadius:"50%", width:32, height:32, fontSize:16, cursor:"pointer" }}>✕</button>
        <div style={{ fontFamily:"var(--head)", fontSize:28, fontWeight:800, color:"#b00000", marginBottom:4 }}>WELCOME BACK</div>
        <div style={{ fontSize:14, color:"#666", marginBottom:24 }}>Login with your email and phone number</div>
        {error && <div style={{ background:"#fff0f0", border:"1px solid #ffcccc", borderRadius:10, padding:"10px 14px", fontSize:13, color:"#e53935", marginBottom:16 }}>{error}</div>}
        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:12, fontWeight:700, color:"#444", display:"block", marginBottom:6 }}>EMAIL ADDRESS</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com" type="email"
            style={{ width:"100%", background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:10, padding:"12px 14px", fontSize:14, outline:"none" }} />
        </div>
        <div style={{ marginBottom:24 }}>
          <label style={{ fontSize:12, fontWeight:700, color:"#444", display:"block", marginBottom:6 }}>PHONE NUMBER (used as password)</label>
          <input value={phone} onChange={e=>setPhone(e.target.value)} placeholder="e.g. 08012345678" type="tel"
            style={{ width:"100%", background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:10, padding:"12px 14px", fontSize:14, outline:"none" }} />
        </div>
        <button onClick={handleLogin} disabled={loading} style={{ width:"100%", background:"#b00000", color:"#fff", border:"none", borderRadius:12, padding:"14px", fontSize:16, fontWeight:800, cursor:"pointer" }}>
          {loading ? "Logging in..." : "Login →"}
        </button>
        <div style={{ fontSize:12, color:"#888", textAlign:"center", marginTop:16 }}>Don't have an account? <span style={{ color:"#b00000", cursor:"pointer", fontWeight:700 }} onClick={onClose}>Subscribe Now</span></div>
      </div>
    </div>
  );
}

export default function App() {
  const [predictions, setPredictionsRaw] = useState(() => {
    // Load from localStorage — Firebase will override immediately on startup
    // Never return hardcoded games — admin controls everything
    return loadLS("bg_predictions", []);
  });
  const [oddsPackages,  setOddsPackagesRaw]  = useState(() => loadLS("bg_odds", EMPTY_ODDS_PACKAGES));
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showModal,     setShowModal]     = useState(false);
  const [showLoginModal,setShowLoginModal] = useState(false);
  const [showMoreMenu,       setShowMoreMenu]       = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [newPassword,        setNewPassword]        = useState("");
  const [confirmPassword,    setConfirmPassword]    = useState("");
  const [passwordMsg,        setPasswordMsg]        = useState("");
  const [showMobileMore, setShowMobileMore] = useState(false);
  const [currency,     setCurrency]    = useState("NGN");
  const [leagueFilter, setLeagueFilter]= useState("All");
  const getTabFromHash = () => {
    const hash = window.location.hash.replace("#", "") || "today";
    const validTabs = ["today","odds","sporty","results","how","profile","leaderboard","referral"];
    return validTabs.includes(hash) ? hash : "today";
  };
  const [tab, setTabRaw] = useState(getTabFromHash);

  const setTab = (newTab) => {
    setTabRaw(newTab);
    window.location.hash = newTab;
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Listen for browser back/forward navigation
  useEffect(() => {
    const handleHashChange = () => setTabRaw(getTabFromHash());
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  const [isAdmin,      setIsAdmin]     = useState(false);
  const [showAdminLogin,setShowAdminLogin]=useState(false);
  const [adminPass,    setAdminPass]   = useState("");
  const [adminError,   setAdminError]  = useState(false);
  const [forgotAdmin,  setForgotAdmin] = useState(false);
  const [resetEmail,   setResetEmail]  = useState("");
  const [resetSent,    setResetSent]   = useState(false);
  const [siteSettings, setSiteSettingsRaw] = useState(() => {
    const saved = loadLS("bg_settings", DEFAULT_SETTINGS);
    // Merge with defaults to ensure new fields like whatsapp/telegram are always present
    return { ...DEFAULT_SETTINGS, ...saved };
  });
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [subExpiry,    setSubExpiry]    = useState(null);
  const [resultsData,  setResultsDataRaw] = useState(() => loadLS("bg_results", DEFAULT_RESULTS));
  const [referrals,    setReferralsRaw]    = useState(() => loadLS("bg_referrals", []));
  const [withdrawals,  setWithdrawalsRaw]  = useState(() => loadLS("bg_withdrawals", []));

  const setResultsData = (fn) => {
    setResultsDataRaw(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      saveLS("bg_results", next);
      return next;
    });
  };

  const setReferrals = (fn) => {
    setReferralsRaw(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      saveLS("bg_referrals", next);
      return next;
    });
  };

  const setWithdrawals = (fn) => {
    setWithdrawalsRaw(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      saveLS("bg_withdrawals", next);
      return next;
    });
  };

  // Load ALL data from Firebase on startup (syncs across all devices)
  useEffect(() => {
    const loadFromFirebase = async () => {
      try {
        // Load all in parallel for speed
        const [settingsSnap, oddsSnap, predsSnap] = await Promise.all([
          getDoc(doc(db, "app_settings", "main")),
          getDoc(doc(db, "app_data", "odds")),
          getDoc(doc(db, "app_data", "predictions")),
        ]);

        if (settingsSnap.exists()) {
          const data = settingsSnap.data();
          setSiteSettingsRaw({ ...DEFAULT_SETTINGS, ...data });
          saveLS("bg_settings", { ...DEFAULT_SETTINGS, ...data });
        }

        if (oddsSnap.exists() && oddsSnap.data().data) {
          setOddsPackagesRaw(oddsSnap.data().data);
          saveLS("bg_odds", oddsSnap.data().data);
        }

        if (predsSnap.exists() && predsSnap.data().list !== undefined) {
          const preds = predsSnap.data().list || [];
          setPredictionsRaw(preds);
          saveLS("bg_predictions", preds);
        }

      } catch(e) {
        console.log("Firebase load error:", e);
      }
    };
    loadFromFirebase();
  }, []);

  // Close more menu when clicking outside
  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest(".more-menu-wrap")) setShowMoreMenu(false);
      if (!e.target.closest(".mobile-nav")) setShowMobileMore(false);
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  // Request push notification permission
  useEffect(() => {
    const requestNotificationPermission = async () => {
      try {
        if (!("Notification" in window)) return;
        if (Notification.permission === "granted") return;
        if (Notification.permission === "denied") return;
        // Ask after 3 seconds so it doesn't feel intrusive
        setTimeout(async () => {
          const permission = await Notification.requestPermission();
          if (permission === "granted") {
            try {
              // FCM token registration skipped (requires service worker)
              const token = null;
              if (token) {
                // Save token to Firestore for sending notifications later
                await setDoc(doc(db, "fcm_tokens", token.substring(0,20)), {
                  token, createdAt: new Date().toISOString(), platform: "web"
                });
                localStorage.setItem("bg_fcm_token", token);
              }
            } catch(e) {
              console.log("FCM token error:", e);
            }
          }
        }, 3000);
      } catch(e) {
        console.log("Notification permission error:", e);
      }
    };
    requestNotificationPermission();
  }, []);

  // Handle return from Paystack payment
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    // Store referral code if someone visited via referral link
    const refBy = urlParams.get("ref");
    if (refBy && refBy.startsWith("BG")) {
      localStorage.setItem("bg_referred_by", refBy);
    }
    const ref = urlParams.get("reference") || urlParams.get("trxref");
    if (ref && ref.startsWith("BG-")) {
      const pending = localStorage.getItem("bg_pending");
      if (pending) {
        const data = JSON.parse(pending);
        localStorage.removeItem("bg_pending");
        // Activate subscription after successful payment
        const activateSubscription = async () => {
          try {
            // Activate subscription using saved uid or email
            let uid = data.uid;
            if (!uid) {
              const userCred = await signInWithEmailAndPassword(auth, data.email, data.phone + "@betguru.app");
              uid = userCred.user.uid;
            }
            // Generate referral code
            const refCode = "BG" + uid.substring(0,6).toUpperCase();
            // Recalculate expiry based on actual plan selected
            const activationDate = new Date();
            const correctExpiry = new Date();
            if (data.plan === "weekly")        correctExpiry.setDate(activationDate.getDate() + 7);
            else if (data.plan === "monthly")  correctExpiry.setDate(activationDate.getDate() + 30);
            else if (data.plan === "quarterly")correctExpiry.setDate(activationDate.getDate() + 90);
            else                               correctExpiry.setDate(activationDate.getDate() + 30);
            // Update Firestore to activate with correct expiry
            await updateDoc(doc(db, "users", uid), {
              active: true,
              pending: false,
              paystackRef: ref,
              activatedAt: activationDate.toISOString(),
              subscribedAt: activationDate.toISOString(),
              expiresAt: correctExpiry.toISOString(),
              plan: data.plan,
              planName: data.planName,
              amount: data.ngnVal,
              referralCode: refCode,
            });
            setIsSubscribed(true);
            localStorage.setItem("bg_refcode", refCode);
            localStorage.removeItem("bg_pending");
            // Track successful payment
            window.gtag?.("event", "purchase", { currency:"NGN", value: data.ngnVal || 0 });
            window.fbq?.("track", "Purchase", { currency:"NGN", value: data.ngnVal || 0 });
            // Credit referrer ONLY for monthly (₦4,999) or quarterly (₦11,999) plans
            const referredBy = localStorage.getItem("bg_referred_by");
            const refSettings = JSON.parse(localStorage.getItem("bg_settings") || "{}");
            if (referredBy && (data.plan === "monthly" || data.plan === "quarterly") && refSettings.referralActive !== false) {
              const reward = JSON.parse(localStorage.getItem("bg_settings")||"{}").referralReward || 500;
              setReferrals(prev => [...prev, {
                code: referredBy,
                email: data.email,
                plan: data.plan,
                date: new Date().toLocaleDateString("en-NG",{day:"numeric",month:"short",year:"numeric"}),
                reward: Number(reward),
                paid: false,
              }]);
              localStorage.removeItem("bg_referred_by");
            } else if (referredBy) {
              // Remove tracking but don't credit — weekly plan doesn't qualify
              localStorage.removeItem("bg_referred_by");
            }
            // Clean URL
            window.history.replaceState({}, document.title, window.location.pathname);
          } catch(e) {
            console.error("Subscription activation error:", e);
          }
        };
        activateSubscription();
      }
    }
  }, []);

  // Listen to Firebase auth state
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setFirebaseUser(user);
      if (user) {
        // Check subscription status from Firestore
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          const data = snap.data();
          const expiry = new Date(data.expiresAt);
          const now = new Date();
          if (data.active && expiry > now) {
            setIsSubscribed(true);
            setSubExpiry(expiry);
            // Load referral code from Firebase
            if (data.referralCode) {
              localStorage.setItem("bg_refcode", data.referralCode);
            } else {
              const newCode = "BG" + user.uid.substring(0,6).toUpperCase();
              localStorage.setItem("bg_refcode", newCode);
              updateDoc(doc(db, "users", user.uid), { referralCode: newCode }).catch(()=>{});
            }
          } else {
            setIsSubscribed(false);
            // Update Firestore to mark expired
            if (data.active && expiry <= now) {
              await updateDoc(doc(db, "users", user.uid), { active: false });
            }
          }
        }
      } else {
        setIsSubscribed(false);
        setSubExpiry(null);
      }
    });
    return () => unsub();
  }, []);

  const setSiteSettings = (fn) => {
    setSiteSettingsRaw(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      saveLS("bg_settings", next);
      // Also save to Firestore so all devices get the same settings
      setDoc(doc(db, "app_settings", "main"), next).catch(e => console.log("Settings sync error:", e));
      return next;
    });
  };

  // Wrappers that also persist to localStorage
  const setPredictions = (fn) => {
    setPredictionsRaw(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      saveLS("bg_predictions", next);
      // Sync entire predictions list to Firebase
      syncPredictionsToFirebase(next);
      return next;
    });
  };

  const syncPredictionsToFirebase = async (preds) => {
    try {
      // Save full list as single document for easy retrieval
      await setDoc(doc(db, "app_data", "predictions"), {
        list: preds,
        updatedAt: new Date().toISOString(),
      });
    } catch(e) {
      console.log("Predictions sync error:", e);
    }
  };
  const setOddsPackages = (fn) => {
    setOddsPackagesRaw(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      saveLS("bg_odds", next);
      // Sync to Firebase
      setDoc(doc(db, "app_data", "odds"), { data: next, updatedAt: new Date().toISOString() })
        .catch(e => console.log("Odds sync error:", e));
      return next;
    });
  };


  const leagues = ["All", ...new Set(predictions.map(p => p.league))];
  const filtered = leagueFilter === "All" ? predictions : predictions.filter(p => p.league === leagueFilter);

  const handleAdminLogin = () => {
    // Brute force protection — max 5 attempts
    const attempts = parseInt(localStorage.getItem("bg_admin_attempts") || "0");
    const lockUntil = parseInt(localStorage.getItem("bg_admin_lock") || "0");
    if (Date.now() < lockUntil) {
      const mins = Math.ceil((lockUntil - Date.now()) / 60000);
      setAdminError(true);
      alert(`Too many failed attempts. Try again in ${mins} minute(s).`);
      return;
    }
    if (adminPass === "Absonpatojima2024") {
      localStorage.removeItem("bg_admin_attempts");
      localStorage.removeItem("bg_admin_lock");
      setIsAdmin(true); setShowAdminLogin(false); setAdminPass(""); setAdminError(false);
    } else {
      const newAttempts = attempts + 1;
      localStorage.setItem("bg_admin_attempts", newAttempts);
      if (newAttempts >= 5) {
        localStorage.setItem("bg_admin_lock", Date.now() + 15 * 60000);
        localStorage.removeItem("bg_admin_attempts");
        alert("Too many failed attempts. Admin locked for 15 minutes.");
      }
      setAdminError(true); setAdminPass("");
    }
  };

  const plans = getPlans(siteSettings);

  if (isAdmin) return <AdminPanel predictions={predictions} setPredictions={setPredictions} oddsPackages={oddsPackages} setOddsPackages={setOddsPackages} siteSettings={siteSettings} setSiteSettings={setSiteSettings} resultsData={resultsData} setResultsData={setResultsData} referrals={referrals} setReferrals={setReferrals} withdrawals={withdrawals} setWithdrawals={setWithdrawals} onLogout={() => setIsAdmin(false)} />;

  return (
    <>
      <style>{STYLES}</style>

      {showModal && <SubscribeModal onClose={() => setShowModal(false)} onSuccess={() => setIsSubscribed(true)} currency={currency} plans={plans} />}
      {showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} onSuccess={() => setIsSubscribed(true)} />}

      {/* Change Password Modal */}
      {showChangePassword && (
        <div className="fade-in" style={{ position:"fixed", inset:0, background:"rgba(5,6,10,0.85)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div style={{ background:"#fff", borderRadius:16, padding:32, width:"100%", maxWidth:380 }}>
            <div style={{ fontFamily:"var(--head)", fontSize:24, marginBottom:6 }}>CHANGE <span style={{ color:"#b00000" }}>PASSWORD</span></div>
            <div style={{ fontSize:13, color:"#888", marginBottom:20 }}>Enter your new password below</div>
            <input type="password" placeholder="New password" value={newPassword} onChange={e=>setNewPassword(e.target.value)}
              style={{ width:"100%", background:"#f8f9fc", border:"1px solid #d0d5e8", borderRadius:10, padding:"12px 14px", fontSize:14, outline:"none", marginBottom:10 }} />
            <input type="password" placeholder="Confirm new password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)}
              style={{ width:"100%", background:"#f8f9fc", border:"1px solid #d0d5e8", borderRadius:10, padding:"12px 14px", fontSize:14, outline:"none", marginBottom:10 }} />
            {passwordMsg && <div style={{ fontSize:13, color: passwordMsg.includes("✅") ? "#00a651" : "#e53935", marginBottom:10 }}>{passwordMsg}</div>}
            <div style={{ display:"flex", gap:10, marginTop:8 }}>
              <button onClick={() => { setShowChangePassword(false); setNewPassword(""); setConfirmPassword(""); setPasswordMsg(""); }}
                style={{ flex:1, padding:"11px", background:"none", border:"1px solid #e0e4ee", borderRadius:10, color:"#666", fontSize:13, cursor:"pointer" }}>Cancel</button>
              <button onClick={async () => {
                if (!newPassword || newPassword.length < 6) return setPasswordMsg("❌ Password must be at least 6 characters");
                if (newPassword !== confirmPassword) return setPasswordMsg("❌ Passwords do not match");
                try {
                  const { updatePassword } = await import("firebase/auth");
                  await updatePassword(auth.currentUser, newPassword);
                  setPasswordMsg("✅ Password changed successfully!");
                  setTimeout(() => { setShowChangePassword(false); setNewPassword(""); setConfirmPassword(""); setPasswordMsg(""); }, 2000);
                } catch(e) {
                  if (e.code === "auth/requires-recent-login") {
                    setPasswordMsg("❌ Please log out and log back in first, then try again");
                  } else {
                    setPasswordMsg("❌ Error: " + e.message);
                  }
                }
              }} style={{ flex:2, padding:"11px", background:"#b00000", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:800, cursor:"pointer" }}>
                Update Password
              </button>
            </div>
          </div>
        </div>
      )}

      {showAdminLogin && (
        <div className="fade-in" style={{ position:"fixed", inset:0, background:"rgba(5,6,10,0.95)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div style={{ background:"#ffffff", border:"1px solid #d0d5e8", borderRadius:16, padding:32, width:"100%", maxWidth:360 }}>
            {!forgotAdmin ? (
              <>
                <div style={{ fontFamily:"var(--head)", fontSize:24, marginBottom:6 }}>ADMIN <span style={{ color:"#b00000" }}>LOGIN</span></div>
                <div style={{ fontSize:13, color:"#888", marginBottom:20 }}>Enter your admin password to continue</div>
                <input type="password" placeholder="Enter admin password" value={adminPass}
                  onChange={e => { setAdminPass(e.target.value); setAdminError(false); }}
                  onKeyDown={e => e.key==="Enter" && handleAdminLogin()}
                  style={{ width:"100%", background:"#f8f9fc", border:`1px solid ${adminError?"#e53935":"#d0d5e8"}`, borderRadius:10, padding:"12px 14px", color:"#111", fontSize:14, marginBottom:8, outline:"none" }} />
                {adminError && <div style={{ color:"#e53935", fontSize:12, marginBottom:8 }}>❌ Incorrect password. Try again.</div>}
                <div style={{ display:"flex", gap:10, marginTop:8 }}>
                  <button onClick={() => { setShowAdminLogin(false); setAdminPass(""); setAdminError(false); setForgotAdmin(false); }}
                    style={{ flex:1, padding:"11px", background:"none", border:"1px solid #e0e4ee", borderRadius:10, color:"#666", fontSize:13, cursor:"pointer" }}>Cancel</button>
                  <button onClick={handleAdminLogin}
                    style={{ flex:2, padding:"11px", background:"#b00000", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:800, cursor:"pointer" }}>Login →</button>
                </div>
                <div style={{ textAlign:"center", marginTop:16 }}>
                  <button onClick={() => { setForgotAdmin(true); setAdminError(false); setResetSent(false); setResetEmail(""); }}
                    style={{ background:"none", border:"none", color:"#b00000", fontSize:12, cursor:"pointer", textDecoration:"underline" }}>
                    Forgot password?
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{ fontFamily:"var(--head)", fontSize:24, marginBottom:6 }}>RESET <span style={{ color:"#b00000" }}>PASSWORD</span></div>
                <div style={{ fontSize:13, color:"#888", marginBottom:20 }}>
                  {resetSent ? "✅ Check your email for reset instructions!" : "Enter your admin email to receive password hint"}
                </div>
                {!resetSent ? (
                  <>
                    <input type="email" placeholder="Enter your admin email address" value={resetEmail}
                      onChange={e => setResetEmail(e.target.value)}
                      style={{ width:"100%", background:"#f8f9fc", border:"1px solid #d0d5e8", borderRadius:10, padding:"12px 14px", color:"#111", fontSize:14, marginBottom:16, outline:"none" }} />
                    <button onClick={() => {
                      if (!resetEmail) return;
                      // Only show hint to the REAL admin email
                      const ADMIN_EMAIL = "abrahamitodo7@gmail.com";
                      if (resetEmail.toLowerCase().trim() === ADMIN_EMAIL.toLowerCase()) {
                        setResetSent(true);
                      } else {
                        // Show same success message to prevent email enumeration
                        // but don't reveal the hint
                        setResetSent("fake");
                      }
                    }} style={{ width:"100%", background:"#b00000", color:"#fff", border:"none", borderRadius:10, padding:"12px", fontSize:14, fontWeight:800, cursor:"pointer", marginBottom:10 }}>
                      Verify Email →
                    </button>
                    <div style={{ background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:10, padding:"12px 14px", fontSize:12, color:"#888" }}>
                      🔒 Only the registered admin email can recover the password
                    </div>
                  </>
                ) : resetSent === "fake" ? (
                  <div style={{ background:"#edfff4", border:"1px solid #00a651", borderRadius:10, padding:"16px", fontSize:13, color:"#333", textAlign:"center" }}>
                    ✅ If that email is registered as admin, instructions have been sent.
                  </div>
                ) : (
                  <div style={{ background:"#edfff4", border:"1px solid #00a651", borderRadius:10, padding:"16px", fontSize:13, color:"#333", textAlign:"center" }}>
                    ✅ Email verified! Here is your password hint:<br/><br/>
                    <div style={{ background:"#fff8ee", border:"1px solid #f5a000", borderRadius:8, padding:"12px", marginTop:8, fontSize:13, color:"#b00000", fontWeight:700 }}>
                      💡 Your password = your name + "son" + wife's name + daughter's name + 2024
                    </div>
                    <div style={{ fontSize:12, color:"#888", marginTop:8 }}>
                      Example pattern: Ab + son + pat + ojima + 2024
                    </div>
                  </div>
                )}
                <button onClick={() => { setForgotAdmin(false); setResetSent(false); setResetEmail(""); }}
                  style={{ width:"100%", marginTop:14, padding:"10px", background:"none", border:"1px solid #e0e4ee", borderRadius:10, color:"#666", fontSize:13, cursor:"pointer" }}>
                  ← Back to Login
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", background:"#f0f2f5" }}>
        {/* Ticker */}
        <div style={{ background:"#8b0000", borderBottom:"1px solid #a00000", padding:"6px 0", overflow:"hidden", whiteSpace:"nowrap" }}>
          <div style={{ display:"inline-block", animation:"ticker 32s linear infinite", fontSize:12, color:"#ffffff", fontWeight:600 }}
            dangerouslySetInnerHTML={{__html: "&nbsp;&nbsp;" + (siteSettings.tickerText||"") + "&nbsp;&nbsp;"}} />
        </div>

        {/* Header */}
        <header style={{ background:"#b00000", borderBottom:"1px solid #8b0000", padding:"0 40px", position:"sticky", top:0, zIndex:100, backdropFilter:"blur(12px)" }} className="px-page">
          <div style={{ maxWidth:1200, margin:"0 auto", display:"flex", alignItems:"center", justifyContent:"space-between", height:62 }}>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <div style={{ width:34, height:34, background:"#ffffff", borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>⚽</div>
              <div>
                <div style={{ fontFamily:"var(--head)", fontSize:24, letterSpacing:"2px", lineHeight:1, color:"#ffffff" }}>BET<span style={{ color:"#ffe066" }}>GURU</span></div>
                <div style={{ fontSize:12, color:"#ffffff", letterSpacing:"0.5px" }}>🇳🇬 NIGERIA · 🇬🇭 GHANA · 🇰🇪 KENYA</div>
              </div>
            </div>

            <nav className="hide-mobile" style={{ display:"flex", gap:4, alignItems:"center" }}>
              {[
                { id:"today",       label:"⚽ Picks" },
                { id:"odds",        label:"💰 Odds" },
                { id:"sporty",      label:"SportyBet" },
                { id:"results",     label:"Results" },
                { id:"leaderboard", label:"🏆 Board" },
              ].map(n => (
                <button key={n.id} onClick={() => setTab(n.id)}
                  style={{ background:tab===n.id?"rgba(255,255,255,0.2)":"transparent", border:tab===n.id?"1px solid rgba(255,255,255,0.5)":"1px solid transparent", color:"#ffffff", padding:"7px 14px", borderRadius:8, fontSize:13, fontWeight:600, transition:"all 0.2s", whiteSpace:"nowrap", cursor:"pointer" }}>
                  {n.label}
                </button>
              ))}
              {/* More dropdown */}
              <div style={{ position:"relative" }} className="more-menu-wrap">
                <button onClick={(e) => { e.stopPropagation(); setShowMoreMenu(prev => !prev); }}
                  style={{ background:["how","profile","referral"].includes(tab)?"rgba(255,255,255,0.2)":"transparent", border:["how","profile","referral"].includes(tab)?"1px solid rgba(255,255,255,0.5)":"1px solid transparent", color:"#ffffff", padding:"7px 14px", borderRadius:8, fontSize:13, fontWeight:600, cursor:"pointer" }}>
                  More ▾
                </button>
                {showMoreMenu && (
                  <div style={{ position:"absolute", top:"110%", right:0, background:"#ffffff", borderRadius:12, boxShadow:"0 8px 32px rgba(0,0,0,0.15)", border:"1px solid #e0e4ee", minWidth:180, zIndex:200, overflow:"hidden" }}>
                    {[
                      { id:"how",          label:"❓ How It Works" },
                      { id:"testimonials", label:"⭐ Reviews" },
                      { id:"profile",      label: isSubscribed ? "👤 My Account" : "👤 Profile" },
                      ...(siteSettings.referralActive !== false ? [{ id:"referral", label:"🔗 Refer & Earn" }] : []),
                    ].map(n => (
                      <button key={n.id} onClick={() => { setTab(n.id); setShowMoreMenu(false); }}
                        style={{ width:"100%", padding:"12px 18px", background:tab===n.id?"#fff0f0":"#fff", border:"none", borderBottom:"1px solid #f0f0f0", color:tab===n.id?"#b00000":"#111", fontSize:14, fontWeight:600, textAlign:"left", cursor:"pointer" }}>
                        {n.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </nav>

            <div style={{ display:"flex", gap:10, alignItems:"center" }}>
              <button onClick={() => setCurrency(c => c==="NGN"?"GHS":c==="GHS"?"KES":"NGN")} className="hide-mobile" style={{ background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.3)", color:"#ffffff", padding:"6px 14px", borderRadius:20, fontSize:11, fontWeight:700 }}>
                {currency==="NGN" ? "🇳🇬 ₦" : currency==="GHS" ? "🇬🇭 GH₵" : "🇰🇪 KSh"}
              </button>
              {isSubscribed ? (
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                {subExpiry && Math.ceil((subExpiry - new Date())/(1000*60*60*24)) <= 3 ? (
                  <button onClick={() => setShowModal(true)} style={{ background:"#e53935", color:"#fff", border:"none", borderRadius:20, padding:"7px 16px", fontSize:12, fontWeight:800, cursor:"pointer", animation:"pulse-btn 1.5s infinite" }}>
                    ⚠️ Expires in {Math.ceil((subExpiry - new Date())/(1000*60*60*24))}d — Renew!
                  </button>
                ) : (
                  <div style={{ background:"rgba(245,160,0,0.15)", border:"1px solid rgba(245,160,0,0.4)", color:"#f5a000", padding:"7px 16px", borderRadius:20, fontSize:12, fontWeight:800 }}>✓ SUBSCRIBED</div>
                )}
                <button onClick={() => { signOut(auth); setIsSubscribed(false); }} style={{ background:"none", border:"none", color:"#ffcccc", fontSize:11, cursor:"pointer" }}>Sign out</button>
              </div>
              ) : (
                <button onClick={() => { setShowModal(true); window.gtag?.("event","subscribe_click",{event_category:"conversion"}); window.fbq?.("track","InitiateCheckout"); }} style={{ background:"#f5a000", color:"#ffffff", border:"2px solid #ffe066", borderRadius:10, padding:"9px 16px", fontSize:13, fontWeight:800, cursor:"pointer", fontFamily:"var(--head)", letterSpacing:"0.5px", boxShadow:"0 4px 14px rgba(245,160,0,0.5)", animation:"pulse-btn 2s infinite" }}>💰 Subscribe</button>
              )}
              <button onClick={() => {
                if (Notification.permission !== "granted") {
                  Notification.requestPermission().then(p => {
                    if (p === "granted") alert("✅ Notifications enabled!");
                  });
                } else {
                  alert("✅ Notifications are already enabled!");
                }
              }} className="hide-mobile" style={{ background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.4)", color:"#ffffff", fontSize:13, cursor:"pointer", padding:"8px 12px", borderRadius:8 }} title="Enable notifications">
                🔔
              </button>
              {!isSubscribed && (
                <button onClick={() => setShowLoginModal(true)} style={{ background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.4)", color:"#ffffff", fontSize:13, fontWeight:700, cursor:"pointer", padding:"8px 14px", borderRadius:8, whiteSpace:"nowrap" }}>🔑 Login</button>
              )}
              <button onClick={() => setShowAdminLogin(true)} className="hide-mobile" style={{ background:"none", border:"none", color:"rgba(255,255,255,0.5)", fontSize:11, cursor:"pointer", padding:"4px 8px" }}>Admin</button>
            </div>
          </div>
        </header>

        <main style={{ flex:1, maxWidth:1200, margin:"0 auto", width:"100%", padding:"32px 40px 64px" }} className="px-page">

          {/* TODAY'S PICKS */}
          {tab === "today" && (
            <div className="fade-up">
              <div style={{ background:"linear-gradient(135deg,#8b0000,#c00000,#8b0000)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:20, padding:"36px 40px", marginBottom:32, display:"flex", justifyContent:"space-between", alignItems:"center", position:"relative", overflow:"hidden" }} className="stripe-bg">
                <div style={{ position:"absolute", right:-40, top:-40, width:200, height:200, borderRadius:"50%", background:"radial-gradient(circle,rgba(200,255,0,0.06) 0%,transparent 70%)" }} />
                <div>
                  <Tag color="#ffffff" bg="rgba(255,255,255,0.25)">📅 {new Date().toLocaleDateString("en-NG",{ weekday:"long", day:"numeric", month:"long", year:"numeric" })}</Tag>
                  <div style={{ fontFamily:"var(--head)", fontSize:52, lineHeight:1.05, marginTop:10, letterSpacing:"1px", color:"#ffffff" }} className="hero-text">
                    {siteSettings.heroTitle||"TODAY'S PICKS"}
                  </div>
                  <div style={{ fontSize:15, color:"#ffffff", marginTop:8, fontWeight:500 }}>{predictions.length} predictions posted · {siteSettings.heroSubtitle||"Updated every morning by 10AM WAT"}</div>

                </div>
                <div style={{ display:"flex", gap:24 }} className="hero-stat">
                  {[ {val:(siteSettings.accuracy||"92")+"%",label:"Accuracy"}, {val:predictions.filter(p=>p.tier==="free").length,label:"Free Picks"}, {val:predictions.filter(p=>p.tier==="premium").length,label:"Premium"} ].map((s,i) => (
                    <div key={i} style={{ textAlign:"center" }}>
                      <div style={{ fontFamily:"var(--head)", fontSize:40, color:"#ffffff", lineHeight:1 }}>{s.val}</div>
                      <div style={{ fontSize:13, color:"rgba(255,255,255,0.8)", marginTop:4 }}>{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Expiry reminder banner */}
              {isSubscribed && subExpiry && Math.ceil((subExpiry - new Date())/(1000*60*60*24)) <= 3 && (
                <div style={{ background:"linear-gradient(135deg,#e53935,#f44336)", borderRadius:14, padding:"14px 20px", marginBottom:20, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                  <div>
                    <div style={{ fontWeight:800, fontSize:15, color:"#fff", marginBottom:2 }}>
                      ⏰ Your subscription expires in {Math.ceil((subExpiry - new Date())/(1000*60*60*24))} day{Math.ceil((subExpiry - new Date())/(1000*60*60*24))!==1?"s":""}!
                    </div>
                    <div style={{ fontSize:13, color:"rgba(255,255,255,0.9)" }}>Renew now to keep access to all premium picks</div>
                  </div>
                  <button onClick={() => setShowModal(true)} style={{ background:"#fff", color:"#e53935", border:"none", borderRadius:10, padding:"10px 20px", fontSize:14, fontWeight:800, cursor:"pointer", whiteSpace:"nowrap" }}>
                    🔄 Renew Now
                  </button>
                </div>
              )}

              {/* Free picks anchor */}
              <div id="free-picks-anchor" />

              {!isSubscribed && (
                <div style={{ background:"linear-gradient(135deg,#b00000,#d00000,#b00000)", border:"2px solid #f5a000", borderRadius:16, padding:"20px 24px", marginBottom:24, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12, boxShadow:"0 4px 20px rgba(176,0,0,0.25)" }}>
                  <div>
                    <div style={{ fontWeight:800, fontSize:17, marginBottom:6, color:"#ffe066" }}>🔒 Unlock All Premium Picks & Booking Codes</div>
                    <div style={{ fontSize:14, color:"rgba(255,255,255,0.95)", marginBottom:4 }}>{siteSettings.subscribeMsg||"Subscribe from ₦1,500/week to unlock all booking codes and analysis"}</div>
                    <div style={{ fontSize:12, color:"rgba(255,255,255,0.9)" }}>✅ Instant access &nbsp;&nbsp;·&nbsp;&nbsp; ✅ All leagues &nbsp;&nbsp;·&nbsp;&nbsp; ✅ Cancel anytime</div>
                  </div>
                  <button onClick={() => setShowModal(true)} style={{ background:"#f5a000", color:"#ffffff", border:"2px solid #ffe066", borderRadius:12, padding:"14px 32px", fontSize:16, fontWeight:800, cursor:"pointer", letterSpacing:"0.5px", boxShadow:"0 4px 16px rgba(245,160,0,0.5)", whiteSpace:"nowrap" }}>💰 Subscribe Now →</button>
                </div>
              )}

              <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:24 }}>
                {leagues.map(l => (
                  <button key={l} onClick={() => setLeagueFilter(l)} style={{ background:leagueFilter===l?"#b00000":"#ffffff", border:leagueFilter===l?"none":"1px solid #e0e4ee", color:leagueFilter===l?"#ffffff":"#555f7a", padding:"7px 18px", borderRadius:20, fontSize:12, fontWeight:700, transition:"all 0.2s" }}>{l}</button>
                ))}
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(360px,1fr))", gap:16 }} className="grid-2">
                {filtered.map(p => <PredictionCard key={p.id} p={p} isSubscribed={isSubscribed} onUpgrade={() => setShowModal(true)} />)}
              </div>
            </div>
          )}

          {/* ODDS PACKAGES TAB */}
          {tab === "odds" && (
            <div className="fade-up">
              <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:8 }}>
                ODDS <span style={{ color:"#f5a000" }}>PACKAGES</span>
              </div>
              <div style={{ fontSize:14, color:"#555f7a", marginBottom:32 }}>Pick your risk level. From free daily picks to massive accumulators — every bettor covered.</div>

              {Object.entries(oddsPackages).map(([key, pkg]) => {
                const isFree = key === "free";
                const locked = !isFree && !isSubscribed;
                const totalOdds = pkg.games.reduce((acc, g) => acc * parseFloat(g.odds || 1), 1).toFixed(2);
                const meta = PKG_META.find(m => m.key === key) || {};
                return (
                  <div key={key} style={{ background:"#ffffff", border:`2px solid ${locked?"#e0e4ee":meta.color||"#444"}33`, borderRadius:20, marginBottom:20, overflow:"hidden" }}>
                    <div style={{ background:locked?"#f5f5f5":`linear-gradient(135deg,${meta.color||"#444"}18,${meta.color||"#444"}08)`, borderBottom:`1px solid ${meta.color||"#444"}22`, padding:"18px 24px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                        <div style={{ fontSize:36 }}>{pkg.emoji}</div>
                        <div>
                          <div style={{ fontFamily:"var(--head)", fontSize:28, letterSpacing:"1px", color:locked?"#666666":meta.color }}>{pkg.label}</div>
                          <div style={{ fontSize:12, color:"#555f7a", marginTop:2 }}>{pkg.desc}</div>
                          {pkg.packageDate && <div style={{marginTop:4,fontSize:11,fontWeight:700,color:"#4488ff",background:"rgba(68,136,255,0.1)",display:"inline-block",borderRadius:6,padding:"2px 9px"}}>
                            📅 {new Date(pkg.packageDate+"T00:00:00").toLocaleDateString("en-NG",{weekday:"long",day:"numeric",month:"long",year:"numeric"})}
                          </div>}
                        </div>
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:20 }}>
                        <div style={{ textAlign:"center" }}>
                          <div style={{ fontSize:12, color:"#888888", fontWeight:700 }}>TOTAL ODDS</div>
                          <div style={{ fontFamily:"var(--head)", fontSize:32, color:locked?"#888888":meta.color, filter:locked?"blur(5px)":"none" }}>{totalOdds}</div>
                        </div>
                        <div style={{ textAlign:"center" }}>
                          <div style={{ fontSize:12, color:"#888888", fontWeight:700 }}>GAMES</div>
                          <div style={{ fontFamily:"var(--head)", fontSize:32, color:"#111318" }}>{pkg.games.length}</div>
                        </div>
                        <div style={{ background:isFree?"rgba(0,166,81,0.15)":"rgba(68,136,255,0.15)", border:`1px solid ${isFree?"rgba(0,166,81,0.4)":"rgba(68,136,255,0.4)"}`, color:isFree?"#00a651":"#4488ff", fontSize:11, fontWeight:800, padding:"4px 12px", borderRadius:20 }}>{isFree?"FREE":"PREMIUM"}</div>
                      </div>
                    </div>

                    {locked ? (
                      <div style={{ padding:"32px", textAlign:"center" }}>
                        <div style={{ fontSize:32, marginBottom:12 }}>🔒</div>
                        <div style={{ fontWeight:700, fontSize:15, marginBottom:6 }}>Subscribe to unlock {pkg.label}</div>
                        <div style={{ fontSize:13, color:"#555f7a", marginBottom:16 }}>Get access from ₦1,500/week</div>
                        <button onClick={() => setShowModal(true)} className="btn-primary" style={{ padding:"10px 28px" }}>Subscribe Now →</button>
                      </div>
                    ) : (
                      <div style={{ padding:"16px 24px" }}>
                        {pkg.games.length === 0 ? (
                          <div style={{ textAlign:"center", padding:"20px", color:"#555f7a", fontSize:13 }}>No games posted yet for this package. Check back soon.</div>
                        ) : pkg.games.map((g, i) => (
                          <div key={g.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"13px 0", borderBottom:i<pkg.games.length-1?"1px solid #e0e4ee":"none", flexWrap:"wrap", gap:8 }}>
                            <div style={{ display:"flex", alignItems:"center", gap:12, flex:1 }}>
                              <div style={{ width:28, height:28, borderRadius:"50%", background:`${meta.color||"#444"}22`, border:`1px solid ${meta.color||"#444"}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:800, color:meta.color, flexShrink:0 }}>{i+1}</div>
                              <div style={{ flex:1 }}>
                                <div style={{ fontSize:14, fontWeight:800 }}>{g.home} <span style={{ color:"#555f7a", fontWeight:400 }}>vs</span> {g.away}</div>
                                <div style={{ fontSize:11, color:"#555f7a", marginTop:3, display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                                  <span>{g.league}</span>
                                  {g.date && <span style={{ background:"rgba(68,136,255,0.12)", color:"#4488ff", borderRadius:6, padding:"1px 7px", fontSize:12, fontWeight:700 }}>📅 {new Date(g.date+"T00:00:00").toLocaleDateString("en-NG",{weekday:"short",day:"numeric",month:"short"})}</span>}
                                  {g.time && <span style={{ background:"rgba(255,184,0,0.12)", color:"#e6a800", borderRadius:6, padding:"1px 7px", fontSize:12, fontWeight:700 }}>⏰ {g.time}</span>}
                                </div>
                              </div>
                            </div>
                            <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
                              <div style={{ background:"#f8f9fc", border:"1px solid #d0d5e8", borderRadius:8, padding:"6px 14px", fontSize:13, fontWeight:700 }}>{g.tip}</div>
                              <div style={{ background:`${meta.color||"#444"}18`, border:`1px solid ${meta.color||"#444"}44`, borderRadius:8, padding:"6px 14px", fontFamily:"var(--head)", fontSize:20, fontWeight:900, color:meta.color, minWidth:60, textAlign:"center" }}>{g.odds}</div>
                            </div>
                          </div>
                        ))}
                        {pkg.games.length > 0 && (
                          <div style={{ marginTop:16, padding:"12px 16px", background:`${meta.color||"#444"}0d`, border:`1px solid ${meta.color||"#444"}22`, borderRadius:12, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                            <span style={{ fontSize:13, color:"#555f7a", fontWeight:600 }}>Combined Odds</span>
                            <span style={{ fontFamily:"var(--head)", fontSize:28, color:meta.color, fontWeight:900 }}>{totalOdds}x</span>
                          </div>
                        )}
                        {/* Package Booking Codes */}
                        {(pkg.bookingCodeBet9ja || pkg.bookingCodeSporty || pkg.bookingCodeBetKing) && (
                          <div style={{ marginTop:12, background:"#f8f9fc", border:"1px solid #e0e4ee", borderRadius:12, padding:"14px 16px" }}>
                            <div style={{ fontSize:11, fontWeight:800, color:"#888", letterSpacing:"1px", marginBottom:10 }}>📋 PACKAGE BOOKING CODES</div>
                            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                              {pkg.bookingCodeBet9ja && (
                                <div style={{ background:"#fff", border:"1px solid #00a651", borderRadius:8, padding:"8px 12px", display:"flex", alignItems:"center", gap:8, flex:1, minWidth:140 }}>
                                  <div>
                                    <div style={{ fontSize:10, fontWeight:700, color:"#00a651" }}>BET9JA</div>
                                    <div style={{ fontFamily:"monospace", fontSize:14, fontWeight:800, color:"#111" }}>{pkg.bookingCodeBet9ja}</div>
                                  </div>
                                  <button onClick={()=>navigator.clipboard?.writeText(pkg.bookingCodeBet9ja)} style={{ marginLeft:"auto", background:"#edfff4", border:"none", borderRadius:6, padding:"4px 8px", fontSize:11, color:"#00a651", fontWeight:700, cursor:"pointer" }}>Copy</button>
                                </div>
                              )}
                              {pkg.bookingCodeSporty && (
                                <div style={{ background:"#fff", border:"1px solid #ff6b00", borderRadius:8, padding:"8px 12px", display:"flex", alignItems:"center", gap:8, flex:1, minWidth:140 }}>
                                  <div>
                                    <div style={{ fontSize:10, fontWeight:700, color:"#ff6b00" }}>SPORTYBET</div>
                                    <div style={{ fontFamily:"monospace", fontSize:14, fontWeight:800, color:"#111" }}>{pkg.bookingCodeSporty}</div>
                                  </div>
                                  <button onClick={()=>navigator.clipboard?.writeText(pkg.bookingCodeSporty)} style={{ marginLeft:"auto", background:"#fff8f0", border:"none", borderRadius:6, padding:"4px 8px", fontSize:11, color:"#ff6b00", fontWeight:700, cursor:"pointer" }}>Copy</button>
                                </div>
                              )}
                              {pkg.bookingCodeBetKing && (
                                <div style={{ background:"#fff", border:"1px solid #7c3aed", borderRadius:8, padding:"8px 12px", display:"flex", alignItems:"center", gap:8, flex:1, minWidth:140 }}>
                                  <div>
                                    <div style={{ fontSize:10, fontWeight:700, color:"#7c3aed" }}>BETKING</div>
                                    <div style={{ fontFamily:"monospace", fontSize:14, fontWeight:800, color:"#111" }}>{pkg.bookingCodeBetKing}</div>
                                  </div>
                                  <button onClick={()=>navigator.clipboard?.writeText(pkg.bookingCodeBetKing)} style={{ marginLeft:"auto", background:"#f5f0ff", border:"none", borderRadius:6, padding:"4px 8px", fontSize:11, color:"#7c3aed", fontWeight:700, cursor:"pointer" }}>Copy</button>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {/* SPORTYBET TAB */}
          {tab === "sporty" && (
            <div className="fade-up">
              <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:8 }}>
                <span style={{ color:"#ff6b00" }}>SPORTYBET</span> CODES
              </div>
              <div style={{ fontSize:14, color:"#555f7a", marginBottom:4 }}>All today's picks with dedicated SportyBet booking codes. Works on Nigeria 🇳🇬, Ghana 🇬🇭 & Kenya 🇰🇪.</div>
              <SportyBetSection predictions={predictions} isSubscribed={isSubscribed} onUpgrade={() => setShowModal(true)} />
            </div>
          )}

          {/* RESULTS */}
          {tab === "results" && (
            <div className="fade-up">
              <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:8 }}>TRACK <span style={{ color:"#f5a000" }}>RECORD</span></div>
              <div style={{ fontSize:14, color:"#555f7a", marginBottom:32 }}>100% transparent. Every pick we've posted, with verified results.</div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:16, marginBottom:32 }} className="grid-3">
                {[
                  { icon:"✅", val:siteSettings.wonThisMonth||"110",  label:"Won This Month",  color:"#f5a000" },
                  { icon:"❌", val:siteSettings.lostThisMonth||"10",   label:"Lost This Month", color:"#e53935" },
                  { icon:"🎯", val:(siteSettings.accuracy||"92")+"%",  label:"Accuracy Rate",   color:"#f5a000" },
                ].map((s,i) => (
                  <div key={i} className="card-base" style={{ padding:"28px", textAlign:"center" }}>
                    <div style={{ fontSize:32, marginBottom:10 }}>{s.icon}</div>
                    <div style={{ fontFamily:"var(--head)", fontSize:56, color:s.color, lineHeight:1 }}>{s.val}</div>
                    <div style={{ fontSize:13, color:"#555f7a", marginTop:6 }}>{s.label}</div>
                  </div>
                ))}
              </div>
              <div className="card-base" style={{ overflow:"hidden" }}>
                <div style={{ padding:"16px 24px", borderBottom:"1px solid rgba(255,255,255,0.15)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div style={{ fontFamily:"var(--head)", fontSize:20, letterSpacing:"1px" }}>RECENT PICKS</div>
                  <Tag color="#f5a000">LAST 12</Tag>
                </div>
                {resultsData.map((r,i) => (
                  <div key={i} style={{ padding:"14px 24px", borderBottom:i<resultsData.length-1?"1px solid #e0e4ee":"none", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:16 }}>
                      <div style={{ width:34, height:34, borderRadius:9, background:r.r==="WON"?"rgba(200,255,0,0.08)":"rgba(255,71,87,0.08)", border:`1px solid ${r.r==="WON"?"rgba(200,255,0,0.25)":"rgba(255,71,87,0.25)"}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14 }}>
                        {r.r==="WON"?"✅":"❌"}
                      </div>
                      <div>
                        <div style={{ fontSize:14, fontWeight:700 }}>{r.m}</div>
                        <div style={{ fontSize:11, color:"#888888", marginTop:2 }}>{r.p} · {r.l} · {r.d}</div>
                      </div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:16 }}>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ fontSize:12, color:"#888888" }}>Odds</div>
                        <div style={{ fontSize:15, fontWeight:800 }}>{r.o}</div>
                      </div>
                      <div style={{ width:72, textAlign:"center", padding:"6px 0", borderRadius:8, background:r.r==="WON"?"rgba(0,166,81,0.1)":"rgba(229,57,53,0.1)", border:`1px solid ${r.r==="WON"?"rgba(0,166,81,0.3)":"rgba(229,57,53,0.3)"}`, color:r.r==="WON"?"#00a651":"#e53935", fontSize:12, fontWeight:800 }}>
                        {r.r}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* HOW IT WORKS */}
          {tab === "how" && (
            <div className="fade-up">
              <div style={{ textAlign:"center", marginBottom:48 }}>
                <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:10 }}>HOW <span style={{ color:"#f5a000" }}>IT WORKS</span></div>
                <div style={{ fontSize:15, color:"#555f7a", maxWidth:500, margin:"0 auto" }}>We post codes. You place on your platform. No bets on our side — just expert analysis and booking codes delivered to your screen.</div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:20, marginBottom:48 }} className="grid-4">
                {[
                  { step:"01", icon:"🔐", title:"Subscribe", desc:"Choose weekly, monthly or 3-month plan. Pay via Paystack, MTN MoMo, or USSD. Access is instant." },
                  { step:"02", icon:"📊", title:"Get Predictions", desc:"Analysts post picks daily with full analysis, confidence scores, and booking codes for multiple platforms." },
                  { step:"03", icon:"📋", title:"Copy Your Code", desc:"See codes for Bet9ja, SportyBet, BetWay GH and more. Tap copy and open your bookmaker app." },
                  { step:"04", icon:"💰", title:"Place the Bet", desc:"Enter the code in your bookmaker's 'Booking' section. The bet slip loads automatically — just stake and confirm." },
                ].map((s,i) => (
                  <div key={i} className="card-base" style={{ padding:"28px 24px" }}>
                    <div style={{ fontFamily:"var(--head)", fontSize:48, color:"rgba(200,255,0,0.15)", lineHeight:1, marginBottom:12 }}>{s.step}</div>
                    <div style={{ fontSize:32, marginBottom:12 }}>{s.icon}</div>
                    <div style={{ fontSize:16, fontWeight:800, marginBottom:8 }}>{s.title}</div>
                    <div style={{ fontSize:13, color:"#555f7a", lineHeight:1.65 }}>{s.desc}</div>
                  </div>
                ))}
              </div>

              {/* Platforms */}
              <div className="card-base" style={{ padding:"24px 28px", marginBottom:32 }}>
                <div style={{ fontFamily:"var(--head)", fontSize:22, letterSpacing:"1px", marginBottom:16 }}>SUPPORTED <span style={{ color:"#f5a000" }}>PLATFORMS</span></div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(170px,1fr))", gap:12 }}>
                  {[
                    { name:"Bet9ja",    market:"🇳🇬", color:"#00a651" },
                    { name:"SportyBet", market:"🇳🇬🇬🇭", color:"#ff6b00" },
                    { name:"BetWay GH", market:"🇬🇭", color:"#e91e63" },
                    { name:"1xBet",     market:"🇳🇬🇬🇭", color:"#1976d2" },
                    { name:"Melbet",    market:"🇳🇬🇬🇭", color:"#e53935" },
                    { name:"BetKing",   market:"🇳🇬", color:"#7c3aed" },
                    { name:"NairaBet",  market:"🇳🇬", color:"#ff9800" },
                  ].map((bm,i) => (
                    <div key={i} style={{ background:"#f8f9fc", borderRadius:12, padding:"12px 16px", border:`1px solid ${bm.color}44`, display:"flex", alignItems:"center", gap:10 }}>
                      <div style={{ width:10, height:10, borderRadius:"50%", background:bm.color, flexShrink:0 }} />
                      <div>
                        <div style={{ fontSize:13, fontWeight:700 }}>{bm.name}</div>
                        <div style={{ fontSize:11, color:"#888888" }}>{bm.market}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Pricing */}
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:16, marginBottom:40 }} className="grid-3">
                {plans.map(plan => (
                  <div key={plan.id} style={{ background:plan.popular?"linear-gradient(160deg,#fff8ee,#fff0d0,#fff8ee)":"#ffffff", border:`2px solid ${plan.popular?"#f5a000":plan.id==="quarterly"?"rgba(245,160,0,0.4)":"#e0e4ee"}`, borderRadius:20, overflow:"hidden", position:"relative", boxShadow:plan.popular?"0 0 32px rgba(0,200,83,0.15)":"none" }}>
                    {plan.badge && <div style={{ background:"#f5a000", color:"#ffffff", fontSize:13, fontWeight:800, textAlign:"center", padding:"6px", letterSpacing:"1px" }}>{plan.badge}</div>}
                    <div style={{ padding:"24px" }}>
                      <div style={{ fontSize:12, fontWeight:700, color:plan.color, letterSpacing:"1px", marginBottom:8 }}>{plan.name.toUpperCase()}</div>
                      <div style={{ fontFamily:"var(--head)", fontSize:44, color:plan.color, lineHeight:1, marginBottom:2 }}>
                        {currency==="NGN" ? `₦${plan.ngnVal.toLocaleString()}` : currency==="GHS" ? toGHS(plan.ngnVal) : toKES(plan.ngnVal)}
                      </div>
                      <div style={{ fontSize:11, color:"#888888", marginBottom:16 }}>
                        {plan.period} · {plan.perDay}
                        {currency==="GHS" && <span style={{ color:"rgba(200,255,0,0.5)", display:"block", marginTop:2 }}>≈ ₦{plan.ngnVal.toLocaleString()} · Rate: 1 GH₵=₦128.39</span>}
                      </div>
                      {plan.features.map((f,i) => (
                        <div key={i} style={{ display:"flex", gap:10, marginBottom:8, alignItems:"flex-start" }}>
                          <span style={{ color:plan.color, fontSize:14, flexShrink:0, marginTop:1 }}>✓</span>
                          <span style={{ fontSize:13, color:"#ccc", fontWeight:400 }}>{f}</span>
                        </div>
                      ))}
                      <button onClick={() => setShowModal(true)} style={{ width:"100%", marginTop:16, borderRadius:12, padding:"13px", fontSize:13, fontWeight:800, border:"none", background:plan.popular?"#f5a000":plan.id==="quarterly"?"#b00000":"#f0f0f0", color:plan.popular||plan.id==="quarterly"?"#ffffff":"#666666", cursor:"pointer" }}>
                        {plan.cta}
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ maxWidth:680, margin:"0 auto" }}>
                <div style={{ fontFamily:"var(--head)", fontSize:32, letterSpacing:"1px", marginBottom:24, textAlign:"center" }}>FAQ</div>
                {[
                  { q:"What is a booking code?", a:"A booking code is generated by the bookmaker and loads a pre-built bet slip. You enter it on your bookmaker's website or app under 'Booking Code' or 'My Bets', and the bet loads automatically — you just choose your stake." },
                  { q:"Do you have SportyBet codes for Ghana and Nigeria?", a:"Yes! Every prediction we post includes a SportyBet code that works on both SportyBet Nigeria and SportyBet Ghana. We also post codes for Bet9ja, BetWay GH, 1xBet, and more where available." },
                  { q:"Do I place bets on your app?", a:"No. BetGuru is a prediction and booking code delivery service. You take the code to your bookmaker of choice (Bet9ja, SportyBet, BetWay, etc.) and place the bet there. We have no affiliation with any bookmaker." },
                  { q:"When are predictions posted?", a:"Analysts post predictions daily between 8AM–12PM WAT, well before kick-off so you have time to review, load the code, and place your bet." },
                  { q:"How are prices calculated for Ghana and Kenya?", a:`We use live mid-market exchange rates. Currently 1 GH₵ = ₦128.39 NGN and 1 KSh = ₦0.098 NGN (as of March 2026). So our monthly plan at ₦4,999 = ${toGHS(4999)} or ${toKES(4999)}.` },
                ].map((f,i) => <FaqItem key={i} q={f.q} a={f.a} />)}
              </div>

              <div style={{ marginTop:48, textAlign:"center" }}>
                <button onClick={() => setShowModal(true)} className="btn-primary" style={{ fontSize:16, padding:"14px 48px" }}>Get Started Today →</button>
                <div style={{ fontSize:12, color:"#888888", marginTop:12 }}>From {currency==="NGN"?"₦1,500/week":currency==="GHS"?"GH₵12/week":"KSh15,345/week"} · Cancel anytime · Instant access</div>
              </div>
            </div>
          )}

          {/* ── PROFILE / MY ACCOUNT ── */}
          {tab === "profile" && (
            <div className="fade-up">
              {isSubscribed && firebaseUser ? (
                <div>
                  {/* Header */}
                  <div style={{ background:"linear-gradient(135deg,#8b0000,#c00000)", borderRadius:20, padding:"32px", marginBottom:24, color:"#fff", position:"relative", overflow:"hidden" }}>
                    <div style={{ position:"absolute", right:-20, top:-20, width:150, height:150, borderRadius:"50%", background:"rgba(255,255,255,0.05)" }} />
                    <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:20 }}>
                      <div style={{ width:64, height:64, borderRadius:"50%", background:"#f5a000", display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, fontWeight:800, color:"#fff" }}>
                        {(firebaseUser.email||"U")[0].toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontFamily:"var(--head)", fontSize:24, letterSpacing:"1px" }}>MY ACCOUNT</div>
                        <div style={{ fontSize:13, color:"rgba(255,255,255,0.8)", marginTop:2 }}>{firebaseUser.email}</div>
                      </div>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }} className="grid-3">
                      {[
                        { icon:"✅", label:"Status", val:"ACTIVE" },
                        { icon:"📅", label:"Expires", val: subExpiry ? subExpiry.toLocaleDateString("en-NG",{day:"numeric",month:"short",year:"numeric"}) : "—" },
                        { icon:"📦", label:"Plan", val: subExpiry ? (subExpiry - new Date() > 60*24*60*60*1000 ? "3 Months" : subExpiry - new Date() > 20*24*60*60*1000 ? "Monthly" : "Weekly") : "—" },
                      ].map((s,i) => (
                        <div key={i} style={{ background:"rgba(255,255,255,0.1)", borderRadius:12, padding:"14px", textAlign:"center" }}>
                          <div style={{ fontSize:20, marginBottom:6 }}>{s.icon}</div>
                          <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginBottom:4 }}>{s.label}</div>
                          <div style={{ fontSize:14, fontWeight:800 }}>{s.val}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Days remaining bar */}
                  {subExpiry && (() => {
                    const daysLeft = Math.max(0, Math.ceil((subExpiry - new Date()) / (1000*60*60*24)));
                    const totalDays = subExpiry - new Date() > 60*24*60*60*1000 ? 90 : subExpiry - new Date() > 20*24*60*60*1000 ? 30 : 7;
                    const pct = Math.min(100, Math.round((daysLeft/totalDays)*100));
                    return (
                      <div style={{ background:"#fff", borderRadius:16, padding:"20px 24px", marginBottom:16, border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
                        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
                          <div style={{ fontSize:14, fontWeight:700, color:"#111" }}>⏳ Subscription Remaining</div>
                          <div style={{ fontSize:14, fontWeight:800, color: daysLeft <= 2 ? "#e53935" : "#00a651" }}>{daysLeft} day{daysLeft!==1?"s":""} left</div>
                        </div>
                        <div style={{ background:"#f0f0f0", borderRadius:8, height:10, overflow:"hidden" }}>
                          <div style={{ width:`${pct}%`, height:"100%", background: daysLeft<=2?"#e53935":daysLeft<=7?"#f5a000":"#00a651", borderRadius:8, transition:"width 0.5s" }} />
                        </div>
                        <div style={{ fontSize:12, color:"#888", marginTop:8 }}>Expires on {subExpiry.toLocaleDateString("en-NG",{weekday:"long",day:"numeric",month:"long",year:"numeric"})}</div>
                      </div>
                    );
                  })()}

                  {/* Quick actions */}
                  <div style={{ background:"#fff", borderRadius:16, padding:"20px 24px", marginBottom:16, border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
                    <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:16 }}>⚡ Quick Actions</div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                      <button onClick={() => setShowModal(true)} style={{ background:"#f5a000", color:"#fff", border:"none", borderRadius:12, padding:"14px", fontSize:14, fontWeight:800, cursor:"pointer" }}>
                        🔄 Renew / Upgrade
                      </button>
                      <button onClick={() => setTab("today")} style={{ background:"#b00000", color:"#fff", border:"none", borderRadius:12, padding:"14px", fontSize:14, fontWeight:800, cursor:"pointer" }}>
                        ⚽ View Picks
                      </button>
                      <button onClick={() => setTab("odds")} style={{ background:"#fff", color:"#111", border:"2px solid #e0e4ee", borderRadius:12, padding:"14px", fontSize:14, fontWeight:700, cursor:"pointer" }}>
                        💰 Odds Packages
                      </button>
                      <button onClick={() => setShowChangePassword(true)} style={{ background:"#fff", color:"#4488ff", border:"2px solid #4488ff33", borderRadius:12, padding:"14px", fontSize:14, fontWeight:700, cursor:"pointer" }}>
                        🔑 Change Password
                      </button>
                      <button onClick={() => { signOut(auth); setIsSubscribed(false); setTab("today"); }} style={{ background:"#fff", color:"#e53935", border:"2px solid #ffcccc", borderRadius:12, padding:"14px", fontSize:14, fontWeight:700, cursor:"pointer", gridColumn:"1/-1" }}>
                        🚪 Sign Out
                      </button>
                    </div>
                  </div>

                  {/* Subscription benefits */}
                  <div style={{ background:"#fff", borderRadius:16, padding:"20px 24px", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
                    <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:14 }}>🎁 Your Premium Benefits</div>
                    {[
                      "✅ All daily predictions unlocked",
                      "✅ Full booking codes for all platforms",
                      "✅ NPFL, GPL, EPL, UCL & more leagues",
                      "✅ Expert match analysis",
                      "✅ Odds packages with confidence scores",
                      "✅ SportyBet exclusive codes",
                    ].map((b,i) => (
                      <div key={i} style={{ fontSize:14, color:"#333", padding:"8px 0", borderBottom:i<5?"1px solid #f5f5f5":"none" }}>{b}</div>
                    ))}
                  </div>
                </div>
              ) : (
                // Not subscribed
                <div style={{ textAlign:"center", padding:"48px 24px" }}>
                  <div style={{ fontSize:64, marginBottom:16 }}>👤</div>
                  <div style={{ fontFamily:"var(--head)", fontSize:32, color:"#111", marginBottom:8 }}>NO ACTIVE SUBSCRIPTION</div>
                  <div style={{ fontSize:15, color:"#666", marginBottom:32, maxWidth:400, margin:"0 auto 32px" }}>Subscribe to unlock all premium picks, booking codes and expert analysis</div>
                  <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
                    <button onClick={() => setShowModal(true)} style={{ background:"#f5a000", color:"#fff", border:"none", borderRadius:12, padding:"14px 32px", fontSize:16, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 14px rgba(245,160,0,0.4)" }}>
                      💰 Subscribe Now
                    </button>
                    <button onClick={() => setShowLoginModal(true)} style={{ background:"#fff", color:"#b00000", border:"2px solid #b00000", borderRadius:12, padding:"14px 32px", fontSize:16, fontWeight:800, cursor:"pointer" }}>
                      🔑 Already subscribed? Login
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
          {/* ── LEADERBOARD ── */}
          {tab === "testimonials" && (
            <div className="fade-up">
              <div style={{ textAlign:"center", marginBottom:32 }}>
                <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:8 }}>
                  ⭐ <span style={{ color:"#b00000" }}>SUCCESS</span> STORIES
                </div>
                <div style={{ fontSize:15, color:"#555f7a", maxWidth:500, margin:"0 auto" }}>What our subscribers are saying about BetGuru</div>
              </div>
              {/* Testimonials grid */}
              <div className="testimonials-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:16, marginBottom:32 }}>
                {(siteSettings.testimonials||[
                  { name:"Emeka O.", country:"🇳🇬", text:"BetGuru is the real deal! Won ₦45,000 in my first week. The booking codes are always accurate.", stars:5 },
                  { name:"Kwame A.", country:"🇬🇭", text:"I was skeptical at first but after 3 wins in a row I became a believer. Best prediction site in Ghana!", stars:5 },
                  { name:"Brian K.", country:"🇰🇪", text:"Finally a prediction site that delivers. 8 out of 10 predictions won this month. Highly recommended.", stars:5 },
                  { name:"Chidi N.", country:"🇳🇬", text:"The monthly plan is worth every naira. The analysis is deep and the accuracy is unmatched.", stars:5 },
                  { name:"Ama S.", country:"🇬🇭", text:"BetGuru helped me turn GH₵200 into GH₵1,800 in one weekend. I'm never leaving this site!", stars:5 },
                  { name:"David M.", country:"🇰🇪", text:"The 5 odds package is my favorite. Combined wins every week. Thank you BetGuru!", stars:5 },
                ]).map((t,i) => (
                  <div key={i} style={{ background:"#fff", borderRadius:16, padding:"20px", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
                    <div style={{ display:"flex", gap:2, marginBottom:10 }}>
                      {Array(t.stars||5).fill("⭐").map((s,j) => <span key={j} style={{ fontSize:14 }}>{s}</span>)}
                    </div>
                    <div style={{ fontSize:14, color:"#333", lineHeight:1.6, marginBottom:14, fontStyle:"italic" }}>"{t.text}"</div>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <div style={{ width:36, height:36, borderRadius:"50%", background:"#b00000", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800, fontSize:14 }}>{t.name[0]}</div>
                      <div>
                        <div style={{ fontWeight:700, fontSize:13, color:"#111" }}>{t.name}</div>
                        <div style={{ fontSize:12, color:"#888" }}>{t.country} Verified Subscriber</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {!isSubscribed && (
                <div style={{ background:"linear-gradient(135deg,#b00000,#c00000)", borderRadius:16, padding:"24px", textAlign:"center", color:"#fff" }}>
                  <div style={{ fontFamily:"var(--head)", fontSize:28, marginBottom:8 }}>JOIN THOUSANDS OF WINNERS</div>
                  <div style={{ fontSize:14, color:"rgba(255,255,255,0.9)", marginBottom:20 }}>Subscribe today and start winning</div>
                  <button onClick={() => setShowModal(true)} style={{ background:"#f5a000", color:"#fff", border:"2px solid #ffe066", borderRadius:12, padding:"14px 36px", fontSize:16, fontWeight:800, cursor:"pointer" }}>
                    💰 Subscribe Now →
                  </button>
                </div>
              )}
            </div>
          )}

          {/* TERMS & CONDITIONS */}
          {tab === "terms" && (
            <div className="fade-up" style={{ maxWidth:800, margin:"0 auto" }}>
              <div style={{ fontFamily:"var(--head)", fontSize:40, color:"#111", marginBottom:8 }}>TERMS & CONDITIONS</div>
              <div style={{ fontSize:12, color:"#888", marginBottom:24 }}>Last updated: March 2026</div>
              {[
                { title:"1. Acceptance of Terms", text:"By accessing and using BetGuru, you accept and agree to be bound by these terms. If you do not agree, please do not use our service." },
                { title:"2. Service Description", text:"BetGuru provides football predictions and betting tips for informational purposes only. We do not place bets on your behalf and are not responsible for any financial losses." },
                { title:"3. Age Restriction", text:"You must be 18 years or older to use BetGuru. By subscribing, you confirm that you are of legal age to participate in gambling activities in your country." },
                { title:"4. Subscription & Payments", text:"Subscriptions are processed via Paystack. All payments are final and non-refundable. Subscription access expires on the date shown in your account." },
                { title:"5. Disclaimer", text:"Football predictions are never 100% guaranteed. Past performance does not guarantee future results. Always gamble responsibly and within your means." },
                { title:"6. Referral Program", text:"Referral rewards are only credited for successful monthly or quarterly subscriptions. BetGuru reserves the right to modify or terminate the referral program at any time." },
                { title:"7. Account Termination", text:"We reserve the right to terminate accounts that violate these terms or engage in fraudulent activity." },
                { title:"8. Changes to Terms", text:"BetGuru may update these terms at any time. Continued use of the service constitutes acceptance of the updated terms." },
              ].map((s,i) => (
                <div key={i} style={{ marginBottom:20 }}>
                  <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:6 }}>{s.title}</div>
                  <div style={{ fontSize:14, color:"#555", lineHeight:1.7 }}>{s.text}</div>
                </div>
              ))}
            </div>
          )}

          {/* PRIVACY POLICY */}
          {tab === "privacy" && (
            <div className="fade-up" style={{ maxWidth:800, margin:"0 auto" }}>
              <div style={{ fontFamily:"var(--head)", fontSize:40, color:"#111", marginBottom:8 }}>PRIVACY POLICY</div>
              <div style={{ fontSize:12, color:"#888", marginBottom:24 }}>Last updated: March 2026</div>
              {[
                { title:"1. Information We Collect", text:"We collect your email address, phone number and country when you subscribe. We also collect usage data through Google Analytics and Facebook Pixel to improve our service." },
                { title:"2. How We Use Your Information", text:"Your information is used to manage your subscription, send prediction updates, and process referral rewards. We do not sell your personal data to third parties." },
                { title:"3. Payment Information", text:"All payments are processed by Paystack. BetGuru does not store your card details. Please review Paystack's privacy policy for payment data handling." },
                { title:"4. Cookies", text:"BetGuru uses cookies to remember your preferences and improve your experience. You can disable cookies in your browser settings, though this may affect functionality." },
                { title:"5. Data Security", text:"We implement industry-standard security measures to protect your data. All data is transmitted via HTTPS encryption." },
                { title:"6. Third Party Services", text:"We use Firebase (Google) for data storage, Paystack for payments, and Google Analytics/Facebook Pixel for analytics. Each has their own privacy policies." },
                { title:"7. Your Rights", text:"You may request deletion of your account and personal data by contacting us via WhatsApp or Telegram. We will process requests within 7 business days." },
                { title:"8. Contact", text:"For privacy concerns, contact us through our WhatsApp or Telegram channels listed on the website." },
              ].map((s,i) => (
                <div key={i} style={{ marginBottom:20 }}>
                  <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:6 }}>{s.title}</div>
                  <div style={{ fontSize:14, color:"#555", lineHeight:1.7 }}>{s.text}</div>
                </div>
              ))}
            </div>
          )}

          {tab === "leaderboard" && (
            <div className="fade-up">
              {/* Header */}
              <div style={{ textAlign:"center", marginBottom:24 }}>
                <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:8 }}>
                  🏆 <span style={{ color:"#b00000" }}>LEADER</span>BOARD
                </div>
                <div style={{ fontSize:15, color:"#555f7a", maxWidth:500, margin:"0 auto" }}>
                  Our top performing predictions — 100% transparent and verified
                </div>
              </div>

              {/* CTA — shown at TOP for non-subscribers */}
              {!isSubscribed && (
                <div style={{ background:"linear-gradient(135deg,#b00000,#c00000)", borderRadius:16, padding:"24px", textAlign:"center", color:"#fff", marginBottom:32 }}>
                  <div style={{ fontFamily:"var(--head)", fontSize:28, marginBottom:8 }}>JOIN THE WINNING SIDE</div>
                  <div style={{ fontSize:14, color:"rgba(255,255,255,0.9)", marginBottom:20 }}>Subscribe and get access to tomorrow's predictions before everyone else</div>
                  <button onClick={() => setShowModal(true)} style={{ background:"#f5a000", color:"#fff", border:"2px solid #ffe066", borderRadius:12, padding:"14px 36px", fontSize:16, fontWeight:800, cursor:"pointer" }}>
                    💰 Subscribe Now →
                  </button>
                </div>
              )}

              {/* Stats bar */}
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:16, marginBottom:32 }} className="grid-4">
                {[
                  { icon:"🎯", val:(siteSettings.accuracy||"92")+"%", label:"Accuracy Rate",   color:"#b00000" },
                  { icon:"✅", val:siteSettings.wonThisMonth||"110",  label:"Won This Month",  color:"#00a651" },
                  { icon:"❌", val:siteSettings.lostThisMonth||"10",  label:"Lost This Month", color:"#e53935" },
                  { icon:"🔥", val:resultsData.filter(r=>r.r==="WON").length + " / " + resultsData.length, label:"Recent Record", color:"#f5a000" },
                ].map((s,i) => (
                  <div key={i} style={{ background:"#fff", borderRadius:16, padding:"20px", textAlign:"center", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
                    <div style={{ fontSize:28, marginBottom:8 }}>{s.icon}</div>
                    <div style={{ fontFamily:"var(--head)", fontSize:36, color:s.color, lineHeight:1 }}>{s.val}</div>
                    <div style={{ fontSize:12, color:"#888", marginTop:6 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              {/* Top predictions table */}
              <div style={{ background:"#fff", borderRadius:16, overflow:"hidden", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:24 }}>
                <div style={{ background:"linear-gradient(135deg,#8b0000,#c00000)", padding:"16px 24px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div style={{ fontFamily:"var(--head)", fontSize:20, color:"#fff", letterSpacing:"1px" }}>🔥 RECENT RESULTS</div>
                  <div style={{ fontSize:12, color:"rgba(255,255,255,0.8)" }}>Last {resultsData.length} predictions</div>
                </div>
                {/* Table header */}
                <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr", gap:8, padding:"12px 24px", background:"#f8f9fc", borderBottom:"1px solid #e0e4ee" }}>
                  {["Match", "League", "Prediction", "Odds", "Result"].map((h,i) => (
                    <div key={i} style={{ fontSize:11, fontWeight:800, color:"#888", letterSpacing:"0.5px" }}>{h}</div>
                  ))}
                </div>
                {resultsData.map((r,i) => (
                  <div key={i} style={{ display:"grid", gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr", gap:8, padding:"14px 24px", borderBottom:i<resultsData.length-1?"1px solid #f0f0f0":"none", alignItems:"center" }}>
                    <div style={{ fontSize:14, fontWeight:700, color:"#111" }}>{r.m}</div>
                    <div style={{ fontSize:12, color:"#666", background:"#f5f5f5", borderRadius:6, padding:"3px 8px", display:"inline-block" }}>{r.l}</div>
                    <div style={{ fontSize:13, color:"#333" }}>{r.p}</div>
                    <div style={{ fontSize:13, fontWeight:700, color:"#f5a000" }}>{r.o}</div>
                    <div style={{ display:"inline-flex", alignItems:"center", gap:4, background:r.r==="WON"?"rgba(0,166,81,0.1)":"rgba(229,57,53,0.1)", border:`1px solid ${r.r==="WON"?"rgba(0,166,81,0.3)":"rgba(229,57,53,0.3)"}`, borderRadius:8, padding:"4px 10px", fontSize:12, fontWeight:800, color:r.r==="WON"?"#00a651":"#e53935" }}>
                      {r.r==="WON" ? "✅ WON" : "❌ LOST"}
                    </div>
                  </div>
                ))}
              </div>

              {/* Win streak */}
              <div style={{ background:"#fff", borderRadius:16, padding:"20px 24px", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:24 }}>
                <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:16 }}>🔥 Current Win Streak</div>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {resultsData.slice().reverse().map((r,i) => (
                    <div key={i} style={{ width:40, height:40, borderRadius:10, background:r.r==="WON"?"#00a651":"#e53935", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, color:"#fff", fontWeight:800, title:r.m }}>
                      {r.r==="WON" ? "✅" : "❌"}
                    </div>
                  ))}
                </div>
                <div style={{ fontSize:12, color:"#888", marginTop:12 }}>Each box = one prediction (most recent on left)</div>
              </div>

              {/* League breakdown */}
              <div style={{ background:"#fff", borderRadius:16, padding:"20px 24px", border:"1px solid #e0e4ee", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", marginBottom:32 }}>
                <div style={{ fontWeight:800, fontSize:15, color:"#111", marginBottom:16 }}>📊 Performance by League</div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12 }} className="grid-3">
                  {Object.entries(resultsData.reduce((acc,r) => {
                    if (!acc[r.l]) acc[r.l] = { won:0, total:0 };
                    acc[r.l].total++;
                    if (r.r==="WON") acc[r.l].won++;
                    return acc;
                  }, {})).map(([league, stats]) => (
                    <div key={league} style={{ background:"#f8f9fc", borderRadius:12, padding:"14px", textAlign:"center", border:"1px solid #e0e4ee" }}>
                      <div style={{ fontSize:13, fontWeight:800, color:"#111", marginBottom:6 }}>{league}</div>
                      <div style={{ fontFamily:"var(--head)", fontSize:28, color: stats.won/stats.total >= 0.8 ? "#00a651" : stats.won/stats.total >= 0.5 ? "#f5a000" : "#e53935" }}>
                        {Math.round((stats.won/stats.total)*100)}%
                      </div>
                      <div style={{ fontSize:11, color:"#888" }}>{stats.won}W / {stats.total-stats.won}L</div>
                    </div>
                  ))}
                </div>
              </div>


            </div>
          )}

          {/* ── REFERRAL PAGE ── */}
          {tab === "referral" && (
            <div className="fade-up">
              <div style={{ textAlign:"center", marginBottom:32 }}>
                <div style={{ fontFamily:"var(--head)", fontSize:52, letterSpacing:"2px", lineHeight:1, marginBottom:8 }}>
                  🔗 <span style={{ color:"#b00000" }}>REFER</span> & EARN
                </div>
                <div style={{ fontSize:15, color:"#555f7a", maxWidth:500, margin:"0 auto" }}>
                  Share BetGuru with friends and earn cash rewards for every successful subscription!
                </div>
              </div>

              {isSubscribed ? (
                <ReferralPage
                  currency={currency}
                  siteSettings={siteSettings}
                  firebaseUser={firebaseUser}
                  referrals={referrals.filter(r => r.code === localStorage.getItem("bg_refcode"))}
                  withdrawals={withdrawals.filter(w => w.code === localStorage.getItem("bg_refcode"))}
                  onWithdraw={(data) => setWithdrawals(prev => [...prev, { ...data, code: localStorage.getItem("bg_refcode"), status:"pending", date: new Date().toLocaleDateString("en-NG",{day:"numeric",month:"short",year:"numeric"}) }])}
                />
              ) : (
                <div style={{ textAlign:"center", padding:"48px 24px" }}>
                  <div style={{ fontSize:64, marginBottom:16 }}>🔒</div>
                  <div style={{ fontFamily:"var(--head)", fontSize:28, color:"#111", marginBottom:8 }}>SUBSCRIBE TO REFER</div>
                  <div style={{ fontSize:15, color:"#666", marginBottom:32 }}>You need an active subscription to get your referral link and start earning</div>
                  <button onClick={() => setShowModal(true)} style={{ background:"#f5a000", color:"#fff", border:"none", borderRadius:12, padding:"14px 32px", fontSize:16, fontWeight:800, cursor:"pointer" }}>
                    💰 Subscribe Now
                  </button>
                </div>
              )}
            </div>
          )}

        </main>

        {/* ── FLOATING SOCIAL BUTTONS (mobile only) ── */}
        <div className="social-float">
          {siteSettings.whatsapp && (
            <a href={siteSettings.whatsapp} target="_blank" rel="noreferrer"
              style={{ display:"flex", alignItems:"center", gap:6, background:"#25D366", color:"#fff", borderRadius:24, padding:"10px 14px", textDecoration:"none", boxShadow:"0 4px 12px rgba(0,0,0,0.25)", fontSize:12, fontWeight:800, whiteSpace:"nowrap" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </a>
          )}
          {siteSettings.telegram && (
            <a href={siteSettings.telegram} target="_blank" rel="noreferrer"
              style={{ display:"flex", alignItems:"center", gap:6, background:"#0088cc", color:"#fff", borderRadius:24, padding:"10px 14px", textDecoration:"none", boxShadow:"0 4px 12px rgba(0,0,0,0.25)", fontSize:12, fontWeight:800, whiteSpace:"nowrap" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
              Telegram
            </a>
          )}
          {siteSettings.twitter && (
            <a href={siteSettings.twitter} target="_blank" rel="noreferrer"
              style={{ display:"flex", alignItems:"center", gap:6, background:"#000", color:"#fff", borderRadius:24, padding:"10px 14px", textDecoration:"none", boxShadow:"0 4px 12px rgba(0,0,0,0.25)", fontSize:12, fontWeight:800, whiteSpace:"nowrap" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.636 5.905-5.636zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              Twitter/X
            </a>
          )}
        </div>

        {/* ── MOBILE BOTTOM NAV ── */}
        <nav className="mobile-nav">
          <div className="mobile-nav-inner">
            {/* 5 main tabs */}
            {[
              { id:"today",       icon:"⚽", label:"Picks" },
              { id:"odds",        icon:"💰", label:"Odds" },
              { id:"sporty",      icon:"🎯", label:"Sporty" },
              { id:"results",     icon:"📊", label:"Results" },
              { id:"leaderboard", icon:"🏆", label:"Board" },
            ].map(n => (
              <button key={n.id} className={`mobile-nav-btn${tab===n.id?" active":""}`}
                onClick={() => { setTab(n.id); if(n.id==="today") setTimeout(()=>document.getElementById("free-picks-anchor")?.scrollIntoView({behavior:"smooth"}),100); }}>
                <span className="mobile-nav-icon">{n.icon}</span>
                <span className="mobile-nav-label">{n.label}</span>
              </button>
            ))}
            {/* More button */}
            <button className={`mobile-nav-btn${["how","profile","referral","testimonials","terms","privacy"].includes(tab)?" active":""}`}
              onClick={(e) => { e.stopPropagation(); setShowMobileMore(prev=>!prev); }}>
              <span className="mobile-nav-icon">☰</span>
              <span className="mobile-nav-label">More</span>
            </button>
          </div>

          {/* Mobile More Menu — slides up */}
          {showMobileMore && (
            <div style={{ position:"fixed", bottom:60, left:0, right:0, background:"#ffffff", borderTop:"2px solid #b00000", borderRadius:"16px 16px 0 0", boxShadow:"0 -8px 32px rgba(0,0,0,0.15)", zIndex:300, padding:"8px 0" }}
              onClick={(e) => e.stopPropagation()}>
              <div style={{ width:40, height:4, background:"#e0e0e0", borderRadius:4, margin:"8px auto 12px" }} />
              {[
                { id:"how",          icon:"❓", label:"How It Works" },
                { id:"testimonials", icon:"⭐", label:"Reviews & Testimonials" },
                { id:"profile",      icon:"👤", label: isSubscribed ? "My Account" : "Profile" },
                ...(siteSettings.referralActive !== false ? [{ id:"referral", icon:"🔗", label:"Refer & Earn" }] : []),
                ...(!isSubscribed ? [{ id:"login", icon:"🔑", label:"Login", action: () => { setShowLoginModal(true); setShowMobileMore(false); } }] : []),
                { id:"admin",        icon:"🔐", label:"Admin Login", action: () => { setShowAdminLogin(true); setShowMobileMore(false); } },
              ].map(n => (
                <button key={n.id}
                  onClick={() => { if(n.action) { n.action(); } else { setTab(n.id); setShowMobileMore(false); } }}
                  style={{ width:"100%", display:"flex", alignItems:"center", gap:14, padding:"14px 24px", background:tab===n.id?"#fff0f0":"#fff", border:"none", borderBottom:"1px solid #f5f5f5", color:tab===n.id?"#b00000":"#111", fontSize:15, fontWeight:600, cursor:"pointer", textAlign:"left" }}>
                  <span style={{ fontSize:22 }}>{n.icon}</span>
                  <span>{n.label}</span>
                  {tab===n.id && <span style={{ marginLeft:"auto", color:"#b00000" }}>●</span>}
                </button>
              ))}

            </div>
          )}
        </nav>

        <footer style={{ borderTop:"1px solid #a00000", background:"#8b0000", padding:"32px 40px" }} className="px-page">
          <div style={{ maxWidth:1200, margin:"0 auto" }}>

            {/* Social links — prominent section */}
            {(siteSettings.whatsapp || siteSettings.telegram || siteSettings.twitter) && (
              <div style={{ textAlign:"center", marginBottom:24, paddingBottom:24, borderBottom:"1px solid rgba(255,255,255,0.15)" }}>
                <div style={{ fontSize:13, color:"rgba(255,255,255,0.7)", marginBottom:14, letterSpacing:"1px", fontWeight:700 }}>JOIN OUR COMMUNITY</div>
                <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
                  {siteSettings.whatsapp && (
                    <a href={siteSettings.whatsapp} target="_blank" rel="noreferrer"
                      style={{ display:"flex", alignItems:"center", gap:8, background:"#25D366", color:"#fff", borderRadius:12, padding:"12px 20px", fontSize:14, fontWeight:700, textDecoration:"none", boxShadow:"0 4px 12px rgba(0,0,0,0.2)" }}>
                      <span style={{ fontSize:20 }}>📱</span> Join WhatsApp
                    </a>
                  )}
                  {siteSettings.telegram && (
                    <a href={siteSettings.telegram} target="_blank" rel="noreferrer"
                      style={{ display:"flex", alignItems:"center", gap:8, background:"#0088cc", color:"#fff", borderRadius:12, padding:"12px 20px", fontSize:14, fontWeight:700, textDecoration:"none", boxShadow:"0 4px 12px rgba(0,0,0,0.2)" }}>
                      <span style={{ fontSize:20 }}>✈️</span> Join Telegram
                    </a>
                  )}
                  {siteSettings.twitter && (
                    <a href={siteSettings.twitter} target="_blank" rel="noreferrer"
                      style={{ display:"flex", alignItems:"center", gap:8, background:"#000000", color:"#fff", borderRadius:12, padding:"12px 20px", fontSize:14, fontWeight:700, textDecoration:"none", boxShadow:"0 4px 12px rgba(0,0,0,0.2)" }}>
                      <span style={{ fontSize:20 }}>🐦</span> Follow on X
                    </a>
                  )}
                </div>
              </div>
            )}

            {/* Footer bottom */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:16 }}>
              <div style={{ fontFamily:"var(--head)", fontSize:20, letterSpacing:"2px", color:"#ffffff" }}>BET<span style={{ color:"#ffe066" }}>GURU</span></div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", textAlign:"center" }}>⚠️ 18+ only. Gambling involves risk. BetGuru does not place bets on your behalf. Bet responsibly.</div>
              <div style={{ display:"flex", gap:16, alignItems:"center", flexWrap:"wrap" }}>
                <button onClick={()=>setTab("terms")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:11,cursor:"pointer",textDecoration:"underline"}}>Terms & Conditions</button>
                <button onClick={()=>setTab("privacy")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:11,cursor:"pointer",textDecoration:"underline"}}>Privacy Policy</button>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>© 2026 BetGuru</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
